import { ElementRef, Component, OnInit, Input, ViewChild, Renderer2, ViewEncapsulation, AfterViewChecked } from '@angular/core';
import { Cartesian3, Color } from 'cesium';
import * as Cesium from 'cesium';
import { ApiService } from 'src/app/services/api.service';
import { UserService } from 'src/app/services/user.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { OpenconfirmwarningComponent } from './openconfirmwarning/openconfirmwarning.component';
import { environment } from 'src/environments/environment';
import { map, Observable, startWith, interval, Subscription, firstValueFrom } from 'rxjs';
import { OPERATORS, RF_RADIUS, TIP_CUE_WORKFLOW, USER, MIN_RF_COLLECTION, MAX_RF_COLLECTION, PIXXEL_RADIUS } from 'src/app/services/constants';
import { HttpClient } from '@angular/common/http';
import { MatRadioChange } from '@angular/material/radio';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';
import { AuthService } from 'src/app/services/auth.service';
import { CountrycheckComponent } from '../taskcost/countrycheck/countrycheck.component';
import { ConfirmDialog } from '../taskcost/confirmdialog';
import { ThemeService } from 'src/app/services/theme.service';
import { DatePipe } from '@angular/common';
import { UtilsService } from 'src/app/services/utils.service';
import { PopupService } from 'src/app/services/popup.service';
import { BudgetpopupComponent } from './budgetpopup/budgetpopup.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { NgxMaterialTimepickerComponent } from 'ngx-material-timepicker';
import { OperatorPopupComponent } from '../taskcost/operator-popup/operator-popup.component';
import { TaskcostComponent } from '../taskcost/taskcost.component';
import { FilterPopupComponent } from '../collections/filter-popup/filter-popup.component';
import { NgxSpinnerService } from 'ngx-spinner';
import {ChangeDetectorRef } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatSelect } from '@angular/material/select';
import { SharedDataService } from '../shared/shared-data-service';
import { CollectionPopupComponent, ConfirmPopupComponent, WarningPopup } from '../shared';

const cesiumContainerNew = document.createElement('div');
cesiumContainerNew.id = 'cesiumGlobeContainerNew';
document.getElementsByTagName('body')[0].appendChild(cesiumContainerNew);
var turf = require('@turf/turf');
var geoParse = require('wellknown');

export interface ProjectModel {
  project: string;
  _id: number;
  customerid: any,
}

@Component({
  selector: 'app-newtask',
  templateUrl: './newtask.component.html',
  styleUrls: ['./newtask.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})

export class NewtaskComponent implements OnInit, AfterViewChecked {
  @Input() target: any = { geoJSON: '', area: 0 };
  @Input() accept = '.topojson, .geojson, .kml';
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('llInput') llInput: ElementRef;
  @ViewChild('cloudPanel') cloudPanel: MatExpansionPanel;
  @ViewChild('timepicker', { static: true }) timepicker: NgxMaterialTimepickerComponent;
  @ViewChild('sensorPanel') sensorPanel!: MatExpansionPanel;
  @ViewChild('sensorList') sensorList!: TaskcostComponent;
  @ViewChild('tqSensorList') tqSensorList!: TaskcostComponent;
  @ViewChild('signalSelect') signalSelect: MatSelect;
  private originalClose: (() => void) | null = null;
  isBroRFSelected: boolean;
  drawingMode = '';
  mapSnap: any;
  defaultLL: any[] = [82.9739, 25.3176];
  roll: any = 0;
  jumpLocation: any;
  locationInvalid = true;
  keyIn = false;
  dateFlag = false;
  tleRangeError = false;
  tleStartRangeError = false;
  tleToiError = false;
  isFirst = true;
  accuracy = 15;
  jsonData = '';
  fileAttr = 'Choose File';
  acceptFile = '.topojson, .geojson, .kml';
  MYENTITY;
  drawingOn = false; // AT21 = false; satllogic = false;
  viewer: any;
  scene: any = null;
  longLatStr: string = '';
  latlonOverlay = document.createElement('div');
  satEntity;
  datafile: any;
  imgUrls: any;
  dataForm: FormGroup | any;
  options: any;
  compassOverlay: any;
  currentUser: any;
  projName: any;
  taskName: any;
  taskTarget: any;
  frequency: any;
  taskArea: 0;
  mapLoading:boolean = false;
  formGroup: any = FormGroup;
 tleSensor: {
  resolution: { key: string; name: string }[];
  sensor: { sensorName: string; obfuscateName: string; sensorId:string }[];
} = {
  resolution: [],
  sensor: []
};
  tleSensorForm: any = FormGroup;
  showtleClick:boolean = false;
  showtleDisabled:boolean = false;
  taskparams: any;
  date: any;
  proceed = false;
  frequencyOption = [
    { id: 0, name: 'Specific Date', selected: true },
    { id: 1, name: 'Recurrent', selected: false },
    { id: 2, name: 'Period', selected: false },
  ];
  selectedOption = 0;
  freqOption = 'Daily';
  showResults = false;
  DateFilter: any;
  DateRange = 30;
  monthRange = 13;
  minDate: Date | null;
  maxDate: Date | null;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  defaultWindow = 30; //30 days
  sensors: any = this.apiService.selectSensors;
  TASKFREQUENCY: any;
  purposeOption: any;
  intentOption: any;
  useCaseOption: any;
  strategyOptions: any
  selectedSensorTypes: any;
  allComplete: boolean = false;
  state: any;
  showSensors = false;
  tasking: FormGroup;
  panelOpenState = true;
  isExpanded = true;
  taskid: any;
  coordinates: string;
  ph: string;
  title = 'Confirmation';
  cancelBtn = 'Cancel Task';
  btnParams = 'CANCEL';
  successMsg: any;
  taskMap: any;
  chkNum = 0;
  dailyCount: any;
  todayDate: Date;
  clickFrequency: boolean = false;
  others: boolean = false;
  description: any;
  purposeTask: any;
  projectData: ProjectModel[] = [];
  filteredProjects: Observable<ProjectModel[]>;
  buttonDisable: boolean = false;
  callCounter: any = 0;
  geocoder: Cesium.Geocoder;
  satellites: any[] = [];
  satelliteEntity: any;
  entityValues: any;
  cesiumToken: any;
  orbitalPath: any;
  randomColor: string;
  subDaily: boolean = false;
  taskStrategy: any| '';
  tipAndCueBasedOn: string;
  observationSection: boolean = false;
  observationOptions: any;
  rulesOptions: any;
  observations: any;
  ruleBased: any;
  parentVal: any;
  observation: any;
  rule: any;
  observationData: any;
  pointArray: any[] = [];
  pointEntities: any[] = [];
  isDrawingEnabled: boolean = false;
  retask: boolean;
  selectedTasks: any;
  polygons: number[][][] = [];
  weatherData: any = [];
  cloudclicked: boolean;
  outComeForm: any = FormGroup;
  SensorsTypes:any = [];
  demoView: boolean = false;
  outComesensor: any;
  outComeError: boolean = true;
  expectedAge: any;
  filteredSensorTypes: any[];
  allocatedSensorTypes: Set<string> = new Set();
  outComeSubmit: boolean = false;
  darkTheme: boolean;
  tooltipImagePath: string;
  isInIframe: boolean;
  isChecked: boolean = false;
  hourly: boolean = true;
  timeError: number;
  isPast: boolean = false;
  isEndPast: boolean = false;
  measurmentTooltipEntities: any[] = [];
  measurmentEntities: any[] = [];
  entityId = '';
  drawStarted = false;
  drawCompleted = false;
  isSearched = false;
  pinDisable: boolean = false;
  handler: any;
  restrictedUser: boolean = false;
  shapeSelected: boolean = false;
  budget: boolean;
  selectedSensorObfuscatedName:any;
  budgetForm:  any = FormGroup;
  budgetInputs: any={resolutionArr:[],cloudCoverKeys:[],holdbackArr:[],tierArr:[],rfSignals:[], rawIQData: false};     
  cloudCoverOptions: string[] = []; 
  resolutionOptions: string[] = [];
  taskingTierOptions: string[] = [];
  rfSignalOptions: any[] = [];
  rfCollectionOptions: any[] = [];
  holdBackOptions: string[] = [];     
  budgetSensorType:any;                                              
  selectedFrequencyID:number;
  currentLocalTime: string;
  private timeSubscription: Subscription;
  private satelliteDataSubscription: Subscription | null = null;
  taskPoint: number = 0;
  userDetails: any;
  totalTaskNumber: number = 0;
  subStrategyOptions: any[] = [
    { 
      name: "Tip and cue with user-picked sensors", 
      value: "Tip-and-Cue",
      description : "Users configure two sensor types in sequenced tasking and make the required sensor choices. " 
    },
    { 
      name: "Tip and cue automated", 
      value: "Tip-and-Cue-Outcome",
      description : "Users configure two sensor types in sequenced tasking, and the platform chooses the sensors. " 
    }
  ];
  subStrategy:any;
  sensorTypesTipnCue:any[] = [
    {
      name: "MSI",
      value: "MSI",
    },
    {
      name: "SAR",
      value: "SAR",
    },
    {
      name: "AIS",
      value: "AIS",
    }
  ];

  updateFrequencies: any[] = [...(this.apiService.updateFrequencies || [])];
  private allocatedAisOperators: Set<string> = new Set();
  private aisAllocationFetched: boolean = false;
  outcomePopUpData:any = {};
  invalidForm: boolean = true;
  cueingSensorResolution: any;
  tippingSensorResolution: any;
  cueingSensorCloudCover: any;
  tippingSensorCloudCover: any;
  feeds: any;
  feedList: any;
  userTimezone: string;
  userid: any;
  updatedIntentOption = false;
  duplicateDetected:boolean = false;
  isCoordinate:string = 'coordinate';
  isPlace:string = 'place';
  inputStatus:any = 'invalid';
  showResolution:boolean = true;
  sensorCategory:any;
  imagingSensor = 'imagingSensor';
  nonImagingSensor = 'nonImagingSensor';
  selectedCategory: string;
  tleSubmit:boolean = false;
  tipCueWorkflow = TIP_CUE_WORKFLOW;
  subUser = USER;
  updateFrequencyOption:boolean = false;
  signalOfInterest:boolean = false;
  rfSelectedSignals: any[] = [];
  audioSelections: any[] = [];
  controlOrder = [
    'target',
    'intent',
    'frequency',
    'date',
    'sensorType',
    'updateFrequency',
    'rfSignals',
    'rawIQData',
    'taskingTier',
    'start',
    'end',
    'endTime',
    'startTime'
  ];
  selectedSignals: any = [];
  selectedDisplay: any = '';
  aisType = 'AIS';
  rfType = 'RF';
  prevValue: any;
  minRFCollection: number = MIN_RF_COLLECTION;
  maxRFCollection: number = MAX_RF_COLLECTION;
  RFCollections: number[] = [];
  
  // Tip-and-Cue eligibility for allocated users
  tipAndCueEligible: boolean = false;
  tipAndCueEligibilityChecked: boolean = false;
  hasTippingSensors: boolean = false;
  hasCueingSensors: boolean = false;

  // Sensor category eligibility for budget mode
  hasImagingSensors: boolean = false;
  hasNonImagingSensors: boolean = false;
  sensorCategoryCheckLoading: boolean = false;
  constructor(private el: ElementRef, private apiService: ApiService, private userService: UserService,
    public dialog: MatDialog, private http: HttpClient, private route: ActivatedRoute, private dataService: DataService,
    private renderer: Renderer2,
    private themeService: ThemeService,
    private authService: AuthService,
    private datePipe: DatePipe,
    private utilsService: UtilsService,
    private spinnerService: NgxSpinnerService,
    private popupService: PopupService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private sharedDataService: SharedDataService
    ) {
      this.isInIframe = this.themeService.isInIframe();

    this.dataService.darkTheme.subscribe((newValue) => {
      this.darkTheme = newValue;

      this.tooltipImagePath = this.darkTheme ? '../../../assets/images/union-dark.svg' : '../../../assets/images/union.svg';
    });

    if (environment.demoView === 'true') {
      this.demoView = true;
    }
    else {
      this.demoView = false;
    }
    this.sensorCategory = this.imagingSensor;
    this.retask = false;
    this.budget = false;
    if (this.route.snapshot.url.join('/').includes('retask')) {
      this.retask = true;
      const data = localStorage.getItem('rowData');
      if (data != null) {
        this.selectedTasks = JSON.parse(data);
      }
    } else {
      this.retask = false;
    }
      this.target['isRetask']= this.retask;
      if (this.route.snapshot.url.join('/').includes('newbudget')) {
        this.budget = true;
      } else {
        this.budget = false;
      }

    if (!this.ph) {
      this.ph = 'init';
    }
    this.cesiumToken = environment.cesiumAccessToken;
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });

    this.formGroup = new FormGroup({
      project: new FormControl(this.projName, [
        Validators.required,
        Validators.minLength(4),
        Validators.maxLength(25),
      ]),
      taskname: new FormControl(this.taskName, [
        Validators.required,
        Validators.minLength(5)
      ]),
      strategyRadio: new FormControl('', [Validators.required]),
      tipAndCueBasedOn: new FormControl(this.tipAndCueBasedOn),
      description: new FormControl(this.description, [Validators.maxLength(50),]),
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      feeds: new FormControl(this.feeds),
      observation: new FormControl(this.observation),
      rule: new FormControl(this.rule),
      observationData: new FormControl(this.observationData),
      purpose: new FormControl(this.purposeTask, [Validators.required]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      jumplocation: new FormControl(this.jumpLocation),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      projectId: new FormControl(''),
      intent: new FormControl('', [Validators.required]),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      subStrategyRadio: new FormControl(null),
      useCase: new FormControl(''),
      useCaseDescription: new FormControl('', [Validators.maxLength(50),]),
    });

    this.updateFormControls(this.taskStrategy);
    // Add the subscription to strategyRadio changes
    this.formGroup.get('strategyRadio').valueChanges.subscribe(strategy => {
      if (strategy === 'Tip-and-Cue') {
        // Set Validators for subStrategyRadio if the strategy is 'Tip-and-Cue'
        this.formGroup.get('subStrategyRadio').setValidators([Validators.required]);
      } else {
        // Clear Validators if the strategy is anything else
        this.formGroup.get('subStrategyRadio').clearValidators();
      }

      // Update the validity after changing validators
      this.formGroup.get('subStrategyRadio').updateValueAndValidity();
    });

    this.formGroup.get('strategyRadio')?.valueChanges.subscribe((strategy) => {
      const intentControl = this.formGroup.get('intent');
      if (strategy === 'Outcome By Platform') {
        intentControl.clearValidators();
        intentControl.updateValueAndValidity();
      }
      this.updateFormControls(strategy);
    });

    this.authService.user.subscribe(user => this.currentUser = user);
    this.userid = this.currentUser.id;
    this.loadUserDetails(this.userid);
    this.outComeForm = new FormGroup({
      tipAndCueBasedOn: new FormControl('Observation'),
      sensorType: new FormControl(),
      resolution: new FormControl(),
      intent: new FormControl(),
      cloudCover: new FormControl(),
      latency: new FormControl('', [Validators.required, Validators.min(24), Validators.pattern(/^[0-9]\d*$/)]),
      budget: new FormControl('', [Validators.required, Validators.min(this.currentUser?.pointsEligible ? this.convertToPoints(150) : 150), Validators.pattern(/^[0-9]\d*(\.\d+)?$/)]),
      tippingSensorType: new FormControl(),
      cueingSensorType: new FormControl(),
      observation: new FormControl(),
      rule: new FormControl(),
      observationData: new FormControl(),
      tippingSensorResolution: new FormControl(),
      cueingSensorResolution: new FormControl(),
      updateFrequency: new FormControl(),
      tippingCloudCover: new FormControl(),
      cueingCloudCover: new FormControl(),
    });

    this.budgetForm = new FormGroup({
      target: new FormControl({ value: null, disabled: true }, [
        Validators.required,
      ]),
      frequency: new FormControl(this.frequency, [Validators.required]),
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
      startTime: new FormControl('', [Validators.required]),
      endTime: new FormControl('', [Validators.required]),
      resolution: new FormControl(''),
      taskingTier: new FormControl(''),
      cloudCover: new FormControl(''),
      holdBack: new FormControl(''),
      sensorType: new FormControl('',[Validators.required]),
      intent: new FormControl('',[Validators.required]),
      sensorCategory: new FormControl(this.sensorCategory),
      updateFrequency: new FormControl(),
      rfSignals: new FormControl([]),
      rawIQData: new FormControl(false),
    });
    this.selectedCategory = this.budgetForm.get('sensorCategory')?.value;
    this.tleSensorForm = new FormGroup({
      sensorType: new FormControl('',[Validators.required]),
      resolution: new FormControl('',[Validators.required]),
      sensor: new FormControl('',[Validators.required]),
    });

    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldEmpty()) {
        this.outComeError = true;
      } else {
        this.outComeError = false;
      }
    });

    this.outComeForm.valueChanges.subscribe(() => {
      if (this.isAnyFieldNull()) {
        this.invalidForm = true;
      } else {
        this.invalidForm = false;
      }
    });

    this.getProjects();
    this.filteredProjects = this.formGroup.get('project').valueChanges
      .pipe(startWith(null), map((data: string) => data ? this._filter(data) : this.projectData.slice())
      );

      this.setUTCTodayDate();
  }

  getProjects() {
    this.apiService.getProjects().subscribe((res: any) => {
      this.projectData = res.result;
    });
  }

  private _filter(value: string): ProjectModel[] {
    const filterValue = value.toString().toLocaleLowerCase();
    return this.projectData.filter((data) => data.project?.toLocaleLowerCase().indexOf(filterValue) === 0);
  }

  setProjectid(value) {
    this.formGroup.controls.projectId.setValue(value._id);
    this.target.projectId = value._id;
    this.projName = value.project;
    this.updateTarget(this.target, '0');
  }

  updateFormControls(taskStrategy: string): void {
    const useCaseControl = this.formGroup.get('useCase');
    if (taskStrategy === 'Help Select Sensor(s)') {
      useCaseControl?.setValidators(Validators.required);
    } else {
      useCaseControl?.clearValidators();
    }
    useCaseControl?.updateValueAndValidity();
  }

  ngOnInit(): void {
    const cesiumContainerNew = document.createElement('div');

    cesiumContainerNew.id = 'cesiumGlobeContainerNew';
    document.getElementsByTagName('body')[0].appendChild(cesiumContainerNew);
    this.TASKFREQUENCY = this.apiService.TASKFREQUENCY;

    this.apiService.getPurpose().subscribe((res: any) => {
      this.purposeOption = this.utilsService.sortPurposeOptions(res?.purposeList);
    });
    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });

    // this.intentOption = this.apiService.intentOption;
    this.apiService.intentOption().subscribe((response: any) => {
      this.intentOption = response;
    });
    const planTaskFeatureKeys = this.currentUser?.planDetails?.features.map(f => f.key) || [];
    this.strategyOptions = this.apiService.strategyOptions.filter(option =>
     planTaskFeatureKeys.includes(option.taskStrategyFeature));
    
    this.dailyCount = this.apiService.dailyCount;
    var west = 40.0;
    var south = -20.0;
    var east = 120.0;
    var north = 70.0;
    var _this = this;

    var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
    Cesium.Ion.defaultAccessToken = this.cesiumToken;
    Cesium.Camera.DEFAULT_VIEW_FACTOR = 0;
    Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;

    const imageryViewModels: any = [];
    const terrainViewModels: any = [];

    //Bing Maps Aerial
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Aerial',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingAerial.png'
        ),
        tooltip: 'Bing Maps Aerial',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 2 });
        },
      })
    );

    //Sentinel data
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Sentinel-2',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/sentinel-2.png'
        ),
        tooltip: 'Sentinel-2 cloudless',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3954 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Bing Maps Road',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/bingRoads.png'
        ),
        tooltip: 'Bing Maps Road',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 4 });
        },
      })
    );
    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'Blue Marble',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/blueMarble.png'
        ),
        tooltip: 'Blue Marble Next Generation July, 2004 imagery from NASA.',
        creationFunction: function () {
          return new Cesium.IonImageryProvider({ assetId: 3845 });
        },
      })
    );

    imageryViewModels.push(
      new Cesium.ProviderViewModel({
        name: 'OpenStreetMap',
        iconUrl: Cesium.buildModuleUrl(
          'Widgets/Images/ImageryProviders/openStreetMap.png'
        ),
        tooltip: 'Open Street Map.',
        creationFunction: function () {
          return new Cesium.OpenStreetMapImageryProvider({
            url: 'https://a.tile.openstreetmap.org/',
          });
        },
      })
    );
    const worldTerrain = Cesium.createWorldTerrain({ requestWaterMask: false });

    terrainViewModels.push(worldTerrain);
    var credit = new Cesium.Credit(
      "<a style='padding-left: 3px' class='credit' target='_blank' href='https://tasking.eartheye.space'><img width='120px' src='assets/images/white-logo.png' alt='EarthEye'></a>"
    );



    const viewer = new Cesium.Viewer('cesiumGlobeContainerNew', {
      imageryProviderViewModels: imageryViewModels,
      terrainProviderViewModels: [],
      // imageryProvider: baseLayer,
      // terrainExaggeration: 2.0,
      // terrainProvider: worldTerrain,
      baseLayerPicker: true,
      geocoder: true,
      homeButton: true,
      // navigationHelpButton: false,
      fullscreenButton: true,
      selectionIndicator: true,
      shouldAnimate: true,
      animation: false,
      timeline: false,
      sceneMode: Cesium.SceneMode.SCENE2D,
      sceneModePicker: true
    });

    this.viewer = viewer
    if (!this.isInIframe) {
      this.viewer.scene.frameState.creditDisplay.addDefaultCredit(credit);
    }
    this.showLatLon();

    var target: any = this.target;
    this.viewer.dataSources.dataSourceAdded.addEventListener(function (
      collection,
      dataSource
    ) {
      var entities = dataSource.entities.values;
      for (var i = 0; i < entities.length; i++) {
        var entity = entities[i];
        if (entity.polygon) {
          // material : Cesium.Color.YELLOW.withAlpha(0.5),
          // entity.polygon.color = Cesium.Color.RED;
          entity.polygon.material = Cesium.Color.BLUE.withAlpha(0.5);
          createAOI(entity.polygon.hierarchy.valueOf().positions);
        }
      }
      function createAOI(cartesianPts) {
        const accuracy = 15;
        let aoiWkt = 'POLYGON ((';
        let polyPts: any = [];
        let lat, lng;

        for (let i = 0; i < cartesianPts.length; i++) {
          let cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[i]);
          lng = Cesium.Math.toDegrees(cartoPoint.longitude);
          lat = Cesium.Math.toDegrees(cartoPoint.latitude);
          aoiWkt = aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}`;
          if (i < cartesianPts.length - 1) aoiWkt = aoiWkt + ', ';
          polyPts.push([lng, lat]);
        }

        aoiWkt = `${aoiWkt}))`;
        var polygon = turf.polygon([polyPts]);
        var aoiArea = (turf.area(polygon) / 1000000).toFixed(2); //in Sq km
        target.geoJSON = aoiWkt;
        // target.area = aoiArea;
        const aoi = { task: 'newtask', area: aoiArea, wkt: aoiWkt };
        getCountryAndPlace(lat, lng);
      }

      function getCountryAndPlace(latitude: number, longitude: number) {
        const apiKey = environment.openCageApiKey;
        const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
        let place: any, country: any, countryCode: any;
        let location = {
          longitude : longitude,
          latitude : latitude
        }

        _this.apiService.checkIsWater(location).subscribe((res: any) => {
        target.openWater = res?.water;
        if (_this.taskStrategy=='Tip-and-Cue' && _this.subStrategy == 'Tip-and-Cue') _this.getObservationList(target.openWater);
        fetch(url)
          .then(response => {
            if (!response.ok) {
              throw new Error('Request failed');
            }
            return response.json();
          })
          .then(data => {
            if (data.results.length > 0) {
              const firstResult = data.results[0];
              if (firstResult.components?.body_of_water) {
                country = firstResult.components.body_of_water;
                place = firstResult.components.body_of_water;
                countryCode = firstResult.components.body_of_water;
                target.overOpenWater = true;
             } else {
                country = firstResult.components.country;
                place = firstResult.components.city || firstResult.components.state || firstResult.components.county;
                countryCode = firstResult.components["ISO_3166-1_alpha-3"];
                target.overOpenWater = false;
             }
              target.place = place;
              target.country = country;
              target.countryCode = countryCode
              _this.updateTarget(target, '0');
            }
          })
          .catch(error => { });
        });
      }
    });



    this.scene = this.viewer.scene;
    this.scene = this.viewer.scene;
    if (!this.scene.pickPositionSupported) {
      window.alert('This browser does not support pickPosition.');
    }
    this.plotTarget();

    // Show point when type lat and long
    this.geocoder = this.viewer.geocoder;

    this.destinationCall();

    let popupShown = false;
    this.geocoder.viewModel.search.beforeExecute.addEventListener((command) => {
      let input = this.geocoder.viewModel.searchText.trim();
      if (input.endsWith(';')) {
        input = input.slice(0, -1).trim();
      }
      command.cancel = true;

      if (!popupShown && input.length > 0) {
        popupShown = true;
        this.inputStatus = this.isValidInput(input)
        if (this.inputStatus !== 'invalid') {
          this.parsePolygonAOI(input, command, this.inputStatus);
        } else {
          //command.cancel = true;
          this.resetMap();
          this.popupService.openPopup(
            WarningPopup,
            "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'",
            '',
            '50%'
          );
        }

        // Reset the flag to allow future popups
        setTimeout(() => {
          popupShown = false;
        }, 1000);
      }
      this.inputStatus = 'invalid';
    });

    if (this.retask) {
      this.selectRecord(this.selectedTasks);
    }

    if (_this.currentUser?.isTaskableAoi && !this.retask) {
      this.restrictedUser = true;
      for (const file of _this.currentUser?.taskableAoi) {
      let targetData = file?.taskableAoi;
      let type: any, coordinates: any;
      type = targetData?.type.toUpperCase();
      coordinates = targetData.coordinates;
      if (type === 'POLYGON') {
        this.drawTaskableAOI(coordinates);
      }
    }

    } else this.restrictedUser = false;
 
    function zoomToEntities() {
      var entities = viewer.entities;
      var dataSourceCollection = viewer.dataSources;

      // Get an array of entities
      var entityArray = entities.values;

      for (var i = 0; i < entityArray.length; i++) {
        var entity = entityArray[i];
        viewer.flyTo(entity);
      }

      // Loop through data sources
      for (var i = 0; i < dataSourceCollection.length; i++) {
        var dataSource = dataSourceCollection.get(i);
        if (dataSource.entities && dataSource.entities.values.length > 0) {
          viewer.flyTo(dataSource, { duration: 3 });
          viewer.scene.globe.depthTestAgainstTerrain = false;
        }
      }
    }

    // viewer.scene.morphStart.addEventListener(function () {
    //   zoomToEntities();
    // });

   // function getPlo
    function zoomToLocation() {
      var entities = viewer.entities;
      var entityArray = entities.values;
      var myEntity = entityArray[0];
      var dataSourceCollection = viewer.dataSources;
      var dataSource = dataSourceCollection.get(0);

      if (myEntity) {
        var entities = viewer.entities;
        var entityArray = entities.values;
        var myEntity = entityArray[0];

        for (var i = 0; i < entityArray.length; i++) {
          var entity = entityArray[i];
          if (entity.name != 'orbit') {
            viewer.flyTo(entity);
          } else {
            if (dataSource) {
              viewer.flyTo(dataSource);
            }
          }
        }
      } else {
        if (dataSource) {
          viewer.flyTo(dataSource);
        }
      }
    }

    const homeButton = this.el.nativeElement.querySelector('.cesium-home-button');

    if (homeButton) {
      this.renderer.listen(homeButton, 'click', function () {
        zoomToLocation();
      });
    }

    this.timeSubscription = interval(30000).subscribe(() => {
      this.updateCurrentLocalTime();
    });

    this.sharedDataService.getData().subscribe(data => {
    if (data) {
      this.userDetails = data;
    }
  });
  }

  ngAfterViewChecked(): void {
    if(this.taskStrategy === "TLE Based Tasking"){
      this.tleSubmit = this.shouldEnableCancelButton(this.target, this.tleSensorForm);
    }  
  }

  ngDoCheck() {
    if (this.selectedCategory === this.nonImagingSensor && ((this.target.geoJSON != null && this.target?.geoJSON !== this.prevValue ) || (this.target.geoJSON === ''))) {
      this.prevValue = this.target.geoJSON;
      this.resetBelow('target');
    }
  }
  drawCircleAOI(lon: number, lat: number, radiusInKm: number) {
    const accuracy = 15;
    const center = [lon, lat];
    const circle = turf.circle(center, radiusInKm, {
      steps: 64,        // more = smoother circle
      units: 'kilometers'
    });
  
    const coords = circle.geometry.coordinates[0];
  
    // Convert to Cesium Cartesian3
    const positions = coords.map(([lng, lat]) => Cesium.Cartesian3.fromDegrees(lng, lat));
  
    // Draw polygon on Cesium globe
    this.viewer.entities.add({
      name: 'Circle AOI',
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(positions),
        material: Cesium.Color.BLUE.withAlpha(0.4),
        outline: true,
        outlineColor: Cesium.Color.BLUE,
      }
    });
  
    // Zoom to it
    this.viewer.zoomTo(this.viewer.entities);
  
    // Format WKT
    const formattedCoords = coords.map(([lng, lat]) => `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}`);
    const wkt = `POLYGON ((${formattedCoords.join(', ')}))`;
  
    const areaSqKm = turf.area(circle) / 1e6;
  
    this.target.geoJSON = wkt;
    this.target.area = areaSqKm.toFixed(2);
    this.updateTarget(this.target, '1');
  }

  isValidInput(input: string): any {
    const trimmed = input.trim();

    // Disallow trailing semicolon
    if (trimmed.endsWith(';')) return 'invalid';

    const singleCoordRegex = /^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/;
    const multipleCoordsRegex = /^(-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)(\s*;\s*-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?)*$/;
    const placeNameRegex = /^[a-zA-Z0-9\s.,'\-]+$/;

    // Just a number like "150.96" or "150.96,"
    const numberOnlyRegex = /^-?\d+(\.\d+)?$/;
    const endsWithCommaOnly = /^-?\d+(\.\d+)?,$/;

    if (singleCoordRegex.test(trimmed) || multipleCoordsRegex.test(trimmed)) return this.isCoordinate;
    
    if (numberOnlyRegex.test(trimmed) || endsWithCommaOnly.test(trimmed)) return 'invalid';

    if (placeNameRegex.test(trimmed)) return 'place';

    return 'invalid';
  }
  destinationCall(){
    this.geocoder.viewModel.destinationFound = (viewModel, destination) => {
      if (!!viewModel.selectedSuggestion || this.inputStatus === 'invalid'){  // runs if selected from dropdown
          this.resetMap();  
        this.isSearched = true;
        this.pinDisable = true;

        let centerLongitude, centerLatitude;
        if (destination instanceof Cesium.Rectangle) {
          const center = Cesium.Rectangle.center(destination);
          centerLongitude = Cesium.Math.toDegrees(center.longitude);
          centerLatitude = Cesium.Math.toDegrees(center.latitude);
        } else {
          this.popupService.openPopup(
            WarningPopup,
           "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'",
            '',
            '50%'
          );
          return;
        }

        // Now add the pin
        const accuracy = 15;
        const poiWkt = `POINT (${centerLongitude.toFixed(accuracy)} ${centerLatitude.toFixed(accuracy)})`;
        this.target.geoJSON = poiWkt;
        this.target.area = 0;

        const location = this.viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(centerLongitude, centerLatitude),
          billboard: {
            image: 'assets/images/marker-icon.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 20,
            height: 30,
          },
        });

        this.viewer.flyTo(location, {
          offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-20), 5000),
          duration: 3,
        });

        this.getCountryAndPlace(centerLatitude, centerLongitude, 'search');

        if (this.restrictedUser) {
          const mousePoint = [centerLongitude, centerLatitude];
          this.checkPointInsidePolygon(mousePoint);
        }
      }
    };
  }
  parsePolygonAOI(input:any, command:any, inputType:any) {

    if(this.taskStrategy === "TLE Based Tasking" && input.includes(';')){
      const message = 'TLE-based tasking supports only point of interest (POI) now';
         this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
            return;
    }else{
      const _this = this;
      this.isSearched = true;
      this.pinDisable = true;
      var positionString = input.trim();
      var positionArray = positionString.split(',');
      const isValid = isArrayValid(positionArray);
     
      function isArrayValid(arr: string[]): boolean {
        const regex = /^-?\d*\.?\d+\s*-?\d*\.?\d+$/;
        return arr.every((str) => regex.test(str.trim()));
      }

      function validateCoordinates(longitude, latitude) {
        // Check if values are numbers
        if (isNaN(longitude) || isNaN(latitude)) {
          return false;
        }
        
        // Check longitude range (-180 to 180)
        if (longitude < -180 || longitude > 180) {
          return false;
        }
        
        // Check latitude range (-90 to 90)
        if (latitude < -90 || latitude > 90) {
          return false;
        }
        
        return true;
      }
      if (positionArray?.length > 2 && !this.retask && inputType === this.isCoordinate) {
        this.resetMap();
        let isValidCoordPairs = true;
        const coordPairs = positionString.split(';').map(pair => pair.trim());
		    const positions: Cesium.Cartesian3[] = [];
        const invalidPairs: string[] = [];
        const validCoords: string[] = [];
        const accuracy = 15;

        let firstPairKey: string | null = null;
        this.duplicateDetected = false;

        for (const pair of coordPairs) {
          const [lonStr, latStr] = pair.split(',').map(s => s.trim());
          const lon = Number(lonStr);
          const lat = Number(latStr);

          if (validateCoordinates(lon, lat) && lonStr !== "" && latStr !== "") {
            const formatted = `${lon.toFixed(accuracy)} ${lat.toFixed(accuracy)}`;

            if (!firstPairKey) {
              firstPairKey = formatted;
            } else if (formatted === firstPairKey) {
              validCoords.push(formatted);
              this.duplicateDetected = true;
              break; // Stop processing further pairs
            }

            validCoords.push(formatted);
            positions.push(Cesium.Cartesian3.fromDegrees(lon, lat));
          } else {
            isValidCoordPairs = false;
            invalidPairs.push(pair);
          }
        }
        if (positions.length >= 3 && isValidCoordPairs) {
          const polygonWKT = `POLYGON ((${validCoords.join(', ')}))`;
          this.target.geoJSON = polygonWKT;
          // Calculate area using turf.js
          this.getCountryAndPlace(0,0,geoParse(this.target.geoJSON));
          const turfCoords = validCoords.map(c => {
            const [lon, lat] = c.split(' ').map(Number);
            return [lon, lat];
          });
          const first = turfCoords[0];
          const last = turfCoords[turfCoords.length - 1];
          
          const isClosed =
            first[0] === last[0] &&
            first[1] === last[1];
          
          if (!isClosed) {
            const message = 'First and last coordinates must be the same to form a closed polygon';
            this.popupService.openPopup(WarningPopup, message, '', '50%');
            return;
          }
          this.viewer.entities.add({
            name: "Validated AOI",
            polygon: {
              hierarchy: new Cesium.PolygonHierarchy(positions),
              material: Cesium.Color.BLUE.withAlpha(0.4),
              outline: true,
              outlineColor: Cesium.Color.BLUE
            }
          });
        
          this.viewer.zoomTo(this.viewer.entities);
          const showUpdateTarget = () => {
            const turfPolygon = turf.polygon([turfCoords]);
            const areaSqM = turf.area(turfPolygon); // in square meters
            this.target.area = (areaSqM / 1e6).toFixed(2);
            _this.updateTarget(this.target, '1');
          };
        if (this.duplicateDetected && validCoords.length != coordPairs.length ) {
          const duplicateMessage = 'All the subsequent coordinates are ignored when the polygon is complete.';
          const duplicateType= 'duplicateDetected';
        
          this.popupService
            .openPopup(WarningPopup, duplicateMessage, duplicateType, '50%')
            .afterClosed()
            .subscribe(result => {
            if (result === 1) {
              showUpdateTarget();
            }
          });
          return;
        }
        showUpdateTarget();
        } else if (!isValidCoordPairs) {
          const message = `Please enter the longitude followed by the latitude.`;
          this.popupService.openPopup(WarningPopup, message,'', '50%');
        }else {
          const message = `Not enough coordinates to draw an AOI polygon. Three or more pairs are required for a polygon.`;
          this.popupService.openPopup(WarningPopup, message,'', '50%');
        }
      }
      else 
      if (positionArray?.length === 2 && !this.retask && inputType === this.isCoordinate) {
        this.resetMap();
        var longitude = parseFloat(positionArray[0]);
        var latitude = parseFloat(positionArray[1]);

        const isValids = validateCoordinates(longitude, latitude);
        if (isValids) {
          const accuracy = 15;
          let poiWkt = `POINT (${longitude.toFixed(accuracy)} ${latitude.toFixed(accuracy)})`;
          this.target.geoJSON = poiWkt;
          this.target.area = 0;
          // this.updateTarget(target, '1');
          var pin = this.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(longitude, latitude),
            billboard: {
              image: 'assets/images/marker-icon.png',
              show: true,
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              alignedAxis: Cesium.Cartesian3.ZERO,
              width: 20,
              height: 30,
            },
          });
          this.viewer.flyTo(pin, {
            offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-20), 5000),
            duration: 3, // Adjust the duration as needed
          });
          this.getCountryAndPlace(latitude,longitude,'search');
          if (this.restrictedUser) {
            let mousePoint = [longitude, latitude];
            this.checkPointInsidePolygon(mousePoint)
          }
        } else {
          const message = `Please enter the longitude followed by the latitude.`;
          _this.popupService.openPopup(WarningPopup, message,'', '50%');
        }
   
      } else if (!this.retask) {
        command.cancel = false;
        this.geocoder.viewModel.destinationFound = (viewModel, destination) => {
          this.resetMap();
          this.isSearched = true;
          this.pinDisable = true;
        
          let centerLongitude, centerLatitude;
        
          if (destination instanceof Cesium.Rectangle) {
            const center = Cesium.Rectangle.center(destination);
            centerLongitude = Cesium.Math.toDegrees(center.longitude);
            centerLatitude = Cesium.Math.toDegrees(center.latitude);
          } else {
            const message = "Please enter a valid coordinate Lng,Lat or multiple coordinate pairs separated by ';'";
            this.popupService.openPopup(WarningPopup, message, '', '50%');
            return;
          }
        
          // Use the determined centerLongitude and centerLatitude below:
          const accuracy = 15;
          let poiWkt = `POINT (${centerLongitude.toFixed(accuracy)} ${centerLatitude.toFixed(accuracy)})`;
          this.target.geoJSON = poiWkt;
          this.target.area = 0;
        
          const location = this.viewer.entities.add({
            position: Cesium.Cartesian3.fromDegrees(centerLongitude, centerLatitude),
            billboard: {
              image: 'assets/images/marker-icon.png',
              show: true,
              eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              alignedAxis: Cesium.Cartesian3.ZERO,
              width: 20,
              height: 30,
            },
          });
        
          this.viewer.flyTo(location, {
            offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-20), 5000),
            duration: 3,
          });
        
          this.getCountryAndPlace(centerLatitude, centerLongitude, 'search');
        
          if (this.restrictedUser) {
            const mousePoint = [centerLongitude, centerLatitude];
            this.checkPointInsidePolygon(mousePoint);
          }
        };
      }
    }
  }

  ngOnDestroy() {
    // Unsubscribe to avoid memory leaks
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
  }

  async selectRecord(rowData: any) {
    try {
      const res: any = await this.apiService.getObservations(rowData?.openWater).toPromise();
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = res?.feeds;
      this.formGroup.get('tipAndCueBasedOn').setValue(rowData?.tipAndCueBasedOn);
      const ruleFilter = this.rulesOptions.filter(el => el.rule === rowData?.rule);
      this.formGroup.get('rule').setValue(ruleFilter[0]?.rule_key);
      if (rowData?.feeds) this.formGroup.get('feeds').setValue(rowData?.feeds[0]?.name);
      if (rowData?.observation) this.formGroup.get('observation').setValue(rowData?.observation[0]?.name);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    this.formGroup.get('project').setValue(rowData?.project);
    const modifiedName = rowData?.taskname.replace('_retask', '');
    let taskName = modifiedName + '_retask';
    this.formGroup.get('taskname').setValue(taskName);
    this.formGroup.controls.projectId.setValue(rowData?.projectid);
    this.formGroup.get('purpose').setValue(rowData?.purpose);
    const purposeFilter = this.purposeOption.filter(el => el.purpose === rowData.purpose);    
    if (purposeFilter?.length > 0) {
      this.onPurposeChange(purposeFilter[0]);
    } else {
      let option = [{
        code: "8",
        purpose: rowData.purpose,
      }];
      this.target.purposeOption = option[0];
    }

    const frequencyFilter = this.frequencyOption.filter(el => el.id === rowData.frequency);
    this.formGroup.get('frequency').setValue(frequencyFilter[0]?.name);
    this.onOptionChange(frequencyFilter[0]?.name);
    if (rowData.taskStrategy) {
      const strategyFilter = this.strategyOptions.filter(el => el.value === rowData.taskStrategy || 
        (rowData.taskStrategy === 'Tip-and-Cue-Outcome' && el.value === 'Tip-and-Cue')
      );
      this.formGroup.get('strategyRadio').setValue(strategyFilter[0]?.name);
      this.taskStrategy = strategyFilter[0]?.value;
    }
    if(this.taskStrategy === 'TLE Based Tasking'){
        const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
     this.minDate = new Date(year, month - 1, day);
      this.maxDate = new Date(year, month - 1, day  + 3);
    this.date = new FormControl(new Date(year, month - 1, day + 1));
    this.range = new FormGroup({
  start: new FormControl(new Date(year, month - 1, day)),
  end: new FormControl(new Date(year, month - 1, day  + 3)) 
});

 this.tleSensorForm.patchValue({
      sensorType : rowData.request[0]?.sensortype,
      resolution: rowData.request[0]?.resolution,
      sensor: this.currentUser?.obfuscated ? rowData.request[0]?.obfuscateName :rowData.request[0]?.name ,
    });
    this.selectedSensorObfuscatedName = {sensorName: rowData.request[0]?.name , obfuscateName: rowData.request[0]?.obfuscateName}
    }

    if (rowData?.intent?.intent_key) {
      const intentFilter = this.intentOption.filter(el => el.intent_key === rowData?.intent.intent_key);
      this.formGroup.get('intent').setValue(intentFilter[0]?.name);
    } 
    else if (rowData?.intent?.key) {
       let intentFilter: any;
        const match = this.intentOption.find(el => el.intent_key === rowData?.intent.key);
        if (match) {
          intentFilter = this.intentOption.filter(el => el.intent_key === rowData?.intent.key);
          this.updatedIntentOption = match;
        }else {
          const internalUseItem = this.intentOption.find((item: any) => item.intent_key === 'internalUse');
          if(internalUseItem) {
            intentFilter = [internalUseItem];
            this.updatedIntentOption = internalUseItem
          }
          else {
            intentFilter = [this.intentOption[0]];
            this.updatedIntentOption = this.intentOption[0];
          }
        } 
        this.formGroup.get('intent').setValue(intentFilter[0]?.name);
      }
      else this.formGroup.get('intent').setValue(rowData?.intent);

    if (rowData?.useCase) {
      this.formGroup.get('useCase').setValue(rowData.useCase)
    }
    if (rowData?.useCaseDescription) {
      this.formGroup.get('useCaseDescription').setValue(rowData.useCaseDescription)
    }
   

    this.selectedOption = rowData.frequency;
    this.clickFrequency = true;
    this.subDaily = false;
    if (rowData.frequency === 1) {
      this.target.freqOption = rowData?.repeatFrequency;
      if (this.target.freqOption === 'Sub-daily') {
        this.subDaily = true;
        this.target.subDailyCount = rowData?.subDailyCount;
      }
    }

    let targetData = JSON.parse(rowData.target);
    let type: any, coordinates: any;

    let targetPoints = rowData?.targetPoints ? JSON.parse(rowData.targetPoints) : null;
    const isLBandIncluded = rowData.request.some(item => (item.operatorKey === OPERATORS.LBAND));

    if (targetData?.length > 1) {
      type = targetData[0]?.type.toUpperCase();
      this.createGeoJSONFile(targetData);
    } else {
      type = targetData?.type.toUpperCase();
      coordinates = JSON.parse(rowData.target).coordinates;

      if (type === 'POINT') {
        this.drawPoint(coordinates);
        if (isLBandIncluded) {
         this.drawCircle(coordinates);
        }
      }
      else if (type === 'POLYGON') {
        this.drawpolygon(coordinates, rowData.area);
        if (isLBandIncluded && targetPoints) {
          let points = targetPoints[0].replace('POINT (', '').replace(')', '').split(' ');
          let coordinates = [parseFloat(points[0]), parseFloat(points[1])]
         this.drawPoi(coordinates);
        }
      }
    }
   
    if (rowData?.taskSubStrategy) {
      const subStartegyFilter = this.subStrategyOptions.filter(el => el.value === rowData?.taskSubStrategy);      
      this.formGroup.get('subStrategyRadio').setValue(subStartegyFilter[0]?.name);
    }
   
    this.projName = rowData?.project;
    this.taskName = taskName;
    this.target.projectId = rowData?.projectid;
    this.target.selectedOption = this.selectedOption;
    this.target.fileName = rowData?.fileName;
    // this.target.intent = rowData?.intent;
    this.target.intent = this.updatedIntentOption == false ? rowData?.intent : this.updatedIntentOption;
    this.target.taskStrategy = rowData?.taskStrategy;
    this.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.target.tipAndCueBasedOn = rowData?.tipAndCueBasedOn;
    this.rule = rowData?.rule;
    this.target.rule = rowData?.rule;
    this.observation = rowData?.observation;
    this.observationData = rowData?.observationData;  
    this.target.observationData = rowData?.observationData;    
    if (rowData?.observation) this.target.observation = rowData?.observation[0];
    this.target.useCase = rowData?.useCase
    this.target.useCaseDescription = rowData?.useCaseDescription
    this.target.taskSubStrategy = rowData?.taskSubStrategy;
    this.subStrategy = rowData?.taskSubStrategy;
    this.feeds = rowData?.feeds;
    if (rowData?.feeds) this.target.feeds = rowData?.feeds[0];

    this.updateTarget(this.target, '0');
  }

  drawPoint(positionArray) {
    var longitude = parseFloat(positionArray[0]);
    var latitude = parseFloat(positionArray[1]);
    const accuracy = 15;
    let poiWkt = `POINT (${longitude.toFixed(accuracy)} ${latitude.toFixed(accuracy)})`;
    this.target.geoJSON = poiWkt;
    this.formGroup.get('target').setValue(poiWkt);
    var pin = this.viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(longitude, latitude),
      billboard: {
        image: 'assets/images/marker-icon.png',
        show: true,
        eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
        alignedAxis: Cesium.Cartesian3.ZERO,
        width: 20,
        height: 30,
      },
    });
    this.getCountryAndPlace(latitude, longitude,'search');

    var cameraHeight = 1000;
    var cameraPosition = Cesium.Cartesian3.fromDegrees(longitude, latitude, cameraHeight);
    this.viewer.camera.setView({
      destination: cameraPosition,
      orientation: {
        heading: 0.0,
        pitch: Cesium.Math.toRadians(-90.0),
        roll: 0.0
      }
    });

    this.viewer.flyTo(pin, {
      duration: 1.0,
      offset: new Cesium.HeadingPitchRange(0, Cesium.Math.toRadians(-45), 1000000)
    });
  }

  drawpolygon(positionArray, area) {
    this.polygons.push(positionArray[0]);
    let aoiWkt: any = 'POLYGON ((';
    const accuracy = 15;
    let polyPts: any = [], aoi: any, lng0 = 0, lat0 = 0;
    this.polygons.forEach((coordinates) => {
      const polygon = this.viewer.entities.add({
        polygon: {
          hierarchy: Cesium.Cartesian3.fromDegreesArray(coordinates.flat()),
          material: Cesium.Color.BLUE.withAlpha(0.5)
        }
      });
    });
    this.viewer.zoomTo(this.viewer.entities);
    for (let i = 0; i < positionArray[0]?.length - 1; i++) {
      let lng = positionArray[0][i][0];
      let lat = positionArray[0][i][1];
      if (i === 0) {
        lng0 = lng;
        lat0 = lat;
      }
      polyPts.push([lng, lat]);
      aoiWkt =
        aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
    }
    polyPts.push([lng0, lat0]);
    aoi = turf.polygon([polyPts]);
    aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
    aoiWkt = aoiWkt + `))`;
    this.target.geoJSON = aoiWkt;
    this.target.area = area;
    this.formGroup.get('target').setValue(aoiWkt);
    this.getCountryAndPlace(lat0, lng0,geoParse(this.target.geoJSON));
  }

  async createGeoJSONFile(features: any[]) {
    const geoJSON = {
      type: 'FeatureCollection',
      features: features.map((feature) => ({
        type: 'Feature',
        geometry: {
          type: feature.type,
          coordinates: feature.coordinates,
        },
      })),
    };

    let selectData: any;
    selectData = Cesium.GeoJsonDataSource.load(geoJSON);

    selectData.then((dataSource) => {
      const entities = dataSource.entities.values;
      for (let i = 0; i < entities.length; i++) {
        const entity = entities[i];
        entity.billboard = new Cesium.BillboardGraphics({
          image: 'assets/images/marker-icon.png',
          show: true,
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          alignedAxis: Cesium.Cartesian3.ZERO,
          width: 20,
          height: 30,
        });
        entity.label = new Cesium.LabelGraphics({
          text: (i + 1).toString(), // Set the label to the index + 1
          font: '14pt sans-serif',
          fillColor: Cesium.Color.WHITE,
          outlineColor: Cesium.Color.BLACK,
          outlineWidth: 2,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
          pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust the offset to position the label correctly
        });
      }

      this.viewer.flyTo(dataSource, { duration: 3 });
      this.viewer.dataSources.add(dataSource);
      this.viewer.scene.globe.depthTestAgainstTerrain = false;
    });

    const selctval = await selectData;
    let point = selctval.entities.values;
    const accuracy = 15;

    let poiWkt: any;
    let pointArray: any = [];
    let latValue, longValue;
    for (const entity of point) {
      if (entity) {
        const position = entity.position.getValue(this.viewer.clock.currentTime); // Get the position in Cartesian3 format
        const cartographic = Cesium.Cartographic.fromCartesian(position);
        const lng = Cesium.Math.toDegrees(cartographic.longitude);
        const lat = Cesium.Math.toDegrees(cartographic.latitude);
        poiWkt = `POINT (${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)})`;
        pointArray.push(poiWkt);
        latValue = Cesium.Math.toDegrees(cartographic.latitude);
        longValue = Cesium.Math.toDegrees(cartographic.longitude);
      }
    }

    function geoParsePoint(wkt: string) {
      const regex = /POINT \(([^)]+)\)/g;
      const points: { type: string; coordinates: [number, number] }[] = [];
      let match;

      while ((match = regex.exec(wkt)) !== null) {
        const coordinates = match[1].split(' ').map(parseFloat);
        points.push({
          type: "Point",
          coordinates: [coordinates[0], coordinates[1]]
        });
      }

      return points;
    }

    this.target.multiTarget = pointArray;
    this.target.geoJSON = pointArray.join(', ');
    const geoPoints = geoParsePoint(this.target.geoJSON);
    this.target.geotargets = JSON.stringify(geoPoints);
    this.target.area = 0;
    this.getCountryAndPlace(latValue, longValue,'search');
  }
  usecasedescChng(event: any){
    this.target.useCaseDescription = event.target.value
    this.updateTarget(this.target, '0')
  }

  descChng(event: any) {
    let option = [{
      code: "8",
      purpose: event.target.value,
    }];
    this.target.purposeOption = option[0];
    this.updateTarget(this.target, '0');
  }

  Space(event: any) {
    if (event.target.selectionStart === 0 && event.code === "Space") {
      event.preventDefault();
    }
  }

  get budgetFields() {
    return this.budgetForm.controls;
  }

  get outcomeFields() {
    return this.outComeForm.controls;
  }

  get fields() {
    return this.formGroup.controls;

  }
   get tleSensorFields() {
    return this.tleSensorForm.controls;
  }
  getTooltip(name: string) {
    if (name === 'Period') return 'Tasked once within the period specified';
    else if (name === 'Specific Date') return 'Tasked once on the date specified';
    else if (name === 'Recurrent') return 'Tasked repeatedly, either sub-daily, daily, weekly or monthly, within the period specified';
    else return 'Description for ' + name.toLowerCase() + ' frequency';
  }

  updateTarget(target, idx) {
    if (idx != 0 && target?.geoJSON && !target?.geoJSON.includes('POINT')) this.callCounter++;
    this.target = target;
    this.target['project'] = this.projName?.trim();
    this.target['taskname'] = this.taskName?.trim();

    if (idx != 0 && this.callCounter === 1) this.isAreaOk(target.area);

    this.resetOutcome();
    this.apiService.updateTaskParams(this.target);
    if(this.isSearched == true) {
      this.drawingMode = 'search';
      this.buttonDisable = true;
      this.pinDisable = true;
    }
    else if(this.isSearched == false && this.drawingMode == 'search') {
      this.drawingMode = '';
      this.buttonDisable = false;
      this.pinDisable = false;
    } 
    else {
      this.drawingMode = '';
    }
    this.weatherData = [];
    this.formGroup.controls.target.setValue(target?.geoJSON);
    this.closePanels();
  }

   onOptionChange(chosenOption: any) {
    this.resetDateDefault();
    this.target.freqOption = '';
    this.dateFlag = false;
    this.subDaily = false;
    this.target.subDailyCount = '';
    const id = this.frequencyOption.findIndex(
      (option) => option.name === chosenOption
    );
    this.selectedFrequencyID = id;
    this.selectedOption = id;
    this.clickFrequency = true;
    this.target.selectedOption = id;
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    this.budgetForm.patchValue({
      resolution: '',
      sensorType: '',
      updateFrequency: '',
      taskingTier:'',
      cloudCover: '',
      holdBack: ''
    });
    this.range.value.start = null;
    this.range.value.end = null;

    if (id === 1) {
      this.target.freqOption = 'Daily';
    }
    if (id === 1 || id === 2) {
      this.range.value.start = this.date.value;
      const day = this.todayDate.getDate();
      const month = this.todayDate.getMonth() + 1;
      const year = this.todayDate.getFullYear();
      this.range.value.end = new Date(
        year,
        month - 1,
        day + this.defaultWindow
      );
    } else {
      this.range.value.start = this.date.value;
      this.range.value.end = this.date.value;
    }

  }
  handleDateChange(event: any, datePicker: any) {
    this.formGroup.get('startTime').setValue(null);
    this.formGroup.get('endTime').setValue(null);
    this.budgetForm.get('startTime').setValue(null);
    this.budgetForm.get('endTime').setValue(null);
    this.resetBelow('date');

    if (datePicker === 1) {
      this.range.value.start = event.value;
      const day = event.value.getDate();
      const month = event.value.getMonth() + 1;
      const year = event.value.getFullYear();
      this.range.value.end = event.value;
    } else if (datePicker === 2) {
      if(this.taskStrategy === 'TLE Based Tasking'){
      this.clearTLEOnly();
      this.showtleDisabled = false;
      this.showtleClick = false;
      }     
      this.range.value.start = event.value;
    } else if (datePicker === 3) {
      if(this.taskStrategy === 'TLE Based Tasking'){
      this.showtleDisabled = false;
      this.showtleClick = false;
      this.clearTLEOnly();
      }
      this.range.value.end = event.value;
    }
    this.showtleClick = false;
    if (this.range.value.start !== null && this.range.value.end !== null) {
      const condition = this.taskStrategy === "TLE Based Tasking" ? this.range.value.start <= this.range.value.end : this.range.value.start < this.range.value.end;    
      
      if (condition) {
        this.dateFlag = false;
      } else {
        this.dateFlag = true;
      }
      if (this.taskStrategy === "TLE Based Tasking") { 

      const startDate = new Date(this.range.value.start);
      const endDate = new Date(this.range.value.end);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);
      const now = new Date();
      const maxAllowedStart = new Date();
      maxAllowedStart.setHours(now.getHours() + 72); 

      if(startDate.getTime() > maxAllowedStart.getTime()){

      this.tleStartRangeError = true;
      } else{
       this.tleStartRangeError = false;
      }
      
      const timeDifferenceMs = endDate.getTime() - startDate.getTime();
      const timeDifferenceDays = timeDifferenceMs / (1000 * 60 * 60 * 24);
      
      if (timeDifferenceDays > 3) {
        this.tleRangeError = true;
      } else {
        this.tleRangeError = false;
      }
    }
      if (this.selectedOption === 1 && this.subDaily) {
        this.dateFlag = false;
      }

    } else {
      this.dateFlag = false;
    }
    this.target['openWindow'] = this.range.value.start;
    this.target['closeWindow'] = this.range.value.end;

    // If sensors are already selected, re-check reaction time vs new TOI lead time.
    this.sensorList?.handleToiChangedReactionTimeWarnings();

    this.updateTarget(this.target, '0');
  }

  freqChange(chosenOption: any) {
    this.subDaily = false;
    this.target.subDailyCount = '';
    this.target.freqOption = chosenOption.name;
    this.target.repeatOption = chosenOption.value;
    if (this.target.repeatOption === 4) {
      this.subDaily = true;
      this.target.subDailyCount = 1;
    }
    this.updateTarget(this.target, '0');
  }

  recurrentCountChange(chosenOption: any) {
    this.target.subDailyCount = chosenOption.label;
    this.updateTarget(this.target, '0');
  }

  onPurposeChange(option: any) {
    this.useCaseOption = null;
    this.target.useCase = null;
    if (option.purpose === 'Others') {
      this.others = true;
    }
    else {
      this.others = false;
      this.target.purposeOption = option;
    }
    if(this.taskStrategy === "Help Select Sensor(s)"){
      this.userService.getUseCases(option._id).subscribe((res: any) => {
        this.useCaseOption = res.data.sort((a, b) => {
          return a.useCase.toLowerCase().localeCompare(b.useCase.toLowerCase());
        });
      });
    } else this.updateTarget(this.target, '0');
  }

  intentChange(option: any) {  
    this.target.intent = option;
    this.showtleClick = false;
    if(this.taskStrategy === "TLE Based Tasking"){
      this.tleSensorForm.reset();
        this.tleSensor = {
  resolution: [],
  sensor: []
};
      this.tleSensorTypes(this.userid, option._id);
      this.clearTLEOnly();
    }
    this.updateTarget(this.target, '0');
    if (this.budget) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier:'',
        holdBack: '',
        sensorType: ''
      });
      
      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];

      let data = {
        intent : option,
        selectedCategory :  this.selectedCategory,
        multiPoi : this.target.multiTarget && this.target.multiTarget.length > 0 ? true : false
      }
      this.apiService.getBudgetSensorType(data).subscribe((res: any) => {
        if(res?.msg == 'Success') {
          this.budgetSensorType=res.response
        }
         else {
          const message = `There are no sensors for the selected intent. Please change to continue for budget generation.`;
          const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          dialogRef.afterClosed().subscribe(result => {
            this.budgetForm.patchValue({intent: ''});
          });
        }
        });
    }
  }

  outcomeIntentChange (option: any) {
    this.target.intent = option;
  }

  useCaseChange(option: any) {
    this.target.useCase = option;
    this.updateTarget(this.target, '0');

  }



  nameChng(e: any, i: number) {
    if (i === 1) {
      this.target.projectId = null;
      if (e.target.value.length > 3) {
        this.projName = e.target.value;
      } else {
        this.projName = undefined;
      }
    } else {
      if (e.target.value.length > 4) {
        this.taskName = e.target.value;
      } else {
        this.taskName = undefined;
      }
    }
    this.updateTarget(this.target, '0');
  }

  inValid() {
    if (!this.taskTarget) return true;
    if (
      this.taskName &&
      this.projName &&
      this.taskTarget.includes('P') &&
      this.selectedSensorTypes.length > 2
    ) {
      this.showSensors = true;
      return false;
    } else {
      this.showSensors = false;
      return true;
    }
  }

  isAreaOk(area) {
    this.target.area = area;
    if (this.target)
      if (
        (this.target.area > 2000 || this.target.area < 10) &&
        this.target.geoJSON?.includes('POLY')
      ) {
        setTimeout(() => {
          const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
            width: '60%', backdropClass: 'blurr',
            data: this.target,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              this.proceed = true;
              this.buttonDisable = true;
              this.target.buttonDisable = true;
            } else {
              this.proceed = false;
              this.resetMap();
            }
          });
          return this.proceed;
        }, 1);
      }
    return
  }

  openAreaPopup () {    
    if (
      (this.target.area > 2000 || this.target.area < 10) &&
      !this.target.geoJSON
    ) {
      const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
        width: '60%', backdropClass: 'blurr',
        data: this.target,
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.proceed = true;
          this.buttonDisable = true;
          this.target.buttonDisable = true;
        } else {
          this.proceed = false;
          this.resetMap();
        }
      });
    }
  }

  getFileData() {
    this.drawingMode = 'fileUpload';
    const entities = this.viewer.entities.values;
    for (const entity of entities) {
      if ((entity.id == undefined || entity.id == null) && entity?.name !== 'allowedArea') {
        this.viewer.entities.remove(entity);
      }
    }

    const doc = document.getElementById('filedatas');
    if (doc) {
      doc.click();
    }
  }

  onFilesSelected($event): void {
    this.buttonDisable = true;
    this.pinDisable = true;
    this.readThis($event.target);
    $event.target.value = '';
    this.shapeSelected = true;
  }

  readThis(inputValue: any): void {
    this.resetMap();
    let viewer = this.viewer;
    let options = {
      camera: viewer.scene.camera,
      canvas: viewer.scene.canvas,
      screenOverlayContainer: viewer.container,
    };
    let file: File = inputValue.files[0];
    let fileReader: FileReader = new FileReader();
    let selectData: any, vals: any, res: any, target = this.target;
    let _this = this;
    const accuracy = 15;
    target.polygon = false;
    if (file) {
      fileReader.onloadend = async function (e) {
        target.fileName = file.name;
        res = fileReader.result;
        if (file.name.includes('json')) {
          vals = JSON.parse(fileReader.result as string);
          selectData = Cesium.GeoJsonDataSource.load(vals);

          selectData.then((dataSource) => {
            const entities = dataSource.entities.values;
            for (let i = 0; i < entities.length; i++) {
              const entity = entities[i];
              entity.billboard = new Cesium.BillboardGraphics({
                image: 'assets/images/marker-icon.png',
                show: true,
                eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
                horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                alignedAxis: Cesium.Cartesian3.ZERO,
                width: 20,
                height: 30
              });
              entity.label = new Cesium.LabelGraphics({
                text: (i + 1).toString(), // Set the label to the index + 1
                font: '14pt sans-serif',
                fillColor: Cesium.Color.WHITE,
                outlineColor: Cesium.Color.BLACK,
                outlineWidth: 2,
                style: Cesium.LabelStyle.FILL_AND_OUTLINE,
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust the offset to position the label correctly
              });
            }
          });
        }
        if (file.name.includes('kml') || file.name.includes('kmz')) {
          selectData = Cesium.KmlDataSource.load(file, options);
        }
        const selctval = await selectData;
        let point = selctval.entities.values;
        let sumOfArea = 0;
        let count = 0;
        target.buttonDisable = false;
        let isInside = true;

        for (let j = 0; j < point.length; j++) {
          if (point[j]?.polygon !== undefined) {
            count = count + 1;
            let polyPts: any = [], aoi: any;
            let poly_point = point[j].polygon.hierarchy.getValue(
              Cesium.JulianDate.now()
            );
            let cartesianPts = poly_point.positions.length;
            let lng0 = 0, lat0 = 0;
            for (let i = 0; i < cartesianPts; i++) {
              let cartoPoint = Cesium.Cartographic.fromCartesian(
                poly_point.positions[i]
              );
              let lng = Cesium.Math.toDegrees(cartoPoint.longitude);
              let lat = Cesium.Math.toDegrees(cartoPoint.latitude);
              if (i === 0) {
                lng0 = lng;
                lat0 = lat;
              }
              polyPts.push([lng, lat]);
            }

            aoi = turf.polygon([polyPts]);
            const areaVal = turf.area(aoi) / 1000000;
            var aoiArea = areaVal.toFixed(2);
            sumOfArea += parseFloat(aoiArea)
          }
        }
        target.area = sumOfArea.toFixed(2);

        if (point[0].position !== undefined && point?.length < 2) {
          let pointss = point[0].position.getValue(Cesium.JulianDate.now());
          let cartographicPosition = Cesium.Cartographic.fromCartesian(pointss);
          let lat = Cesium.Math.toDegrees(cartographicPosition.latitude);
          let lng = Cesium.Math.toDegrees(cartographicPosition.longitude);
          createBB(lng, lat);
          function createBB(lng, lat) {
            let poiWkt = `POINT (${lng.toFixed(accuracy)} ${lat.toFixed(
              accuracy
            )})`;
            target.geoJSON = poiWkt;
            target.area = 0;
            _this.getCountryAndPlace(lat,lng,'search');
            if (_this.restrictedUser) {
              isInside = _this.currentUser.taskableAoi.some(aoi =>
                _this.utilsService.pointInPolygon(
                  geoParse(target.geoJSON).coordinates,
                  aoi.taskableAoi.coordinates[0]
                )
              );
              if (!isInside) {
                const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
                const dialogRef = _this.popupService.openPopup(WarningPopup, message, '', '50%');

                dialogRef.afterClosed().subscribe(() => {
                  _this.resetMap();
                });
              }
            }
            _this.updateTarget(target, '1');
          }
        } else if (point[0].polygon) {
          let poly_point = point[0].polygon.hierarchy.getValue(
            Cesium.JulianDate.now()
          );
          let cartesianPts = poly_point.positions.length;
          let polyPts: any = [],
            aoi;
          let aoiWkt: any = 'POLYGON ((';
          let lng0 = 0,
            lat0 = 0;
          for (let i = 0; i < cartesianPts; i++) {
            let cartoPoint = Cesium.Cartographic.fromCartesian(
              poly_point.positions[i]
            );
            let lng = Cesium.Math.toDegrees(cartoPoint.longitude);
            let lat = Cesium.Math.toDegrees(cartoPoint.latitude);
            if (i === 0) {
              lng0 = lng;
              lat0 = lat;
            }
            polyPts.push([lng, lat]);

            if (i === cartesianPts - 1) {
              aoiWkt =
                aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)} `;
            } else {
              aoiWkt =
                aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
            }
          }
          aoi = turf.polygon([polyPts]);
          aoiWkt = aoiWkt + `))`;
          if (!aoi) return;
          const areaVal = turf.area(aoi) / 1000000;
          let areaMsg = '';
          var aoiArea = areaVal.toFixed(2); //in Sq km
          target.geoJSON = aoiWkt;
          target.area = aoiArea;
          _this.getCountryAndPlace(lat0,lng0,geoParse(target.geoJSON));
          if (_this.restrictedUser) {
            const targetCoords = geoParse(target.geoJSON).coordinates[0];

            const isInside = _this.currentUser.taskableAoi.some(aoi =>
              _this.utilsService.comparePolygons(targetCoords, aoi.taskableAoi.coordinates[0])
            );
            if (!isInside) {
              const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
              const dialogRef = _this.popupService.openPopup(WarningPopup, message, '', '50%');

              dialogRef.afterClosed().subscribe(() => {
                _this.resetMap();
              });
            }
          }
          _this.updateTarget(target, '1');
        } else if (point?.length > 1 && point[0].position !== undefined) {
          target.buttonDisable = true;
          let poiWkt: any;
          let pointArray: any = [];
          for (const entity of point) {
            if (entity) {
              const position = entity.position.getValue(viewer.clock.currentTime); // Get the position in Cartesian3 format
              const cartographic = Cesium.Cartographic.fromCartesian(position);
              const lng = Cesium.Math.toDegrees(cartographic.longitude);
              const lat = Cesium.Math.toDegrees(cartographic.latitude);
              poiWkt = `POINT (${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)})`;
              pointArray.push(poiWkt);
            }
          }

          function geoParsePoint(wkt: string) {
            const regex = /POINT \(([^)]+)\)/g;
            const points: { type: string; coordinates: [number, number] }[] = [];
            let match;

            while ((match = regex.exec(wkt)) !== null) {
              const coordinates = match[1].split(' ').map(parseFloat);
              points.push({
                type: "Point",
                coordinates: [coordinates[0], coordinates[1]]
              });
            }

            return points;
          }

          target.multiTarget = pointArray;
          target.geoJSON = pointArray.join(', ');
          const geoPoints = geoParsePoint(target.geoJSON);
          target.geotargets = JSON.stringify(geoPoints);
          target.area = 0;
          if (_this.restrictedUser) {
            isInside = _this.currentUser.taskableAoi.some(aoi =>
              _this.utilsService.pointInPolygon(
                geoParse(pointArray[pointArray.length - 1]).coordinates,
                aoi.taskableAoi.coordinates[0]
              )
            );

            if (!isInside) {
              const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
              const dialogRef = _this.popupService.openPopup(WarningPopup, message, '', '50%');

              dialogRef.afterClosed().subscribe(() => {
                _this.resetMap();
              });
            }
          }
          _this.updateTarget(target, '1');

        }
        _this.openAreaPopup();

        if (!_this.restrictedUser || (_this.restrictedUser && isInside))
        selectData.then((dataSource) => {
          viewer.flyTo(dataSource, { duration: 3 });
          viewer.dataSources.add(dataSource);
        });

        setTimeout(() => {
          if (count > 1) {
            _this.openDialog();      
          }
        }, 4000);
      };
    }

    fileReader.readAsText(file);
  }

  openDialog() {
    const dialogRef = this.dialog.open(CollectionPopupComponent, {
      width: '50%', backdropClass: 'blurred', disableClose: true,
      data: { message: 'Multi-polygon AOI is not supported at this time. Please submit a single contiguous polygon with any internal boundaries dissolved.' },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.resetMap();
    });
  }

  resetMe(parentVal: any) {
    if (parentVal === 'Reset') {
      this.formGroup.controls['taskname'].setValue('');
      this.target['taskname'] = '';
      this.target.polygon = false;
      this.apiService.updateTaskParams(this.target);
      this.formGroup = new FormGroup({
        project: new FormControl(),
        taskname: new FormControl(),
        target: new FormControl()
      });
    }
  }

  drawOnMap(drawMode) {
    if(drawMode != 'point') {
    this.drawStarted = false;
    this.drawCompleted = false;
    this.drawingMode = drawMode;
    let drawingMode = drawMode;
    this.callCounter = 0;
    this.shapeSelected = true;
    var activeShapePoints: any = [];
    var activeShape;
    var floatingPoint;
    var viewer = this.viewer;
    this.target.project = this.projName;
    this.target.taskname = this.taskName;
    var _this = this;
    var target = this.target;
    viewer._container.style.cursor = 'crosshair';
    if (this.handler) {
        this.handler.destroy();
        this.handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    } else {
      this.handler = new Cesium.ScreenSpaceEventHandler(viewer.canvas);
    }
      
    target.polygon = false;
    this.pointArray = [];
    this.pointArray.length = 0;
    this.isDrawingEnabled = false;

    if(this.drawingMode != 'line') {
      this.pointEntities = [];
      this.target.multiTarget = [];
      this.target.geoJSON = null;
      this.target.geotargets = null;
    }

    if (this.drawingMode == 'line') {
      this.proceed = false;
    }

    // Double click the left mouse button to clear the default event
    viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(
      Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
    );
    // draw a point
    function createPoint(worldPosition) {
      var point = viewer.entities.add({
        position: worldPosition,
        point: {
          color: Cesium.Color.BLUE,
          pixelSize: 5,
          heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
        },
      });
      return point;
    }
    const createBB = (lng, lat) => {
      var entitiesToRemove: any = [];
      // Loop through all entities in the viewer.entities collection
      viewer.entities.values.forEach(function (entity) {
        // Check if the entity is not a line or a point

        if ((entity.polyline === undefined && entity.point === undefined) && entity?.name !== 'allowedArea') {
          // If the entity is not a line or a point, remove it from the collection
          viewer.entities.remove(entity);
        }
      });
      var lastEllipseEntity = null;
      var entities = viewer.entities.values;
      for (var i = entities.length - 1; i >= 0; i--) {
        var entity = entities[i];
        if (entity.ellipse) {
          lastEllipseEntity = entity;
          break;
        }
      }
      if (lastEllipseEntity != null)
        this.removeEntity();
      const accuracy = 15;
      let poiWkt = `POINT (${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)})`;
      const bb = viewer.entities.add({
        position: Cesium.Cartesian3.fromDegrees(lng, lat), //  bbPosition,
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
      target.geoJSON = poiWkt;
      target.area = 0;
      _this.updateTarget(target, '1');
      this.getCountryAndPlace(lat,lng,'search');
      target.fileName = '';
    }

    const createCZML = (mode, cartesianPts) => {
      const accuracy = 15;
      let polyPts: any = [],
        aoi;
      let aoiWkt: any = 'POLYGON ((';
      let lng0 = 0,
        lat0 = 0;
      if (mode === 'polygon') {
        target.polygon = true;

        for (let i = 0; i < cartesianPts.length; i++) {
          let cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[i]);
          let lng = Cesium.Math.toDegrees(cartoPoint.longitude);
          let lat = Cesium.Math.toDegrees(cartoPoint.latitude);
          if (i === 0) {
            lng0 = lng;
            lat0 = lat;
          }
          polyPts.push([lng, lat]);
          aoiWkt =
            aoiWkt + `${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)}, `;
        }
        polyPts.push([lng0, lat0]);
        aoi = turf.polygon([polyPts]);
        aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
      } else if (mode === 'rectangle') {
        let i = 0;
        let cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[0]);
        let lng0 = Cesium.Math.toDegrees(cartoPoint.longitude);
        let lat0 = Cesium.Math.toDegrees(cartoPoint.latitude);
        cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[1]);
        let lng2 = Cesium.Math.toDegrees(cartoPoint.longitude);
        let lat2 = Cesium.Math.toDegrees(cartoPoint.latitude);
        var bbox = [lng0, lat0, lng2, lat2];
        aoi = turf.bboxPolygon(bbox);

        aoiWkt =
          aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
        aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
      } else if (mode === 'circle') {
        // let dx = 0, dy = 0, delta = 0;
        let cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[0]);
        let lng0 = Cesium.Math.toDegrees(cartoPoint.longitude);
        let lat0 = Cesium.Math.toDegrees(cartoPoint.latitude);
        cartoPoint = Cesium.Cartographic.fromCartesian(cartesianPts[1]);
        let lng2 = Cesium.Math.toDegrees(cartoPoint.longitude);
        let lat2 = Cesium.Math.toDegrees(cartoPoint.latitude);
        var options = { units: 'kilometers' }; //var options = {units: 'miles'};
        let radius = turf.distance(
          turf.point([lng0, lat0]),
          turf.point([lng2, lat2]),
          options
        );
        const circle = turf.circle([lng0, lat0], radius, { steps: 64 });
        aoi = turf.bboxPolygon(turf.bbox(circle));
        lng0 = aoi.bbox[0];
        lat0 = aoi.bbox[1];
        lng2 = aoi.bbox[2];
        lat2 = aoi.bbox[3];

        aoiWkt =
          aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng2.toFixed(accuracy)} ${lat0.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng2.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
        aoiWkt =
          aoiWkt + `${lng0.toFixed(accuracy)} ${lat2.toFixed(accuracy)}, `;
        aoiWkt = aoiWkt + `${lng0.toFixed(accuracy)} ${lat0.toFixed(accuracy)}`;
        var circleEntity = viewer.entities.add({
          name: 'Circle',
          position: Cesium.Cartesian3.fromDegrees(
            (lng0 + lng2) / 2,
            (lat0 + lat2) / 2
          ),
          ellipse: {
            semiMinorAxis: radius * 1000.0,
            semiMajorAxis: radius * 1000.0,
            heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
            outline: true,
            outlineColor: Cesium.Color.RED,
            outlineWidth: 4,
            material: new Cesium.ColorMaterialProperty(
              Cesium.Color.BLUE.withAlpha(0.5)
            ),
          },
        });
      }
      aoiWkt = aoiWkt + `))`;
      if (!aoi) return;
      const areaVal = turf.area(aoi) / 1000000;

      let areaMsg = '';

      var aoiArea = areaVal.toFixed(2); //in Sq km
      target.geoJSON = aoiWkt;
      target.area = aoiArea;
      viewer.render();
      target.fileName = '';
      this.getCountryAndPlace(lat0,lng0,geoParse(target.geoJSON));
      
      if (this.currentUser?.isTaskableAoi) {
        const targetCoords = geoParse(target.geoJSON).coordinates[0];

        const isInside = this.currentUser.taskableAoi.some(aoi =>
          this.utilsService.comparePolygons(targetCoords, aoi.taskableAoi.coordinates[0])
        );

        if (!isInside) {
          const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
          const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

          dialogRef.afterClosed().subscribe(() => {
            this.resetMap();
          });
        }
      }
      _this.updateTarget(target, '1');

    }

    // Initialize to line
    // draw graphics
    let drawShape = (positionData) => {
      var shape;
      if (this.drawingMode === 'point') {
        this.buttonDisable = true;
      } else if (this.drawingMode === 'line') {
        this.entityId = Date.now() + ''
        shape = viewer.entities.add({
          id: this.entityId + 'line',
          polyline: {
            positions: positionData,
            clampToGround: true,
            width: 2,
          },
        });
      } else if (this.drawingMode === 'polygon') {
        this.pinDisable = true;
        this.buttonDisable = true;
        if (positionData.length > 0) {
          shape = viewer.entities.add({
            polygon: {
              hierarchy: positionData,
              material: new Cesium.ColorMaterialProperty(
                Cesium.Color.BLUE.withAlpha(0.7)
              ),
            },
          });
        } else {
          shape = viewer.entities.add({
            polyline: {
              positions: positionData,
              clampToGround: true,
              width: 1,
            },
          });
        }
      } else if (this.drawingMode === 'circle') {
        this.buttonDisable = true;
        this.pinDisable = true;
        //Draw the final graph when positionData is an array, and draw a dynamic graph if it is function
        var value =
          typeof positionData.getValue === 'function'
            ? positionData.getValue(0)
            : positionData;
        shape = viewer.entities.add({
          position: activeShapePoints[0],
          name: 'Blue translucent, rotated, and extruded ellipse with outline',
          type: 'Selection tool',
          ellipse: {
            semiMinorAxis: new Cesium.CallbackProperty(function () {
              //radius distance between two points
              var r = Math.sqrt(
                Math.pow(value[0].x - value[value.length - 1].x, 2) +
                Math.pow(value[0].y - value[value.length - 1].y, 2)
              );
              return r ? r : r + 1;
            }, false),
            semiMajorAxis: new Cesium.CallbackProperty(function () {
              var r = Math.sqrt(
                Math.pow(value[0].x - value[value.length - 1].x, 2) +
                Math.pow(value[0].y - value[value.length - 1].y, 2)
              );
              return r ? r : r + 1;
            }, false),
            material: Cesium.Color.BLUE.withAlpha(0.5),
            outline: true,
            show: false,
          },
        });
        // viewer.entities.remove(shape)
      } else if (this.drawingMode === 'rectangle') {
        this.buttonDisable = true;
        this.pinDisable = true;
        //Draw the final graph when positionData is an array, and draw a dynamic graph if it is function
        var arr =
          typeof positionData.getValue === 'function'
            ? positionData.getValue(0)
            : positionData;
        shape = viewer.entities.add({
          name: 'Blue translucent, rotated, and extruded ellipse with outline',
          rectangle: {
            coordinates: new Cesium.CallbackProperty(function () {
              var obj = Cesium.Rectangle.fromCartesianArray(arr);
              //if(obj.west==obj.east){ obj.east+=0.000001};
              //if(obj.south==obj.north){obj.north+=0.000001};
              return obj;
            }, false),
            material: Cesium.Color.BLUE.withAlpha(0.5),
          },
        });
      }
      return shape;
    }

    let tooltipEntity: any = null;
    let totalDistance = 0;
    var previousPoint: any;
    let measuretooltipEntity: any = null;

    //left mouse button

    if(this.handler) {
      this.handler.setInputAction((event) => {
        
        if(this.isDrawingEnabled == false && this.drawCompleted == false) {
        this.drawStarted = true;
        if (this.proceed == false) {
          var earthPosition = viewer.camera.pickEllipsoid(
            event.position,
            viewer.scene.globe.ellipsoid
          );
          if (Cesium.defined(earthPosition)) {
            if (activeShapePoints.length === 0) {
              floatingPoint = createPoint(earthPosition);
              activeShapePoints.push(earthPosition);
              var dynamicPositions = new Cesium.CallbackProperty(function () {
                return activeShapePoints;
              }, false);
              activeShape = drawShape(dynamicPositions); //Draw dynamic graph
  
              if (this.drawingMode === 'polygon') {
                tooltipEntity = viewer.entities.add({
                  label: {
                    show: false,
                    showBackground: true,
                    font: "14px Arial",
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    pixelOffset: new Cesium.Cartesian2(15, -10),
                    backgroundColor: Cesium.Color.fromCssColorString('black'),
                    fillColor: Cesium.Color.WHITE
                  },
                });
              } else if (this.drawingMode === 'rectangle') {

                if(tooltipEntity) {
                  viewer.entities.remove(tooltipEntity);
                }
                
                tooltipEntity = viewer.entities.add({
                  label: {
                    show: false,
                    showBackground: true,
                    font: "14px Arial",
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    pixelOffset: new Cesium.Cartesian2(15, -10),
                    backgroundColor: Cesium.Color.fromCssColorString('black'),
                    fillColor: Cesium.Color.WHITE
                  },
                });
              } else if (this.drawingMode === 'line') {
                if(tooltipEntity) {
                  viewer.entities.remove(tooltipEntity);
                }
                measuretooltipEntity = viewer.entities.add({
                  label: {
                    show: false,
                    showBackground: true,
                    font: "14px Arial",
                    horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
                    pixelOffset: new Cesium.Cartesian2(15, -10),
                    backgroundColor: Cesium.Color.fromCssColorString('black'),
                    fillColor: Cesium.Color.WHITE
                  },
                });
              }
            }
            activeShapePoints.push(earthPosition);
            if (this.drawingMode === 'point') {
              let cartoPoint = Cesium.Cartographic.fromCartesian(earthPosition);
              let lng = Cesium.Math.toDegrees(cartoPoint.longitude);
              let lat = Cesium.Math.toDegrees(cartoPoint.latitude);
              createBB(lng, lat);  
            }
  
            if (activeShapePoints.length > 1) {
              if (this.drawingMode == 'polygon') {
                if (previousPoint) {
                  var distance = (Cesium.Cartesian3.distance(previousPoint, earthPosition)) / 1000;
                  totalDistance = totalDistance + distance;
                  if (tooltipEntity) {
                    tooltipEntity.position = earthPosition;
                    tooltipEntity.label.text =
                      "Distance: " + distance.toFixed(2) + " km\n" +
                      "Total Distance: " + totalDistance.toFixed(2) + " km";
                    tooltipEntity.label.show = true;
                  }
                }
              } else if (this.drawingMode == 'rectangle') {
                if (previousPoint) {
                  if (tooltipEntity) {
                    tooltipEntity.position = earthPosition;
                    tooltipEntity.label.text = 'Total distance : ' + totalDistance.toFixed(2) + " km";;
                    tooltipEntity.label.show = true;
                    this.buttonDisable = true;
                    this.target.buttonDisable = true;
  
                  }
                }
              } else if (this.drawingMode == 'line') {
                if (previousPoint) {
                  var distance = (Cesium.Cartesian3.distance(previousPoint, earthPosition)) / 1000;
                  totalDistance = totalDistance + distance;
                  if (measuretooltipEntity) {
                    measuretooltipEntity.position = earthPosition;
                    measuretooltipEntity.label.text = 'Total : ' + totalDistance.toFixed(2)+" km";
                    measuretooltipEntity.label.show = true;
                  }
                }
              }else if (this.drawingMode == 'circle') {
                if (previousPoint) {
                  this.buttonDisable = true;
                  this.pinDisable = true;
                }}
            }
            previousPoint = earthPosition;
          }
  
          viewer.screenSpaceEventHandler.setInputAction((movement) => {
                var pickedObject = viewer.scene.pick(movement.position);
                if (Cesium.defined(pickedObject) && pickedObject.id) {
                    var clickedId = pickedObject.id.id; 
                    let pointEntityindex = this.pointEntities.findIndex((pointEntity) => clickedId == pointEntity.uniqueId);
                    if(pointEntityindex == -1) {
                      // Remove the tooltip entity with the clicked id
                    var indexToRemove = this.measurmentTooltipEntities.findIndex(function (entity) {
                        return entity.id === clickedId;
                    });
    
                    if (indexToRemove !== -1) {
                  
                        var entityToRemove = viewer.entities.getById(clickedId+'line');
                  
                        if (entityToRemove !== undefined) {
                            viewer.entities.remove(this.measurmentTooltipEntities[indexToRemove]);
                            this.measurmentTooltipEntities.splice(indexToRemove, 1);
                            this.measurmentEntities.splice(indexToRemove, 1);
                            viewer.entities.remove(entityToRemove);
                        } else {
                      }
                    }
                    } else if (pickedObject.id.name != 'allowedArea') {
                      const clickedEntity = this.viewer.entities.getById(clickedId);
                      this.pointEntities.splice(pointEntityindex, 1);
                      this.viewer.entities.remove(clickedEntity);
                    }
  
                    this.pointArray = [];
                    for (const items of this.pointEntities) {
                      this.pointArray.push(items.poiWkt);
                    }

                  if(this.target?.geoJSON?.includes('POINT') && this.isSearched == false) {                    
                    if (this.pointArray?.length === 1) {
                      this.target.geoJSON = this.pointArray[0];
                      this.target.multiTarget = [];
                    } else {
                      this.target.multiTarget = this.pointArray;
                      this.target.geoJSON = this.pointArray.join(', ');
                      const geoPoints = this.geoParsePoint(this.target.geoJSON);
                      this.target.geotargets = JSON.stringify(geoPoints);
                    }     
                  }

                }
          }, Cesium.ScreenSpaceEventType.LEFT_CLICK)
        }
      }
      }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
    }

    // Function to calculate the distance between two Cartesians
    function calculateDistance(cartesian1, cartesian2) {
      var p1 = Cesium.Cartographic.fromCartesian(cartesian1);
      var p2 = Cesium.Cartographic.fromCartesian(cartesian2);
      var a = Math.sin(p1.latitude) * Math.sin(p2.latitude) +
        Math.cos(p1.latitude) * Math.cos(p2.latitude) * Math.cos(p2.longitude - p1.longitude);
      var distance = Cesium.Ellipsoid.WGS84.maximumRadius * Math.acos(Math.min(a, 1.0));
      return distance;
    }

    //Mouse movement
    this.handler.setInputAction((event) => {
      
      if(this.drawStarted == false) {
        activeShapePoints.length = 0;
      }
      
      if (Cesium.defined(floatingPoint)) {
        var newPosition = viewer.camera.pickEllipsoid(
          event.endPosition,
          viewer.scene.globe.ellipsoid
        );

        if (Cesium.defined(newPosition)) {
          floatingPoint.position.setValue(newPosition);
          if (activeShapePoints.length > 0) {
            activeShapePoints.pop();
          }
          var newPositionCopy = Cesium.Cartesian3.clone(newPosition);
          activeShapePoints.push(newPositionCopy);

          if (activeShapePoints.length > 1) {
            var distance = (Cesium.Cartesian3.distance(previousPoint, newPosition)) / 1000;

            if (tooltipEntity && this.drawingMode == 'polygon') {              
              tooltipEntity.position = newPosition;
              tooltipEntity.label.text =
                "Distance: " + distance.toFixed(2) + " km";
              tooltipEntity.label.show = true;
            }
            if (measuretooltipEntity && this.drawingMode == 'line') {
              measuretooltipEntity.position = newPosition;
              measuretooltipEntity.label.text =
                "Distance: " + distance.toFixed(2) + " km";
              measuretooltipEntity.label.show = true;
            }

            if (activeShapePoints.length === 2 && this.drawingMode == 'rectangle') {
              let cartoPoint = Cesium.Cartographic.fromCartesian(activeShapePoints[0]);
              let lng0 = Cesium.Math.toDegrees(cartoPoint.longitude);
              let lat0 = Cesium.Math.toDegrees(cartoPoint.latitude);
              cartoPoint = Cesium.Cartographic.fromCartesian(activeShapePoints[1]);
              let lng2 = Cesium.Math.toDegrees(cartoPoint.longitude);
              let lat2 = Cesium.Math.toDegrees(cartoPoint.latitude);
              var bbox = [lng0, lat0, lng2, lat2];


              // Calculate the width of the rectangle
              let width = turf.distance([lng0, lat0], [lng2, lat0], { units: 'kilometers' });

              // Calculate the height of the rectangle
              let height = turf.distance([lng0, lat0], [lng0, lat2], { units: 'kilometers' });

              // Calculate the total area
              totalDistance = 2 * (width + height);

              // Display or use the calculated area
              if (tooltipEntity) {
                tooltipEntity.position = newPosition;
                tooltipEntity.label.text =
                  "Distance: " + totalDistance.toFixed(2) + " km";
                tooltipEntity.label.show = true;
              }
            }
          }


        }
        if (activeShapePoints.length === 1 && this.drawStarted) {
          if (this.drawingMode === 'point') terminateShape();
        } else if (activeShapePoints.length > 2 && this.drawStarted) {
          if (this.drawingMode === 'rectangle' || this.drawingMode === 'circle'){
            terminateShape();
          }
        }
      }
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    // Redraw the shape so it's not dynamic and remove the dynamic shape.
    let terminateShape = () => {     
      this.drawStarted = false;
      
      activeShapePoints.pop(); //remove the last dynamic point
      if (activeShapePoints.length) {
        drawShape(activeShapePoints); //Draw the final graph
        createCZML(this.drawingMode, activeShapePoints);
      }
      viewer.entities.remove(floatingPoint); //Remove dynamic dot graphics (current mouse point)
      viewer.entities.remove(activeShape); //Remove dynamic graphics
      floatingPoint = undefined;
      activeShape = undefined;
      activeShapePoints = [];
      drawingMode = undefined;
      viewer._container.style.cursor = 'default';
    }


    this.handler.setInputAction((event) => {
      if (this.drawingMode != 'rectangle') {
        var earthPosition = viewer.camera.pickEllipsoid(
          event.position,
          viewer.scene.globe.ellipsoid
        );

        if (this.drawingMode === 'polygon') {
          if(tooltipEntity) {
            viewer.entities.remove(tooltipEntity);
          }
          tooltipEntity = viewer.entities.add({
            label: {
              show: false,
              showBackground: true,
              font: "13px Arial",
              horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
              pixelOffset: new Cesium.Cartesian2(15, -10),
              backgroundColor: Cesium.Color.fromCssColorString('black'),
            },
          });

          tooltipEntity.position = earthPosition;
          tooltipEntity.label.text =
            "Total Distance: " + totalDistance.toFixed(2) + " km";
          tooltipEntity.label.show = true;
          this.buttonDisable = true;
          this.target.buttonDisable = true;
        }

        terminateShape();
      }

      if (this.drawingMode === 'line') {
        viewer.entities.remove(measuretooltipEntity);
        measuretooltipEntity = viewer.entities.add({
          id: this.entityId,
          label: {
            show: false,
            showBackground: true,
            font: "13px Arial",
            horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
            pixelOffset: new Cesium.Cartesian2(15, -10),
            backgroundColor: Cesium.Color.fromCssColorString('black'),
          },
        });

        measuretooltipEntity.position = earthPosition;
        measuretooltipEntity.label.text =
          "Total Distance: " + totalDistance.toFixed(2) + " km";
        measuretooltipEntity.label.show = true;
        this.measurmentTooltipEntities.push(measuretooltipEntity); 
      }
    
      this.drawCompleted = true;
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);
  }
  }

  resetMap(task?:string) {
    if(this.drawingMode == 'search' || this.drawingMode == 'line') {
      this.isSearched = false;
    }
    
    this.pinDisable = false;
    this.isDrawingEnabled = false;
    this.pointArray = [];
    this.pointEntities = [];
    this.target.multiTarget = [];
    this.buttonDisable = false;
    this.target.buttonDisable = false;
    this.viewer.dataSources.removeAll(true);
    this.target.area = null;
    this.target.geoJSON = null;
    this.target.geotargets = null;
    this.callCounter = 0;
    this.shapeSelected = false;
    this.target.targetPoints = null;
    this.target.openWater = false;
    this.target.overOpenWater = false;
    //this.resetBelow('target');

    if(this.drawingMode == 'fileUpload') {
      this.pinDisable = true;
      const entities = this.viewer.entities.values;
      for (let i = entities.length - 1; i >= 0; i--) {
      const e: any = entities[i];
      if ((e.id == null) && e?.name !== 'allowedArea' && !this.isTLEEntity(e)) {
        this.viewer.entities.remove(e);
      }
    }
    } else {
      if(task === 'tle'){
        this.removeEntityTle()
      }else{
         this.removeEntity();
      }
      
    }

    if(this.drawingMode != 'fileUpload') {
      this.proceed = false;
    }

    this.updateTarget(this.target, '0');
    if (this.selectedCategory === this.nonImagingSensor){
    this.range?.reset({
    start: null,
    end: null
  });
  }
  }

  plotTarget() {
    let target: any,
      viewer = this.viewer;

    if (this.taskTarget)
      if (this.taskTarget.type === 'Polygon') {
        const fpPos = this.taskTarget.coordinates[0]
          .toString()
          .split(',')
          .map(Number);
        // const pts = this.taskTarget.coordinates[0]
        var bbox = turf.bbox(this.taskTarget);
        // var rectangle = Cesium.Rectangle.fromDegrees(west, south, east, north);
        var rectangle = Cesium.Rectangle.fromDegrees(
          bbox[0],
          bbox[1],
          bbox[2],
          bbox[3]
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          name: this.taskName,
          polygon: {
            hierarchy: {
              positions: Cesium.Cartesian3.fromDegreesArray(fpPos),
            },
            fill: false,
            // material : Cesium.Color.BLUE.withAlpha(0.2),
            height: 0,
            outlineColor: Cesium.Color.YELLOW,
            outline: true, // height is required for outline to display
          },
        });
        // viewer.zoomTo(target);
        viewer.flyTo(target, { duration: 3 });
      } else if (this.taskTarget.type === 'Point') {
        const fpPos = this.taskTarget.coordinates;
        const lng = fpPos[0],
          lat = fpPos[1];
        var rectangle = Cesium.Rectangle.fromDegrees(
          lng - 1,
          lat - 1,
          lng + 1,
          lat + 1
        );
        Cesium.Camera.DEFAULT_VIEW_RECTANGLE = rectangle;
        target = viewer.entities.add({
          id: this.taskName,
          position: Cesium.Cartesian3.fromDegrees(lng, lat), //  bbPosition,
          billboard: {
            image: 'assets/images/marker-icon.png',
            show: true, // default
            // pixelOffset: new Cesium.Cartesian2(0, 5), // default: (0, 0)
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            // scale: 0.75, // default: 1.0
            // color: Cesium.Color.LIME, // default: WHITE
            // rotation: Cesium.Math.PI_OVER_FOUR, // default: 0.0
            alignedAxis: Cesium.Cartesian3.ZERO, // default
            width: 20, // default: undefined
            height: 30, // default: undefined
          },
        });
        viewer.entities.add({
          position: Cesium.Cartesian3.fromDegrees(lng, lat), // bbPosition,
          billboard: {
            image: 'assets/images/marker-shadow.png',
            pixelOffset: new Cesium.Cartesian2(5, 0), // default: (0, 0)
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
            scale: 0.6,
          },
        });
        this.defaultLL = [lng, lat];
        this.viewer.camera.flyTo(
          {
            destination: Cesium.Cartesian3.fromDegrees(lng, lat, 100000.0),
            orientation: {
              heading: Cesium.Math.toRadians(0),
              pitch: Cesium.Math.toRadians(-90.0),
              roll: 0.0,
            },
          },
          { duration: 3 }
        );
      }
  }

  flyHome() {
    this.viewer.camera.flyHome(2); // take 2 seconds
  }

  showLatLon() {
    const viewer = this.viewer;
    const latlonOverlay = this.latlonOverlay;
    const scene = this.viewer.scene;
    const canvas = this.viewer.canvas;
    // this.latlonOverlay.id = 'latlon';
    viewer.container.appendChild(latlonOverlay);
    // latlonOverlay.className = 'llDisp';
    // latlonOverlay.style.display = 'none';
    latlonOverlay.style.position = 'absolute';
    latlonOverlay.style['z-index'] = '10';
    latlonOverlay.style.right = '3px';
    latlonOverlay.style.bottom = '5px';
    // latlonOverlay.style.marginTop = '-30px';
    latlonOverlay.style.height = '30px';

    // latlonOverlay.style.width = 'calc(100% - 37px)';
    latlonOverlay.style.width = 'fit-content';
    latlonOverlay.style['pointer-events'] = 'none';
    latlonOverlay.style.textAlign = 'center';
    latlonOverlay.style.justifyContent = 'center';
    latlonOverlay.style.padding = '5px 4px 0 4px';
    latlonOverlay.style.color = 'rgba(255, 255, 255, 1)';
    // latlonOverlay.style.color = '#026FC2';
    // latlonOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.2)';
    let mousePosition;
    const handler = new Cesium.ScreenSpaceEventHandler(canvas);
    const accuracy = 15;

    handler.setInputAction((movement) => {
      mousePosition = movement.endPosition;
      const cartesian = viewer.camera.pickEllipsoid(
        movement.endPosition,
        viewer.scene.globe.ellipsoid
      );
      if (cartesian) {
        const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

        const longString = Cesium.Math.toDegrees(cartographic.longitude).toFixed(accuracy);
        const latString = Cesium.Math.toDegrees(cartographic.latitude).toFixed(accuracy);
        const latitude = parseFloat(latString);
        const longitude = parseFloat(longString);

        const latitudeDMS = convertDecimalToDMS(latitude) + (latitude >= 0 ? 'N' : 'S');
        const longitudeDMS = convertDecimalToDMS(longitude) + (longitude >= 0 ? 'E' : 'W');

        
        function convertDecimalToDMS(decimal) {
          const degrees = Math.floor(Math.abs(decimal));
          const minutesDecimal = (Math.abs(decimal) - degrees) * 60;
          const minutes = Math.floor(minutesDecimal);
          const seconds = (minutesDecimal - minutes) * 60;

          const formattedDegrees = degrees !== 0 ? `${degrees}°` : '';
          const formattedMinutes = minutes !== 0 ? `${minutes}'` : '';
          const formattedSeconds = `${seconds.toFixed(1)}"`;

          return `${formattedDegrees}${formattedMinutes}${formattedSeconds}`;
        }

        this.longLatStr = 'Lng: ' + longitudeDMS + ', ' + 'Lat: ' + latitudeDMS;

        latlonOverlay.innerHTML =
          "<div style='padding:0px; padding-right: 30px'>" + this.longLatStr + '</div>';
      } else {
        this.longLatStr = '';
        latlonOverlay.innerHTML = "<div style='padding:0px;padding-right: 25px'>Out of Globe</div>";
        // latlonOverlay.style.display = 'none';
      }
      this.roll = Cesium.Math.toDegrees(this.viewer.camera.heading).toFixed(0);
      if (this.roll > 359.5) this.roll = 0;
      // this.compassOverlay.style.transform = `rotate(${360-this.roll}deg)`;
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  zoomIn() {
    var height = this.viewer.camera.positionCartographic.height;
    this.viewer.camera.zoomIn(height / 2);
  }
  zoomOut() {
    var height = this.viewer.camera.positionCartographic.height;
    this.viewer.camera.zoomOut(height * 2);
  }

  receivedMessageHandler(result: any) {
    this.satellites = [];
    this.viewer.entities.remove(this.satelliteEntity);

    if (result?.length > 0) {
      this.satellites = result;

      for (let i = 0; i < this.satellites.length; i++) {
        let satelliteData = this.satellites[i];
        let orbitPosition: any = [];
        let satellite = satelliteData;
        orbitPosition.push(satellite.longitude, satellite.latitude, satellite.position[satellite.position.length - 1][0], satellite.position[satellite.position.length - 1][1]);

        this.satelliteEntity = this.viewer.entities.add({
          name: 'orbit',
          position: Cartesian3.fromDegrees(
            satellite.longitude,
            satellite.latitude,
          ),
          billboard: {
            image: 'assets/images/satellite.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 25,
            height: 20,
          },
          label: {
            text: ((this.currentUser.obfuscated && satellite.obfuscateName) ? satellite.obfuscateName : satellite.name) + '\n' + satellite.time,
            font: '11px Barlow',
            fillColor: Color.YELLOW,
            outlineColor: Color.YELLOW,
            outlineWidth: 1,
            style: 2,
            pixelOffset: new Cesium.Cartesian2(0, 10),
          },
          satellitesToRemove: true,
        });

        if (satellite.operatorKey === OPERATORS.CAPELLA) {
          this.randomColor = 'YELLOW';
        } else if (satellite.operatorKey === OPERATORS.SATELLOGIC) {
          this.randomColor = 'YELLOWGREEN';
        } else if (satellite.operatorKey === OPERATORS.UMBRA) {
          this.randomColor = 'BLUE';
        } else if (satellite.operatorKey === OPERATORS.HEAD) {
          this.randomColor = 'GREENYELLOW';
        } else if (satellite.operatorKey === OPERATORS.STE) {
          this.randomColor = 'BLUEVIOLET';
        } else if (satellite.operatorKey === OPERATORS.AT21) {
          this.randomColor = 'GREEN';
        } else {
          this.randomColor = 'ROYALBLUE';
        }

        // Render orbital path     
        this.orbitalPath = this.viewer.entities.add({
          name: 'orbit',
          polyline: {
            positions: Cesium.Cartesian3.fromDegreesArray(orbitPosition),
            width: 5,
            material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.fromCssColorString(this.randomColor)
            )
          },
          satellitesToRemove: true
        });

        this.viewer.flyTo(this.viewer.entities); // Zoom to show the entire orbital path
        // }
      }
      this.entityValues = this.viewer.entities.values;
    }

  }
  handleClearSensorCost(event: boolean){
    this.sensorPanel.close();
    this.panelOpenState = false;
  }

  receiveHandler(data: any) {
    if (data?.length > 0) {
       let selectedRadius: number | null = null;

    data.forEach((item: any) => {
      if (item.key === OPERATORS.PIXXEL) {
        selectedRadius = PIXXEL_RADIUS;
      } else if (item.key === OPERATORS.LBAND) {
        selectedRadius = RF_RADIUS;
      }
      });

    if (selectedRadius) {
      this.drawCircles(selectedRadius);
    }

      const spireExists = data.some(item => item.key === OPERATORS.SPIRE);
      if (spireExists) this.drawRectangle(data);
    }
  }

  drawRectangle(data: any) {
    if (data[0]?.centroid) {
      const { longitude, latitude } = this.getCoordinatesFromPoint(data[0].centroid);

      // Step 2: Calculate square corners
      const corners = this.getSquareCorners(longitude, latitude);
    
      // Step 3: Draw the square
      this.drawSquare(corners);
      
    }
  }

  getCoordinatesFromPoint(pointString: string): { longitude: number; latitude: number } {
    const match = pointString.match(/POINT\s*\(([-\d.]+)\s+([-\d.]+)\)/);
  
    if (!match) {
      throw new Error('Invalid POINT format');
    }
  
    return {
      longitude: parseFloat(match[1]),
      latitude: parseFloat(match[2]),
    };
  }

  getSquareCorners(
    longitude: number,
    latitude: number,
    sideLength: number = 50
  ): Cesium.Cartesian3[] {
    // Convert 50 km to degrees approximately (~0.5 degrees for simplicity, refine as needed)
    const degreeOffset = sideLength / 111.32;
  
    return [
      Cesium.Cartesian3.fromDegrees(longitude - degreeOffset, latitude - degreeOffset),
      Cesium.Cartesian3.fromDegrees(longitude + degreeOffset, latitude - degreeOffset),
      Cesium.Cartesian3.fromDegrees(longitude + degreeOffset, latitude + degreeOffset),
      Cesium.Cartesian3.fromDegrees(longitude - degreeOffset, latitude + degreeOffset),
    ];
  }
  
  drawSquare(corners: Cesium.Cartesian3[]) {
    let newEntity = this.viewer.entities.add({
      name:'sqaure',
      polygon: {
        hierarchy: new Cesium.PolygonHierarchy(corners),
        material: Cesium.Color.RED.withAlpha(0.5),
        outline: true,
        outlineColor: Cesium.Color.BLACK,
      },
    });
    this.viewer.flyTo(newEntity);
  }

  removeRectangles() {
    let entitiesToRemove: any = [];

    const entities = this.viewer.entities.values;
    for (const entity of entities) {
      if (entity?.name === 'sqaure') {
        entitiesToRemove.push(entity);
      }
    }

    for (let i = 0; i < entitiesToRemove.length; i++) {
      this.viewer.entities.remove(entitiesToRemove[i]);
    }
  }

  removeCircles() {
    let entitiesToRemove: any = [];

    const entities = this.viewer.entities.values;
    for (const entity of entities) {
      if (entity?.name === 'circles' || entity?.name === 'sqaure') {
        entitiesToRemove.push(entity);
      }
    }

    for (let i = 0; i < entitiesToRemove.length; i++) {
      this.viewer.entities.remove(entitiesToRemove[i]);
    }
  }

  clearSatllite() {
    let entitiesToRemove: any = [];

    for (let i = 0; i < this.entityValues?.length; i++) {
      let entity = this.entityValues[i];
      if (entity.satellitesToRemove) {
        entitiesToRemove.push(entity);
      }
    }

    for (let i = 0; i < entitiesToRemove.length; i++) {
      this.viewer.entities.remove(entitiesToRemove[i]);
    }
  }

  getCountryAndPlace(latitudes: number, longitudes: number,target: any, status:any = false) {
    let longitude: any, latitude: any
    if (target?.type === 'Point') {
      longitude = target?.coordinates[0];
      latitude = target?.coordinates[1];
    } else if (target === 'search') {
      longitude = longitudes;
      latitude = latitudes;
    } else {
      let totalLat = 0;
      let totalLng = 0;
      for (let i = 0; i < target?.coordinates[0].length; i++) {
          totalLat += target?.coordinates[0][i][1];
          totalLng += target?.coordinates[0][i][0];
      }
      const centroidLat = totalLat / target?.coordinates[0].length;
      const centroidLng = totalLng / target?.coordinates[0].length;
      longitude = centroidLng;
      latitude = centroidLat;
    }    

    if (this.budget && this.target.intent) {
      this.budgetForm.patchValue({
        resolution: '',
        cloudCover: '',
        taskingTier:'',
        holdBack: '',
        sensorType: ''
      });
      
      this.budgetInputs.resolutionArr = [];
      this.budgetInputs.tierArr = [];
      this.budgetInputs.cloudCoverKeys = [];
      this.budgetInputs.holdbackArr = [];
      this.budgetSensorType = [];

      let data = {
        intent : this.target.intent,
        selectedCategory :  this.selectedCategory,
        multiPoi : this.target.multiTarget && this.target.multiTarget.length > 0 ? true : false
      }
      this.apiService.getBudgetSensorType(data).subscribe((res: any) => {
        if(res?.msg == 'Success') {
          this.budgetSensorType=res.response
        }
         else {
          const message = `There are no sensors for the selected intent. Please change to continue for budget generation.`;
          const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');
          dialogRef.afterClosed().subscribe(result => {
            this.budgetForm.patchValue({intent: ''});
          });
        }
        });
    }
    
    const apiKey = environment.openCageApiKey;
    const url = `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${apiKey}`;
    let place: any, country: any, countryCode: any;
    let location = {
      longitude : longitude,
      latitude : latitude
    }

    this.apiService.checkIsWater(location).subscribe((res: any) => { 
      if(status) {
        this.target.openWaterCue =res?.water;
      }else{
        this.target.openWater = res?.water;
        if (this.taskStrategy=='Tip-and-Cue' && this.subStrategy == 'Tip-and-Cue') this.getObservationList(this.target.openWater);
      }
    this.http.get(url).subscribe((response: any) => {
      if (response.results.length > 0) {
        const firstResult = response.results[0];
                
        if (firstResult.components?.body_of_water) {
           country = firstResult.components.body_of_water;
           place = firstResult.components.body_of_water;
           countryCode = firstResult.components.body_of_water;
           if(status)
            this.target.overOpenWaterCue = true;
          else
            this.target.overOpenWater = true;
        } else {
           country = firstResult.components.country;
           place = firstResult.components.city || firstResult.components.state || firstResult.components.county;
           countryCode = firstResult.components["ISO_3166-1_alpha-3"];
           if(status)
            this.target.overOpenWaterCue = true;
          else
            this.target.overOpenWater = true;
        }
        if(status) {
            this.target.placeCue = place;
            this.target.countryCue = country;
            this.target.countryCodeCue = countryCode
        }else {
            this.target.place = place;
            this.target.country = country;
            this.target.countryCode = countryCode
        }
        this.updateTarget(this.target, '0');
      }
    });
  });
  }

  isLatitudeInRange(geoJSON: any, minValue: number, maxValue: number): boolean {
    if(this.target?.multiTarget?.length > 0) {
      for (const targets of this.target.multiTarget) {
        const geoJson = geoParse(targets);
        const latitude = geoJson.coordinates[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    } else if (geoJSON.type === 'Point') {
      const latitude = geoJSON.coordinates[1];
      return latitude >= minValue && latitude <= maxValue;
    } else if (geoJSON.type === 'Polygon') {
      const coordinates = geoJSON.coordinates[0];
      for (const coordinate of coordinates) {
        const latitude = coordinate[1];
        if (latitude >= minValue && latitude <= maxValue) {
          return true; // If any latitude is within the range, return true
        }
      }
    }
    return false;
  }

  strategyChange(data: any) {
    this.useCaseOption = null
    this.formGroup.reset();
    this.resetMap();
    this.clearTLEOnly();
    this.onOptionChange('');
    this.formGroup.get('strategyRadio').setValue(data.value);
    this.formGroup.get('tipAndCueBasedOn').setValue('Rules');
    this.subStrategy = null;
    this.taskStrategy = data.value;
    this.selectedSensorTypes = '';
    if (this.taskStrategy != "Tip-and-Cue") {
      this.rule = null;
      this.target.rule = null;
      this.observation = null;
      this.target.observation = null;
      this.feeds = null;
      this.target.feeds = null;
    }
    if(this.taskStrategy === "Outcome By Platform" ){
      this.outcomeSensorTypes(this.userid)
    }
    if(this.taskStrategy === "TLE Based Tasking" ){
     
     const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
     this.minDate = new Date(year, month - 1, day);
      this.maxDate = new Date(year, month - 1, day  + 3);
    this.date = new FormControl(new Date(year, month - 1, day + 1));
    this.range = new FormGroup({
  start: new FormControl(new Date(year, month - 1, day)),
  end: new FormControl(new Date(year, month - 1, day  + 3)) 
});
    }else{
      this.minDate = null;
  this.maxDate = null;
    }
    this.tipAndCueBasedOn = 'Rules';
    this.target.tipAndCueBasedOn = 'Rules';
    this.target.taskStrategy = data.value;
    this.updateTarget(this.target, '0');
  }

  tipAndCueTypeChange(data: MatRadioChange) {
    this.tipAndCueBasedOn = data.value;
    this.target.tipAndCueBasedOn = data.value;
    this.observation = null;
    this.target.observation = null;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
  }

  onFeedsChange(option: any) {
    this.feeds = option;
    this.target.feeds = option;
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;
    this.updateTarget(this.target, '0');
  }

  onObservationChange(option: any) {
    let previousvalue:any;
    let previousoperator:any;
    if(this.target.observation?.name === option.name){
      previousvalue = this.target.observationData.value;
      previousoperator = this.target.observationData.action;
    }
    this.observation = option;
    this.target.observation = option;
    this.rule = null;
    this.target.rule = null;
    this.feeds = null;
    this.target.feeds = null;
    this.updateTarget(this.target, '0');
    const dialogRef = this.dialog.open(FilterPopupComponent, {
      width: '35%', backdropClass: 'blurr',
      data: {
            type: 'observation',
            name: this.target.observation.name,
            dataType :this.target.observation.data_type,
            value : previousvalue,
            operator :previousoperator
          },
    });
    dialogRef.afterClosed().subscribe((result) => {      
      if (result) {
        this.target.observationData =  result;
        this.formGroup.get('observationData').setValue(result);
        if(result.value.split(',').map(s => s.trim()).length > 1) {
          if (this.calculateObservation(result.value)) {
            this.getCountryAndPlace(0, 0, geoParse(this.target?.geoJSONCue), 'cueing');
          } else {
            const msg = ' The observation coordinates are outside the AOI';
            this.popupService.openPopup(CollectionPopupComponent, msg, '', '30%');
            this.formGroup.get('observationData').setValue(null);
            this.formGroup.get('observation').setValue(null);
            this.observation = null;
            this.target.observation = null;
            return;
          }
        }
      }
      else {
        this.formGroup.get('observationData').setValue(null);
        this.formGroup.get('observation').setValue(null);
        this.observation = null;
        this.target.observation = null;
      }
    });

  }

  onRulesChange(option: any) {
    let previousvalue:any;
    if(this.target.rule === option && this.target.rule === 'rule-3'){
      previousvalue = this.target.cloudCover;
    }   
    if (option === 'rule-3') {
      const dialogRef = this.dialog.open(OpenconfirmwarningComponent, {
        width: '60%', backdropClass: 'blurr',
        data: 'rule',
      });
      if (this.target.rule === option && this.target.rule === 'rule-3') {
        dialogRef.componentInstance.previousValue = this.target.cloudCover;
      }
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.formGroup.get('rule').setValue(option);
          this.rule = option;
          this.target.rule = option;
          this.observation = null;
          this.target.observation = null;
          this.feeds = null;
          this.target.feeds = null;
          this.target.cloudCover = result;
          this.updateTarget(this.target, '0');
        } else {
          this.formGroup.get('rule').setValue(null);
          this.target.cloudCover = '';
        }
      });
    } else {
      this.formGroup.get('rule').setValue(option);
      this.rule = option;
      this.target.rule = option;
      this.observation = null;
      this.target.observation = null;
      this.feeds = null;
      this.target.feeds = null;
      this.updateTarget(this.target, '0');
    }
  }

  drawPinOnMap() {
    this.drawingMode = 'point';
    let activeShapePoints: any = [];
    let pointEntity: any;
    let poiWkt: any;
    const accuracy = 15;
    this.isDrawingEnabled = true;
    this.buttonDisable = true;
    this.shapeSelected = true;
    this.viewer._container.style.cursor = 'auto';
    this.viewer.screenSpaceEventHandler.setInputAction((click) => {

      if (!this.isDrawingEnabled) {
        return;
      }

      var pickedObject = this.viewer.scene.pick(click.position);
       const ent: any = pickedObject?.id;
    const isAllowedArea = ent?.name === 'allowedArea';
    const isOrbit = !!(ent && (ent.noRemoveOnClick === true || ent.type === 'ORBIT' || ent.name === 'orbit'));
      let lat: any, lng: any;
      const uniqueId = Date.now();

      var earthPosition = this.viewer.camera.pickEllipsoid(
        click.position,
        this.viewer.scene.globe.ellipsoid
      );

      if (Cesium.defined(earthPosition)) {
        activeShapePoints.push(earthPosition);
        let cartoPoint = Cesium.Cartographic.fromCartesian(earthPosition);
        lng = Cesium.Math.toDegrees(cartoPoint.longitude);
        lat = Cesium.Math.toDegrees(cartoPoint.latitude);
      }

      if (Cesium.defined(pickedObject) && !isAllowedArea && !isOrbit) {

     
        
        const clickedEntityId = ent.id;
        const clickedEntity = this.viewer.entities.getById(clickedEntityId);     

        let measuringEntityIndex = this.measurmentTooltipEntities.findIndex((entity) => entity.id == clickedEntityId)
        if(measuringEntityIndex == -1) {
          if (clickedEntity) {
            const indexToRemove = this.pointEntities.findIndex(item => item.uniqueId === clickedEntityId);
            if (indexToRemove !== -1) {
              this.pointEntities.splice(indexToRemove, 1);
            }
            this.viewer.entities.remove(clickedEntity);
            this.updatePointLabels();
          }
        } else {
          var indexToRemove = this.measurmentTooltipEntities.findIndex(function (entity) {
            return entity.id === clickedEntityId;
          });

          if (indexToRemove !== -1) {           
            var entityToRemove = this.viewer.entities.getById(clickedEntityId+'line');           
            if (entityToRemove) {
              this.viewer.entities.remove(this.measurmentTooltipEntities[indexToRemove]);
              this.measurmentTooltipEntities.splice(indexToRemove, 1);
              this.measurmentEntities.splice(indexToRemove, 1);
              this.viewer.entities.remove(entityToRemove);
            }
          }
        }
      } else {    
         if (this.taskStrategy === 'TLE Based Tasking' && this.pointEntities.length >= 1) {
        const msg =
          'For TLE Based Tasking, only one POI is allowed. Click the existing pin to remove it, then place a new one.';
        this.popupService.openPopup(WarningPopup, msg, '', '50%');
        return; 
      }  else if (this.pointEntities.length >= 3) {
        const msg = 'The maximum number of points for multiple points of interest (POIs) tasking is three.';
        this.popupService.openPopup(CollectionPopupComponent, msg, '', '50%');
        return; 
      }  
        pointEntity = this.viewer.entities.add({
          id: uniqueId,
          position: Cesium.Cartesian3.fromDegrees(lng, lat),
          billboard: {
            image: 'assets/images/marker-icon.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 20,
            height: 30,
            pixelSize: 50,
          },
          label: {
            text: '',
            font: '14pt sans-serif',
            fillColor: Cesium.Color.WHITE,
            outlineColor: Cesium.Color.BLACK,
            outlineWidth: 2,
            style: Cesium.LabelStyle.FILL_AND_OUTLINE,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            pixelOffset: new Cesium.Cartesian2(0, -35) // Adjust this offset as needed
          }
        });
        pointEntity.type = 'POI';
        poiWkt = `POINT (${lng.toFixed(accuracy)} ${lat.toFixed(accuracy)})`;
        this.pointEntities.push({ poiWkt: poiWkt, uniqueId: pointEntity?.id });
        this.updatePointLabels();
      }

      this.pointArray = [];
      this.target.geoJSON = '';
      this.target.geotargets = null;

      for (const items of this.pointEntities) {
        this.pointArray.push(items.poiWkt);
      }

      if (this.currentUser?.isTaskableAoi) {
        const pointCoordinates = geoParse(this.pointArray[this.pointArray.length - 1]).coordinates;

        const isInside = this.currentUser.taskableAoi.some(aoi =>
          this.utilsService.pointInPolygon(pointCoordinates, aoi.taskableAoi.coordinates[0])
        );
        if (!isInside) {
          const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
          const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

          dialogRef.afterClosed().subscribe(() => {
            this.resetMap();
          });
        }
      }
      
      this.target.area = 0;
      if (this.pointArray?.length === 1) {
        this.target.geoJSON = this.pointArray[0];
        this.target.multiTarget = [];
      } else {
        this.target.multiTarget = this.pointArray;
        this.target.geoJSON = this.pointArray.join(', ');
        const geoPoints = this.geoParsePoint(this.target.geoJSON);        
        this.target.geotargets = JSON.stringify(geoPoints);
        if (
          this.target?.multiTarget?.length === 4 &&
          !this.currentUser.pointsEligible &&
          !this.budget) {
          const message = `The maximum number of points for multiple points of interest (POIs) tasking is three.`;
          this.popupService.openPopup(CollectionPopupComponent, message, '', '50%');
        }
      }
      this.target.fileName = '';
      this.getCountryAndPlace(lat, lng,'search');
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);
  }

  updatePointLabels() {
    this.removeCircles();  
    if (!this.currentUser.pointsEligible && !this.budget) {
      this.pointEntities.forEach((entity, index) => {
        const point = this.viewer.entities.getById(entity.uniqueId);
        if (point && point.label && point?.type === 'POI' && this.pointEntities?.length > 1) {
          point.label.text = (index + 1).toString();
        } else if (point && point.label && point?.type === 'POI' && this.pointEntities?.length === 1) {
          point.label.text = '';
        }
      });
    }


  // Add hover effect for each point
  const handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
  handler.setInputAction((movement) => {
    var hoverEntity = this.viewer.scene.pick(movement.endPosition);
    
    if (Cesium.defined(hoverEntity) && hoverEntity.id) {
      const point = this.viewer.entities.getById(hoverEntity.id.id);
      if (point && point.label && point?.type === 'POI') {
        point.label.text = "Click to remove";
        point.label.show = true;
      }
    } else {
      // Revert labels to index numbers or empty based on the point count
      this.pointEntities.forEach((entity, index) => {
        const point = this.viewer.entities.getById(entity.uniqueId);
        if (point && point.label && point?.type === 'POI') {
          if (this.pointEntities?.length > 1) {
            point.label.text = (index + 1).toString();
          } else if (this.pointEntities?.length === 1) {
            point.label.text = '';
          }
        }
      });
    }
  }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
  }

  geoParsePoint(wkt: string) {
    const regex = /POINT \(([^)]+)\)/g;
    const points: { type: string; coordinates: [number, number] }[] = [];
    let match;

    while ((match = regex.exec(wkt)) !== null) {
      const coordinates = match[1].split(' ').map(parseFloat);
      points.push({
        type: "Point",
        coordinates: [coordinates[0], coordinates[1]]
      });
    }

    return points;
  }

  sensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      resolution: '',
      cloudCover: '',
      updateFrequency: '',
      latency: '',
      budget: '',
      intent: ''
    });

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';
     let sensorObj = {
        sensorType: event.value,
        target: target,
      }

    let intent = this.target?.intent?.key ? this.target?.intent.key : this.target?.intent;

    if(event.value !== 'AIS') {
      this.apiService.getSensorDetails(sensorObj).subscribe((res: any) => {
        this.outComesensor = res;
        const cloudC: any = [];
        if (res.cloudCover) {
          for (var key in res.cloudCover) {
            cloudC.push({ key, value: res.cloudCover[key] });
          }
          this.outComesensor.cloudCover = cloudC;

          if (this.outComesensor?.cloudCover?.length === 0) {
            this.outComeForm.get('cloudCover').disable();
          } else {
            this.outComeForm.get('cloudCover').enable();
          }
        }
      });
    }
  }
  sensorTypeChangeTle(event: any){
     this.tleSensorForm.patchValue({
      sensorType : event,
      resolution: "",
      sensor:'',
    });
     this.showtleClick = false;
     this.showtleDisabled = false;
     this.apiService.getBudgetResolutionDetails(event, this.target.intent, this.currentUser.id, 'TLE Based Tasking', this.target.area).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        let resolutions = res.response;
        this.tleSensor.resolution = resolutions;

      }
     
    });
    this.clearTLEOnly();
    
  }
  resolutionChangeTle(event:any){
 this.tleSensorForm.patchValue({
      resolution: event,
      sensor:'',
    });
     this.showtleClick = false;
     this.showtleDisabled = false;
    const sensorObj = {
     intent: this.target?.intent?._id,
     userid: this.userid,
     sensorType: this.tleSensorForm.value?.sensorType,
     resolution: event,
    }
     this.apiService.getSensorDetailsTle(sensorObj).subscribe((res: any) => {
        let sensors = res?.filteredSensors;
        if(sensors?.length > 0) {
        this.tleSensor.sensor = sensors;
        } else{
         const message = 'No sensors are meeting the selected resolution. Please change the resolution and try again.';
       const dialogRef = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        dialogRef.afterClosed().subscribe((result) => {
       this.tleSensorForm.get('resolution')?.setValue('');
       this.tleSensorForm.get('resolution')?.markAsPristine();
       this.tleSensorForm.get('resolution')?.markAsUntouched();
       this.tleSensor.sensor = [];

    });
        
      }
    });
    this.clearTLEOnly();

  }
   sensorChangeTle(event: any){
   const matchedSensor = this.tleSensor.sensor?.find((s) => {
  return this.currentUser?.obfuscated
    ? s.obfuscateName === event
    : s.sensorName === event;
});
  if (matchedSensor) {
     this.selectedSensorObfuscatedName = matchedSensor
  } 
   this.clearTLEOnly();
    this.showtleClick = false;
    this.showtleDisabled = false;
    
  }
  clearTLEOnly(): void {
  const ents = this.viewer.entities.values;
  for (let i = ents.length - 1; i >= 0; i--) {
    const e: any = ents[i];
    if (this.isTLEEntity(e)) {
      this.viewer.entities.remove(e);
    }
  }
  const sources = (this.viewer.dataSources as any)?._dataSources?.slice?.() ?? [];
  for (const ds of sources) {
    if ((ds as any).isTLE) {
      this.viewer.dataSources.remove(ds, true);
    }
  }
}
  OpenSatTracking(){
    this.mapLoading = true;
    this.showtleClick = true;
    this.showtleDisabled = true;
    this.spinnerService.show();
   this.getSatelliteData();
  }
  getSatelliteData() {
    let sensor = this.selectedSensorObfuscatedName
    let sensorName, sensorInfo;
    
      sensorName = [sensor?.sensorName];
      sensorInfo = [{ key: sensor?.sensorName, obfuscateName: sensor?.obfuscateName }];
    
    let sensorData = {};
    sensorData['sensorName'] = sensorName;
    sensorData['sensors'] = sensorInfo;
    sensorData['action'] = 'projectedData';

      let target = this.target;
      // hardcoded value for testing
//       const openWindow = moment().add(1, 'hour');
// const closeWindow = moment(openWindow).add(2, 'minutes');

// sensorData['openWindow'] = openWindow.utcOffset(0, true).format();
// sensorData['closeWindow'] = closeWindow.utcOffset(0, true).format();

      sensorData['openWindow'] = moment(target.openWindow)
        .utcOffset(0, true)
        .format();
      sensorData['closeWindow'] = moment(target.closeWindow)
        .utcOffset(0, true)
        .format();
      sensorData['target'] = JSON.stringify(geoParse(target.geoJSON));
    

    const sensorObj = { sensorData: sensorData };
    if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
    }
   this.satelliteDataSubscription = this.apiService.getSatelliteData(sensorObj).subscribe((res: any) => {
      if (res?.msg === 'Failed') {
        this.mapLoading = false;
        this.showtleClick = false;
        this.showtleDisabled = false;
        this.spinnerService.hide();
        const message = 'There are no active satellites for the chosen provider at this time. Please select another.';
        this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
      } else this.plotSatellitePath(res);
    });
  }

  plotSatellitePath(result: any) {
    if (result?.length > 0) {
      for (let i = 0; i < result.length; i++) {
        let satelliteData = result[i];
        let satellite = satelliteData;
        const ORBIT_HEIGHT = 1000;
     const [endLon, endLat] = satellite.position?.[satellite.position.length - 1] ?? [satellite.longitude, satellite.latitude];

        let satelliteEntity = this.viewer.entities.add({
          name: 'orbit',
          type: 'ORBIT',          
      noRemoveOnClick: true,   
          position: Cesium.Cartesian3.fromDegrees(
            satellite.longitude,
            satellite.latitude,
          ),
          billboard: {
            image: 'assets/images/satellite.png',
            show: true,
            eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0),
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            alignedAxis: Cesium.Cartesian3.ZERO,
            width: 25,
            height: 20,
             disableDepthTestDistance: 0,
        heightReference: Cesium.HeightReference.CLAMP_TO_GROUND,
          },
          label: {
            text:  ((this.currentUser?.obfuscated && satellite.obfuscateName) ? satellite.obfuscateName : satellite.name) + '\n' + satellite.time,
            font: '11px Barlow',
            fillColor: Color.YELLOW,
            outlineColor: Color.YELLOW,
            outlineWidth: 1,
            style: 2,
            pixelOffset: new Cesium.Cartesian2(0, 10),
          },
          satellitesToRemove: true,
        });

        let randomColor = 'YELLOW';
        let key = this.selectedSensorObfuscatedName.sensorName;
        if (key === OPERATORS.CAPELLA) {
          randomColor = 'YELLOW';
        } else if (key === OPERATORS.SATELLOGIC) {
          randomColor = 'YELLOWGREEN';
        } else if (key === OPERATORS.UMBRA) {
          randomColor = 'BLUE';
        } else if (key === OPERATORS.HEAD) {
          randomColor = 'GREENYELLOW';
        } else if (key === OPERATORS.STE) {
          randomColor = 'BLUEVIOLET';
        } else if (key === OPERATORS.AT21) {
          randomColor = 'GREEN';
        } else if (key === OPERATORS.KOMPSAT) randomColor = 'CYAN';
        else if (key === OPERATORS.USL) randomColor = 'INDIGO'; 
        else if (key === OPERATORS.ISI) randomColor = 'TURQUOISE'; 
        else if (key === OPERATORS.AXELSPACE) randomColor = 'GOLD';
        else if (key === OPERATORS.GHG) randomColor = '#25aae0'; 
        else if (key === OPERATORS.ORORATECH) randomColor = '#008B8B'; 
        else if (key === OPERATORS.WYVERN) randomColor = 'Brown'; 
        else if (key === OPERATORS.SPIRE) randomColor = 'Plum'; 
        else if (key === OPERATORS.CLYDE) randomColor = '#BC8F8F'; 
        else if (key === OPERATORS.SYNSPECTIVE) randomColor = 'GREEN'; 
        else if (key === OPERATORS.GOKTURK) randomColor = '#9ce49c'; 
        else if (key === OPERATORS.LBAND) randomColor = 'Violet'; 
        else if (key === OPERATORS.ECURS || key === OPERATORS.ECURS_L) randomColor = 'Aqua'; 
        else if (key === OPERATORS.ESPER) randomColor = 'DeepPink'; 
        else randomColor = 'ROYALBLUE';

        // Render orbital path     
        let orbitalPath = this.viewer.entities.add({
           name: 'orbit',
           type: 'ORBIT',
      noRemoveOnClick: true,   
          polyline: {
             positions: Cesium.Cartesian3.fromDegreesArrayHeights([
          satellite.longitude, satellite.latitude, ORBIT_HEIGHT,
          endLon,      endLat,     ORBIT_HEIGHT
        ]),
            width: 5,
             material: new Cesium.PolylineArrowMaterialProperty(
              Cesium.Color.fromCssColorString(randomColor)
            )
          },
          satellitesToRemove: true
        });
        this.mapLoading = false;
        this.spinnerService.hide();
        this.viewer.flyTo(this.viewer.entities);

      }
    }
  }


  updateRfSignalsControl(event: any) {
  if (this.selectedCategory === this.nonImagingSensor && event?.value?.sensor === this.rfType) {
    if (!this.budgetForm.contains('rfSignals')) {
      this.budgetForm.addControl('rfSignals', new FormControl([]));
    }
  } else {
    if (this.budgetForm.contains('rfSignals')) {
      this.budgetForm.removeControl('rfSignals');
    }
  }
}

  budgetSensorChange(event: any) {
    //this.resolutionRequired = true;
    if ( event?.value?.sensor === 'GHG' && this.target?.multiTarget?.length > 1) { 
      const message = `GHG is only available for a point of interest (POI).`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.outComeSubmit = false;
      this.budgetForm.get('sensorType')?.reset();
      return;
    }
    this.closePanels();
    let target: any;
    this.budgetForm.patchValue({
      resolution: '',
      cloudCover: '',
      taskingTier:'',
      holdBack: '',
      updateFrequency: '',
    });
    this.resetRfSignals();
    this.updateRfSignalsControl(event)

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI'; 
    this.updateFrequencyOption = event?.value?.sensor === this.aisType;
    if (event?.value?.sensor === this.rfType) {
      this.signalOfInterest = true;
    }
    let intent = this.target?.intent;
    if (this.budgetForm.value.sensorCategory == this.imagingSensor) {
      this.apiService.getBudgetResolutionDetails(event.value, intent, this.userid, false, this.target.area, this.target.multiTarget).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          let resolutions = res.response;
          this.budgetInputs.resolutionArr = resolutions.sort((a, b) => this.sortResolutions(a, b));
          this.budgetInputs.resolutionArr = this.budgetInputs.resolutionArr.filter(item => item.key !== 'Both');
        }
      });
    } else {
      if (event?.value?.sensor === this.rfType) {
        if ( this.target?.geoJSON == null || this.target?.geoJSON == '') {
          const message = `Please select a target location to proceed with RF Signals selection.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return;
        }
        let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
        const sensorObj = {
          target: targetType,
        }
        this.apiService.getRFSignals(sensorObj).subscribe((res: any) => {
          if (res?.msg === 'Success') {
            this.budgetInputs.rfSignals = res.response;
            this.updateOptions()
          }
        });
      }
      let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
      this.apiService.getBudgetTierDetails(this.budgetForm?.value?.sensorType,null,this.selectedCategory,this.target.selectedOption, this.target.multiTarget, targetType).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          let seen = new Map();
          res.response.forEach(item => {
            let lowerItem = item?.name.toLowerCase();
            if (!seen.has(lowerItem)) {
                seen.set(lowerItem, item);
            }
          });
          let uniqueTierArr = Array.from(seen.values());
          this.budgetInputs.tierArr =uniqueTierArr;
          this.updateOptions()
        }
      });
    }
  }

  sortResolutions(a, b) {
    const aIsNumeric = /^[0-9.]+m$/.test(a.key);
    const bIsNumeric = /^[0-9.]+m$/.test(b.key);

    if (aIsNumeric && bIsNumeric) {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    } else if (aIsNumeric) {
      return -1;
    } else if (bIsNumeric) {
      return 1;
    } else {
      return this.extractNumericValue(a.key) - this.extractNumericValue(b.key);
    }
  }

  extractNumericValue(text: string): number {
    const match = text.match(/(\d+(\.\d+)?)/);
    return match ? parseFloat(match[0]) : Number.MAX_VALUE;
  }

  sensorWarning(event) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI'){
      if (event.value.key === '5.3m') {
        const message =`
        <ol>
          <li>Each line in the area of interest (AOI) must be at least 5km and no more than 25km long.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.</li>
          <li>The area of interest (AOI) requested should at least be 100 sqkm for the standard tasking and 50 sqkm for the priority tasking.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      } else if (event.value.key === '10m'){
        const message = `
        <ol>
          <li> The sensor does not have holdback selection options.</li>
          <li> Only period-based collection orders are supported at this time. Recurrent and specific date orders are not available.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'GHG') {
      const message =`
      <ol>
        <li>Recurrence selection is limited to monthly at this time.</li>
        <li>The Time of Interest (TOI) must be at least 30 days.</li>
        <li>Specific date tasking is not supported at this time.</li>
      </ol>`;
      this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      return;
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'SAR') {
      if (event.value.key === '0.25m' || event.value.key === '0.5m' || event.value.key === '1.2m') {
        const message =`
        <ol>
          <li>Standard tasking requires a minimum seven day Time of Interest (TOI).</li>
          <li>Priority tasking requires a minimum three day TOI.</li>
          <li>Rush tasking requires a minimum one day TOI.</li>
          <li>The start date must be within 90 days from today.</li>
          <li>The Time of Interest (TOI) cannot exceed 30 days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '0.35m') {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let KomsatArr = ['0.85m', '2.5m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
      if (KomsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'MSI') {
      if (event.value.key === '0.5-0.7m') {
        const message =`
        <ol>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>Only POI (Point of Interest) tasks over open waters are supported. AOI (Area of Interest) tasks are not allowed.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for AOI tasks.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Super Resolution (SR):0.5m' || event.value.key === 'Ground Sample Distance (GSD):0.7m') {
        const message =`
        <ol>
          <li>Tasking over open waters is not supported.</li>
          <li>Only 2 sub-daily collections are allowed at this time.</li>
          <li>For areas smaller than 50 sqkm, please task with a single POI.</li>
          <li>Rush tasking tier is not supported for AOI tasks.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '2.5m TCI' || event.value.key === '5m MS') {
        const message =`
        <ol>
          <li>Specific date and recurrent frequency are not supported at this time.</li>
          <li>Only AOI (Area of Interest) orders are supported.</li>
          <li>The start date must be at least one day from the current date, and the Time of Interest (TOI) must be 14 days or less from the current date.</li>
          <li>The minimum task area is 100 sqkm.</li>
          <li>If the AOI is greater than 900 sqkm, each AOI must be within 30 km in both length and width.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '0.5m TCI') {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Pan-sharpened:0.52m' || event.value.key === 'Bundle:0.52m PAN+2.08m MS') {
        const message =`
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>Only POI (Point of Interest) orders are supported.</li>
          <li>The start date must be at least 24 hours or 48 hours from the current date.</li>
          <li>Up to 2 sub-daily collections are allowed.</li>
          <li>Tasking is limited to the latitude range of -13 to 13.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === '2.5m' || event.value.key === '0.4m' || event.value.key === '0.92m') {
        const message =`
        <ol>
          <li>Recurrency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let komsatArr = ['0.85m', '1m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
       if (komsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'MSI' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      if (event.value.key === '0.83-0.94m') {
        const message =`
        <ol>
          <li>Only POI (Point of Interest) orders are supported.</li>
          <li>Up to 4 sub-daily collections are allowed, and sub-daily tasking is only available for a minimum of seven days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key === 'Pan-sharpened:0.5m' || event.value.key === "Bundle:0.5m PAN/2m MS") {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>Each line in the Area of Interest (AOI) must be at least 5 km long.</li>
        <ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let resolutionArr = ['Pan-sharpened:0.59m', 'Bundle:0.59m PAN/2.36m MS', '0.25m', 'Pan-sharpened:0.3m', 'Bundle:0.3m PAN/1.2m MS','0.15m',
         'High Definition (HD):0.15m', 'High Definition (HD):0.25m', ];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Only period-based collection orders are supported at this time. Recurrent and specific date orders are not available.</li>
          <li>Each side of the Area of Interest (AOI) must be at least 5 km.</li>
        <ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      let msiArr = ['Pan-sharpened:0.4m', 'Bundle:0.4m PAN/1.6m MSI'];
      if (msiArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'PAN') {
      if (event.value.key === '4.6m') {
        const message =`
        <ol>
          <li>Only open water tasking is supported, and it must be limited to a single Point of Interest (POI).</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The sensor can only be tasked within the next ten days.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'InSAR' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      let komsatArr = ['0.85m', '1m', '2.5m', '20m/4 look', 'Pan-sharpened:0.8m', 'Bundle:0.8m PAN/3.2m MSI', 'Pan-sharpened:1m', 'Bundle:1m PAN/4m MSI'];
      if (komsatArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Tasking of certain government operators is not permitted over their respective countries. You may not see them included in the budgeting response.</li>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'TIR') {
      let resolutionArr = ['30m', '69m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrence selection is limited to weekly and monthly at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
      if (event.value.key=== "3.5m") {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'PAN' || this.budgetForm?.value?.sensorType.sensor === 'Stereo') {
      let resolutionArr = ['0.5m', '0.4m', 'Pan-sharpened:0.4m', 'Bundle:0.4m PAN/1.6m MSI','0.69m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
          <li>The start date must be at least 24 hours from the current date.</li>
          <li>Tasking is only allowed within the latitude range of -42 to 42.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
    if (this.budgetForm?.value?.sensorType.sensor === 'InSAR') {
      let resolutionArr = ['3m', '12m', '20m', '6m', '20m - 30m', '30m'];
      if (resolutionArr.includes(event.value.key)) {
        const message =`
        <ol>
          <li>Recurrent frequency is not supported at this time.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
        return;
      }
    }
  }

  budgetResolutionChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      taskingTier:'',
      holdBack: '',
    });
    // if (event.value.key === '5.3m' && this.budgetForm?.value?.sensorType.sensor === 'HSI'){
    //   const message =`
    //   <ol>
    //     <li>Each line in the area of interest (AOI) must be at least 5km and no more than 25km long.</li>
    //     <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
    //     <li>The start of the time of interest (TOI) must be at least three days after the submission date, and the end date must be at least 30 days after the start date of the TOI. Please change your TOI or choose an alternative provider.</li>
    //     <li>The area of interest (AOI) requested should at least be 100 sqkm for the standard tasking and 50 sqkm for the priority tasking.</li>
    //   </ol>`;
    //   this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
    // } else if (event.value.key === '10m'  && this.budgetForm?.value?.sensorType.sensor === 'HSI'){
    //   const message = `
    //   <ol>
    //     <li> The sensor does not have cloud cover and holdback selection options.</li>
    //     <li> The start of the time of interest (TOI) must be at least three days after the submission date and the end date is within 14 days from the submission date.</li>
    //   </ol>`;
    //   this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
    // }
    let targetType = this.target?.geoJSON?.includes('POINT') ? 'POI' : 'AOI';
    this.apiService.getBudgetTierDetails(this.budgetForm?.value?.sensorType,event.value?.key,this.selectedCategory, this.target.selectedOption, this.target.multiTarget, targetType).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        let seen = new Map();
        res.response.forEach(item => {
            let lowerItem = item?.name.toLowerCase();
            if (!seen.has(lowerItem)) {
                seen.set(lowerItem, item);
            }
        });
        let uniqueTierArr = Array.from(seen.values());
        this.budgetInputs.tierArr =uniqueTierArr;
        this.updateOptions()
      }
    });
  }

  budgetTierChange(event: any) {
    this.closePanels();
    this.budgetForm.patchValue({
      cloudCover: '',
      holdBack: '',
    });
   
    this.apiService.getBudgetCcandHoldbackDetails(this.budgetForm?.value?.sensorType,this.budgetForm?.value?.resolution,event.value.key,this.selectedCategory, this.target.multiTarget).subscribe((res: any) => {
      if (res?.msg === 'Success') {
        res.response.cloudCoverKeys =  res.response.cloudCoverKeys.sort((a, b) => parseInt(a) - parseInt(b));
        this.budgetInputs.cloudCoverKeys =   res.response.cloudCoverKeys.sort((a, b) => parseInt(a) - parseInt(b));
        this.budgetInputs.holdbackArr = this.sortArray([...res.response.holdbackArr]);
        this.updateOptions()
      }
    });
  }

  isAnyFieldEmpty(): boolean {
    const requiredFields = 
    this.target.taskStrategy === 'Outcome By Platform' && this.outComeForm?.value?.sensorType?.name === 'AIS'
      ? ['sensorType', 'updateFrequency', 'budget', 'latency']
      : this.target.taskStrategy === 'Outcome By Platform' && this.outComeForm?.value?.sensorType?.name !== 'AIS'
        ? ['sensorType', 'resolution', 'budget', 'latency', 'intent']
        : Object.keys(this.outComeForm.controls).filter(key => key !== 'cloudCover');
  
    for (const key of requiredFields) {
      if (key != 'cloudCover') {
        const controlValue = this.outComeForm.get(key).value;
        if (controlValue === null || controlValue === undefined || controlValue === '') {
          return true;
        }
      }
    }
    return false;
  }

  submit() {
    let newTaskParams = {};
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate =  moment(this.target.closeWindow).utcOffset(0, true).format();
    let time_difference = new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    const currentDate: any = new Date();
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getTimezoneFromCountry(this.currentUser.country);

    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      }
      else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      }
      else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }
    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['taskname'] = this.target.taskname;
    newTaskParams['purpose'] = this.target?.purposeOption;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (this.target.geotargets != null) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    if(this.taskStrategy !== "TLE Based Tasking"){
    newTaskParams['geometryCentroid'] = this.target?.geometryCentroid;
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] = this.taskStrategy === "TLE Based Tasking" ? 2 : this.target.selectedOption;
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    if (this.taskStrategy !== 'TLE Based Tasking'){
    newTaskParams['mode'] = this.target.mode;
    newTaskParams['expected_age'] = this.expectedAge;
    newTaskParams['circleCordinates'] = this.target.circleCordinates;
    }
  
    newTaskParams['openWindow'] = moment(this.target.openWindow).utcOffset(0, true).format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow).utcOffset(0, true).format();
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
    .tz(userTimezone)
    .format();
  
   newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
    .tz(userTimezone)
    .format();
    newTaskParams['projectid'] = this.target?.projectId;
    newTaskParams['taskStrategy'] = this.target?.taskStrategy;
    newTaskParams['tipAndCueBasedOn'] = this.target?.tipAndCueBasedOn;
    newTaskParams['observation'] = this.target?.observation;
    newTaskParams['rule'] = this.target?.rule;
    newTaskParams['intent'] = this.target?.intent;
    if(this.taskStrategy !== 'TLE Based Tasking'){
    newTaskParams['cloudCover'] = this.target?.cloudCover;
    newTaskParams['taskSubStrategy'] = this.target?.taskSubStrategy;
    }
    newTaskParams['openWater'] = this.target?.openWater;
    newTaskParams['feeds'] = this.target?.feeds;
    newTaskParams['observationData'] = this.target?.observationData;
    newTaskParams['isReTask'] = this.target?.isRetask;
    if(this.taskStrategy === 'TLE Based Tasking'){
      newTaskParams['sensorId'] = this.retask ? this.selectedTasks?.request[0]?.sensorId : this.selectedSensorObfuscatedName?.sensorId;
    }

    if(this.target?.taskStrategy == "Help Select Sensor(s)"){
      newTaskParams['useCase'] = this.target?.useCase;
      newTaskParams['useCaseDescription'] = this.target?.useCaseDescription;
    }
    if (this.retask && this.taskStrategy !=='TLE Based Tasking') {
      let totalAmount = 0;
      for (const item of this.selectedTasks.request) {
        item.feasibilityId = null;
        item.firstCapture = null;
        item.isQueuedTime = null;
        item.lastCapture = null;
        item.orderStatus = null;
        item.queuedTime = null;
        item.uuid = null;
        item.status = null;
        item.statusHistory = null;
        item.taskid = null;
        item.resolution = {
          value: item?.name === 'GRUS' ? item?.originalResolution : item?.resolution,
          mode_value: item?.resolutionTooltip,
          resolution_value: item?.name === 'GRUS' ? item?.originalResolution : item?.resolution,
          originalResolution:item?.originalResolution,
          ...( item?.originalResolution === 'Both' ? { combinedResolution : item?.resolution } : {} )
        },

        item.retaskingTooltip = [];
        item.feedData = [];
        item.pay = false;
        item.refund = false;
        item.orderNumber = null;

        ['approverDetails', 'ordererDetails', 'cancelerDetails', 'rejecterDetails', 'approved_by', 'ordered_by',
          'canceled_by','approval_rejected_details'
        ]
        .forEach(key => {
          if (item.hasOwnProperty(key)) {
            delete item[key];
          }
        });

        if (item.sensortype === 'GHG') {         
          let annualCost = 0;
          let targetLength = 1
          if (this.target?.geotargets) {
            targetLength = JSON.parse(this.target?.geotargets)?.length > 0 ? this.target.multiTarget.length : 1;
          }

          const keyToMatch = item.latency.key; // Extract the key
          let ghgCost = null;

          // Find the matching cost
          for (const items of item.collectionMode[0].cost) {
            if (items[keyToMatch] !== undefined) {
              ghgCost = items[keyToMatch];
              break;
            }
          }

          if(ghgCost) {
          if (item.collectionMode[0].captureMode.includes('annual')) {
            let monthlyCost = ghgCost / 12;
            if (noOfMonths > 12) {
              if (noOfMonths % 12 === 0) {
                annualCost = (noOfMonths / 12) * ghgCost;
              } else {
                annualCost = ghgCost + ((noOfMonths - 12) * monthlyCost);
              }
            } else {
              annualCost = ghgCost;
            }
            item.cost = parseFloat((annualCost).toFixed(2))
          } else {
            annualCost = ghgCost * noOfMonths;
            item.cost = parseFloat((annualCost).toFixed(2))
          }
          if (!item.collectionMode[0].captureMode.includes('Complex')) {
            annualCost = annualCost * targetLength;
            item.cost = parseFloat((annualCost).toFixed(2))
          }
        }
        }
        else if (this.target.selectedOption === 1 && item.multiplierCost) {
          item.cost = parseFloat((item.multiplierCost * no_of_repeats).toFixed(2))
        }
      }

      this.selectedTasks.request = this.selectedTasks.request.map(sensor => {
        let tNumber = 0;
        if (this.currentUser?.allocated) {
            if (sensor.isPoint === true) {
                tNumber = 1 * no_of_repeats;
                this.totalTaskNumber += tNumber;
            } else {
                if (sensor.unit === 'sqkm' || sensor.unit === 'scene' || sensor.unit === 'week' || sensor.unit === 'day') {
                    tNumber = (Math.ceil(sensor.areacalc / sensor.minimumArea) * no_of_repeats);
                    this.totalTaskNumber += tNumber;
                }
            }
        }
        const p =  this.currentUser.pointsEligible ? this.convertCostToPoints(sensor.cost,false) : 0;
        return {
            ...sensor,
            point: p,
            taskNumber: tNumber
        };
    });

      totalAmount = this.selectedTasks.request.reduce((a, { cost }) => a + cost, 0);
      this.taskPoint = this.currentUser.pointsEligible ? this.selectedTasks.request.reduce((total, sensor) => {
        return total + this.convertCostToPoints(sensor.cost,false);
      }, 0) : 0;
      newTaskParams['taskcost'] = totalAmount.toFixed(2);
      newTaskParams['sensors'] = JSON.stringify(this.selectedTasks.request);
      newTaskParams['feasibilityTask'] = this.selectedTasks?.feasibilityTask;
      newTaskParams['collectionStart'] = this.selectedTasks?.collectionStart;
      newTaskParams['collectionEnd'] = this.selectedTasks?.collectionEnd;
      newTaskParams['taskPoints'] = this.taskPoint;
      newTaskParams['totalTaskNumber'] = this.totalTaskNumber;

      if (this.target?.taskStrategy === 'Outcome By Platform') {
        newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible ? this.selectedTasks?.outComeBudget : 0;
        newTaskParams['outComeBudget'] = this.currentUser.pointsEligible ? this.convertToCost(this.selectedTasks?.outComeBudget) : this.selectedTasks?.outComeBudget;
        // newTaskParams['outComeBudget'] = this.selectedTasks?.outComeBudget;
        newTaskParams['outComeCloudCover'] = this.selectedTasks?.outComeCloudCover;
        newTaskParams['outComeLatency'] = this.selectedTasks?.outComeLatency;
        newTaskParams['outComeResolution'] = this.selectedTasks?.outComeResolution;
        newTaskParams['outComesensorType'] = this.selectedTasks?.outComesensorType;
        newTaskParams['outcomeUpdateFrequency'] = this.outComeForm?.value?.updateFrequency;
        newTaskParams['outcomeIntent']= this.target?.intent;

        //Popup details
        newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
        newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
        newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
        newTaskParams['noOfHistoricalData'] = this.outcomePopUpData?.noOfHistoricalData;
      }
      this.apiService.newTaskSubmit(newTaskParams).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          let data = JSON.parse(res?.response);
          let taskid;
          let sensorList = this.matchUUIDs(newTaskParams['sensors'], data);
          newTaskParams['sensors'] = JSON.stringify(sensorList);
          if (data && data.length > 0) {
            taskid = res?.taskid;
            newTaskParams['taskId'] = taskid;
            this.apiService
              .genCollection(
                this.currentUser.id,
                this.currentUser.email,
                newTaskParams
              )
              .subscribe((res: any) => {
                const taskid = res?.id;
              });
          }
          const dialogRef = this.dialog.open(ConfirmDialog, {
            backdropClass: 'blurr', disableClose: true,
            data: { taskid: taskid, taskname: this.target.taskname, response: res, type: 'normal',from:'task' },
          });
        }
      }, (error: any) => {
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '50%', backdropClass: 'blurred', disableClose: true,
          data: { message: "fail",url:"/task" }
        });
      });

    } else {
      if (
      this.target?.multiTarget?.length > 1) { 
      const message = `Multiple points of interest (POIs) tasking is only available for user initiated tasking strategy at this time.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      this.outComeSubmit = false;
      return;
    }

      this.outComeForm.value.budget = parseFloat(this.outComeForm?.value?.budget)
      this.outComeForm.value.sensorType = this.outComeForm?.value?.sensorType.name;

      newTaskParams['outComeBudgetPoint'] = this.currentUser.pointsEligible ? parseFloat(this.outComeForm.value.budget.toFixed(2)) : 0;
      newTaskParams['outComeBudget'] = this.currentUser.pointsEligible ? this.convertToCost(parseFloat(this.outComeForm.value.budget.toFixed(2))): parseFloat(this.outComeForm.value.budget.toFixed(2));
      // newTaskParams['outComeBudget'] = parseFloat(this.outComeForm.value.budget.toFixed(2));
      if(this.taskStrategy !== "TLE Based Tasking"){
        newTaskParams['outComeCloudCover'] = this.outComeForm?.value?.cloudCover;
      }
      newTaskParams['outComeLatency'] = this.taskStrategy !== "TLE Based Tasking" ? this.outComeForm?.value?.latency : this.getWindowDiffInHours(this.target.openWindow, this.target.closeWindow) ;
      newTaskParams['outComeResolution'] = this.taskStrategy === "TLE Based Tasking" ?  this.parseResolutionValues(): this.outComeForm?.value?.resolution;    
      newTaskParams['outComesensorType'] = this.taskStrategy === "TLE Based Tasking" ? this.tleSensorForm?.value?.sensorType  : this.outComeForm?.value?.sensorType;

      if(this.taskStrategy === 'Tip-and-Cue' && this.subStrategy === 'Tip-and-Cue-Outcome') {
        newTaskParams['outComesensorType'] = [
          {
            'sensor' :  this.outComeForm?.value?.cueingSensorType?.name,
            'sensorType' : 'Cueing',
          },
          {
            'sensor' : this.outComeForm?.value?.tippingSensorType?.name,
            'sensorType' : 'Tipping',
          }
        ];
        newTaskParams['tippingSensorResolution'] = this.outComeForm?.value?.tippingSensorResolution;
        newTaskParams['cueingSensorResolution'] = this.outComeForm?.value?.cueingSensorResolution;
        newTaskParams['tippingSensorCloudCover'] = this.outComeForm?.value?.tippingCloudCover;
        newTaskParams['cueingSensorCloudCover'] = this.outComeForm?.value?.cueingCloudCover;
      }
      if(this.taskStrategy !== 'TLE Based Tasking'){
       newTaskParams['taskStrategy'] = this.subStrategy ? this.subStrategy : this.target?.taskStrategy;
      }
      newTaskParams['outcomeUpdateFrequency'] = this.outComeForm?.value?.updateFrequency;
      newTaskParams['outcomeIntent']= this.target?.intent;
    if(this.target.taskStrategy !== "TLE Based Tasking"){
    //Popup details
      newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
      newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
      newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
      newTaskParams['noOfHistoricalData'] = this.outcomePopUpData?.noOfHistoricalData;
    }
      this.apiService.outcomeTaskSubmit(newTaskParams).subscribe((res: any) => {
        if (res?.msg === 'Success') {
          let taskid;
          taskid = res?.taskid;
          newTaskParams['taskId'] = taskid;

          const dialogRef = this.dialog.open(ConfirmDialog, {
            backdropClass: 'blurr', disableClose: true, width: '40%',
            data: { taskid: taskid, taskname: this.target.taskname, response: res, type: 'outcome',from:'outcome' },
          });
        } else if (res?.msg === 'Failed' && res?.message) {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%', backdropClass: 'blurred', disableClose: true,
            data: { message: "outcomeFail", response: res?.message ,url:"/task"}
          });
          if (this.target?.taskStrategy === 'Outcome By Platform') {
              this.resetOutcomeDefined();
          } else {
            this.resetOutcome();
          }
        } else {
          const dialogRef = this.dialog.open(CountrycheckComponent, {
            width: '40%', backdropClass: 'blurred', disableClose: true,
            data: { message: "fail",url:"/task" }
          });
        }
        if (this.target?.taskStrategy === 'Outcome By Platform') {
          this.resetOutcomeDefined();
        } else {
          this.resetOutcome();
        }
      }, (error: any) => {
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '40%', backdropClass: 'blurred', disableClose: true,
          data: { message: "fail",url:"/task" }
        });
        this.resetOutcome();
      });
    }
  }

  getWindowDiffInHours(openWindow: string | Date, closeWindow: string | Date): number {
  const openWindowMoment = moment(openWindow).utcOffset(0, true);
  const closeWindowMoment = moment(closeWindow).utcOffset(0, true);
  return closeWindowMoment.diff(openWindowMoment, 'hours', true);
}

  parseResolutionValues() {
  const resolution = this.tleSensorForm?.value?.resolution;
  
  if (!resolution) {
    return {
      key: resolution,
      minValue: resolution,
      maxValue: resolution
    };
  }
  if (resolution.includes('-')) {
    const rangeMatch = resolution.match(/(\d+\.?\d*)-(\d+\.?\d*)/);
    
    if (rangeMatch) {
      const minVal = parseFloat(rangeMatch[1]);
      const maxVal = parseFloat(rangeMatch[2]);
      
      return {
        key: resolution,
        minValue: minVal,
        maxValue: maxVal
      };
    }
  }
  
  return {
    key: resolution,
    minValue: resolution,
    maxValue: resolution
  };
}

  convertCostToPoints(cost:number, includeLabel: boolean = true)
  {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
    const points =  Math.round(cost * conversionFactor);      
    return includeLabel == true ? points + ' Points' : points;
  }
  

  getCloudData(panelOpenState,index) {
    let type;
    if (this.target.geoJSON && panelOpenState) {
    let sensorData = {};
    if (index === 0) {
      this.isChecked = false;
    }
    const currentDate: any = new Date();
    sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    sensorData['openWindow'] = moment(this.target.openWindow).utcOffset(0, true).format();
    sensorData['closeWindow'] = moment(this.target.closeWindow).utcOffset(0, true).format();
 
    sensorData['type'] = 'days';
  
    const sensorObj = { sensorData: sensorData };
    this.cloudclicked = false;

    if (sensorObj?.sensorData['openWindow'] !== "Invalid date" && sensorObj?.sensorData['closeWindow'] !== "Invalid date" && sensorObj?.sensorData['target'] != 'null') {
      this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {
        this.weatherData = res?.result;
        this.hourly = true;
        this.cloudclicked = true;
      });
    }
  } 
  }
  
  getHourlyCloudData(panelOpenState,item) {
    if (this.target.geoJSON && panelOpenState) {
    let sensorData = {};
    sensorData['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    sensorData['openWindow'] = item?.date;
    sensorData['closeWindow'] = item?.date;
    sensorData['type'] = 'hours';
  
    const sensorObj = { sensorData: sensorData };  
    this.cloudclicked = false;
  
    if (sensorObj?.sensorData['openWindow'] !== "Invalid date" && sensorObj?.sensorData['closeWindow'] !== "Invalid date" && sensorObj?.sensorData['target'] != 'null') {
      this.apiService.getCloudCoverData(sensorObj).subscribe((res: any) => {      
        this.weatherData = res?.result;
        this.hourly = false;
        this.cloudclicked = true;
      });
    }
  }
  }

  openFromIcon(timepicker: NgxMaterialTimepickerComponent) {
    if (!this.formGroup.get('startTime')?.value) {
      this.updateCurrentLocalTime();
      timepicker.defaultTime = this.currentLocalTime;
    } else {
      timepicker.defaultTime = this.currentLocalTime;
    }
    timepicker.open();
  }

  openDate(timepicker: NgxMaterialTimepickerComponent) {
    if (!this.formGroup.get('endTime')?.value) {
      this.updateCurrentLocalTime();
      timepicker.defaultTime = this.currentLocalTime;
    } else {
      timepicker.defaultTime = this.currentLocalTime;
    }
    timepicker.open();
  }

onTimeSet(event: any) {
  let ustDateTime = this.onStartTimeChange(event, this.range.value.start);
  this.date = new FormControl(ustDateTime.utcStartDate);
  this.range.patchValue({
    start: ustDateTime.utcStartDate,
    end: this.range.value.end
  });

  this.range.value.start = ustDateTime.utcStartDate
  this.target['openWindow'] = this.range.value.start;
  const selectedTimeStr = ustDateTime.utcTime;
  const selectedTime = new Date("2000-01-01 " + selectedTimeStr);

  
  const startHours = selectedTime.getHours();
  const startMinutes = selectedTime.getMinutes();
  const startSeconds = selectedTime.getSeconds();  

  const openWindow = moment(this.target['openWindow']);
  const combinedDateTime = openWindow
    .set({ hour: startHours, minute: startMinutes, second: startSeconds })
    .toDate();

  this.target['openWindow'] = combinedDateTime;
  this.isPast = this.isPastDateTime(combinedDateTime);
  this.getHoursDifference();
  if(this.taskStrategy === "TLE Based Tasking"){
    this.clearTLEOnly();
    this.showtleClick = false;
     this.showtleDisabled = false;
  }
  this.apiService.updateTaskParams(this.target);

  setTimeout(() => {
    this.formGroup.patchValue({
      startTime: ustDateTime.utcTime
    });

    this.budgetForm.patchValue({
      startTime: ustDateTime.utcTime
    });
  }, 0);
  this.updateTarget(this.target, '0');
}

onEndTimeSet(event: any) {
  let ustDateTime = this.onEndTimeChange(event, this.range.value.end);
  this.range.patchValue({
    end: ustDateTime.utcEndDate
  });
  this.range.value.end = ustDateTime.utcEndDate;
  if (this.selectedOption === 0) {
    this.range.value.end = this.range.value.start;
  }
  this.target['closeWindow'] = this.range.value.end;
  const selectedTimeStr = ustDateTime.utcTime;
  const selectedTime = new Date("2000-01-01 " + selectedTimeStr);

  const startHours = selectedTime.getHours();
  const startMinutes = selectedTime.getMinutes();
  const startSeconds = selectedTime.getSeconds();

  const closeWindow = moment(this.target['closeWindow']);
  const combinedDateTime = closeWindow
    .set({ hour: startHours, minute: startMinutes, second: startSeconds })
    .toDate();

  this.target['closeWindow'] = combinedDateTime;
  this.isEndPast = this.isEarlierThan(this.target['closeWindow'], this.target['openWindow']);

  this.getHoursDifference();
  if(this.taskStrategy === "TLE Based Tasking"){
    this.clearTLEOnly();
    this.showtleClick = false;
     this.showtleDisabled = false;
     if(this.getHoursDifference() > 72){
       this.tleToiError = true;
     }else {
    this.tleToiError = false;
     } 
  }
  
  
  this.apiService.updateTaskParams(this.target);

  setTimeout(() => {
    this.formGroup.patchValue({
      endTime: ustDateTime.utcTime
    });

    this.budgetForm.patchValue({
      endTime: ustDateTime.utcTime
    });
  }, 0); 
  this.updateTarget(this.target, '0'); 
}

getHoursDifference(): number {
  const millisecondsPerHour = 1000 * 60 * 60;
  const differenceInMilliseconds = this.target['closeWindow']?.getTime() - this.target['openWindow']?.getTime();
  if(this.taskStrategy !== "TLE Based Tasking"){
   this.timeError = differenceInMilliseconds / millisecondsPerHour;
  }
  return differenceInMilliseconds / millisecondsPerHour;
}

isPastDateTime(dateTime: Date): boolean {
  const givenDate = new Date(dateTime);

  // Get the current date and time in UTC
  const nowUtc = new Date();

  // Convert the current date and time to UTC
  const currentUtcDate = new Date(
    nowUtc.getUTCFullYear(),
    nowUtc.getUTCMonth(),
    nowUtc.getUTCDate(),
    nowUtc.getUTCHours(),
    nowUtc.getUTCMinutes(),
    nowUtc.getUTCSeconds()
  );
  
  const hasPassed = givenDate.getTime() < currentUtcDate.getTime();
  return hasPassed;
}

// Method to check if one date-time is earlier than another
isEarlierThan(end: Date, start: Date): boolean {
  const date1 = new Date(end);
  const date2 = new Date(start);
  
  return date1.getTime() < date2.getTime();
}

  drawTaskableAOI(positionArray) {
    this.polygons.push(positionArray[0]);
    const polygonPoints = positionArray[0];
    // Step 2: Find the bottom-most point (minimum latitude)
    const bottomLonLat = polygonPoints.reduce((lowest, current) => {
      return current[1] < lowest[1] ? current : lowest;
    }, polygonPoints[0]);

    // Step 3: Calculate dynamic vertical shift
    const latitudes = polygonPoints.map(p => p[1]);
    const maxLat = Math.max(...latitudes);
    const minLat = Math.min(...latitudes);
    const latRange = maxLat - minLat;

    // Use 5% of the polygon's vertical height to shift the label down
    const shiftDegrees = latRange * 0.05;
    const labelLat = bottomLonLat[1] - shiftDegrees;

    // Step 4: Convert to Cesium Cartesian3
    const labelPosition = Cesium.Cartesian3.fromDegrees(bottomLonLat[0], labelLat);


    let polygon;

    this.polygons.forEach((coordinates) => {

      polygon = this.viewer.entities.add({
        name: 'allowedArea',
        polygon: {
          hierarchy: Cesium.Cartesian3.fromDegreesArray(coordinates.flat()),
          material: Cesium.Color.ORANGERED.withAlpha(0.1),
          fill: false,
          height: 0,
          outlineColor: Cesium.Color.YELLOW,
          outline: true,
        },
        position: labelPosition, // <-- this is where position belongs
        label: {
          text: 'This is your allowed tasking area',
          font: '10pt sans-serif',
          fillColor: Cesium.Color.WHITE,
          style: Cesium.LabelStyle.FILL_AND_OUTLINE,
          outlineWidth: 2,
          outlineColor: Cesium.Color.BLACK,
          showBackground: true,
          backgroundColor: Cesium.Color.BLACK.withAlpha(0.5),
        }
      });
    });
    this.viewer.flyTo(polygon, { duration: 3 });
  }
  private isTLEEntity(e: any): boolean {
  return !!(e && (e.type === 'ORBIT' || e.noRemoveOnClick === true || e.name === 'orbit'));
}

  removeEntity () {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
    const e: any = entities[i];
    if (e?.name === 'allowedArea') continue;  
    if (this.isTLEEntity(e)) continue;           
    this.viewer.entities.remove(e);
    }
  }
    removeEntityTle () {
    const entities = this.viewer.entities.values;
    for (let i = entities.length - 1; i >= 0; i--) {
      if (entities[i]?.name !== 'allowedArea') {
        this.viewer.entities.remove(entities[i]);
      }
    }
  }

  checkPointInsidePolygon(mousePoint) {
    this.shapeSelected = true;

    let isInside = this.currentUser.taskableAoi.some(aoi =>
      this.utilsService.pointInPolygon(mousePoint, aoi.taskableAoi.coordinates[0])
    );
    if (!isInside) {
      const message = `This tasking request is outside the authorised area. Please task within the allowed area.`;
      const dialogRef = this.popupService.openPopup(WarningPopup, message, '', '50%');

      dialogRef.afterClosed().subscribe(() => {
        this.resetMap();
      });
    }
  }

  loadTaskCostDetails() {
    let tipAndCueObservation = true;
    let tipAndCueRule= true;
    let tipAndCueFeed = true;
    const validDate = (this.dateFlag && this.selectedOption != 0) || this.range.value.end === null || this.isPast || this.isEndPast;

    if(this.taskStrategy === 'Tip-and-Cue') {
      if (this.subStrategy === 'Tip-and-Cue') {
        tipAndCueObservation =  this.target.observation && this.tipAndCueBasedOn === 'Observation';
        tipAndCueRule =  this.target.rule  && this.tipAndCueBasedOn === 'Rules';
        tipAndCueFeed =  this.target.feeds  && this.tipAndCueBasedOn === 'Feeds';
      }
    }
    const toiRange = (this.timeError < 4 && this.selectedOption === 0 || this.timeError < 24 && this.selectedOption != 0);
    const noUsecase = (this.taskStrategy === 'Help Select Sensor(s)' && !this.target.useCase)
  
    return (this.formGroup.valid && this.target.geoJSON?.length > 10 && !validDate && (tipAndCueObservation || tipAndCueRule || tipAndCueFeed || this.taskStrategy != 'Tip-and-Cue')
            && !toiRange && !noUsecase);
  }

  matchUUIDs(selectedSensors,taskResponse) {
    let sensorList = JSON.parse(selectedSensors);
    
    const minLength = Math.min(sensorList.length, taskResponse.length);  
    for (let i = 0; i < minLength; i++) {
      sensorList[i].uuid = taskResponse[i].uuid;
    }

    return sensorList;
  }

  budgetEnable () {
    const validDate = (this.dateFlag && this.selectedOption != 0) || this.range.value.end === null || this.isPast;
    const toiRange = (this.timeError < 4 && this.selectedOption === 0 || this.timeError < 24 && this.selectedOption != 0);
    const frequencyUpdate = (this.budget && this.displayUpdateFrequency() && !this.budgetForm.value.updateFrequency.value);
    return validDate || toiRange || frequencyUpdate;
  }

  resetForm (sensorCategoryOverride?: string) {
    this.budgetForm.reset();

    const rfSignalsControl = this.budgetForm.get('rfSignals');
    rfSignalsControl?.setValue([], { emitEvent: false });

    if (sensorCategoryOverride) {
      const sensorCategoryControl = this.budgetForm.get('sensorCategory');
      sensorCategoryControl?.setValue(sensorCategoryOverride, { emitEvent: false });
    }
    this.range.reset();
    this.resetMap();
    this.target.geoJSON = null;
    this.updateFrequencyOption = false;
    this.selectedOption = 0;
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
    this.clickFrequency = false;
    this.ensureBudgetSensorCategorySelection();
  }
  resetFormTle(){
    if(this.retask){
      if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
      this.satelliteDataSubscription = null;
    }
    this.router.navigate(['/task']); 
    }else{
 if (this.satelliteDataSubscription) {
      this.satelliteDataSubscription.unsubscribe();
      this.satelliteDataSubscription = null;
    }
    this.showtleClick = false;
    this.showtleDisabled = false;
    this.formGroup.reset();
    this.selectedOption = 2;
    this.range.reset();
    this.mapLoading = false;
    this.tleSensorForm.reset();
     this.tleSensor = {
  resolution: [],
  sensor: []
};
   this.selectedSensorObfuscatedName;
    this.resetMap('tle');
    this.target.geoJSON = null;
    this.selectedOption = 0;
         const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();
    this.date = new FormControl(new Date(year, month - 1, day + 1));
    this.range = new FormGroup({
  start: new FormControl(new Date(year, month - 1, day)),
  end: new FormControl(new Date(year, month - 1, day  + 3)) })
  this.target = { geoJSON: '', area: 0 };
  this.taskStrategy = '';
   this.clickFrequency = false;
    }
   
  }
  submitBudget () {
    let newTaskParams = {}; 
    let no_of_repeats = 1;
    let noOfMonths = 1;
    let no_of_weeks = 1;
    let startdate = moment(this.target.openWindow).utcOffset(0, true).format();
    let enddate =  moment(this.target.closeWindow).utcOffset(0, true).add(86399, 'seconds').format();
    let time_difference = new Date(enddate).getTime() - new Date(startdate).getTime();
    let days_difference = Math.ceil(time_difference / (1000 * 60 * 60 * 24));
    noOfMonths = Math.ceil(days_difference / 30);
    this.outComeSubmit = true;
    let userTimezone = this.utilsService.getTimezoneFromCountry(this.currentUser.country);

    // if (
    //   this.target?.multiTarget?.length > 1) { 
    //   const message = `Budgeting is only available for a point of interest (POI) or an area of interest (AOI).`;
    //   this.popupService.openPopup(WarningPopup, message, '', '50%');
    //   this.outComeSubmit = false;;
    //   return;
    // }
  
    if (this.target.selectedOption === 1) {
      if (this.target.freqOption === 'Weekly') {
        no_of_repeats = Math.ceil(days_difference / 7);
        this.expectedAge = '7 days, 00:00:00';
      } else if (this.target.freqOption === 'Monthly') {
        no_of_repeats = Math.ceil(days_difference / 30);
        this.expectedAge = '30 days, 00:00:00';
      }
      else if (this.target.freqOption === 'Daily') {
        no_of_repeats = days_difference;
        this.expectedAge = '1 day, 00:00:00';
      }
      else if (this.target.subDailyCount) {
        no_of_weeks = Math.ceil(days_difference / 7);
        no_of_repeats = days_difference * this.target.subDailyCount;
        this.expectedAge = '0 day, 04:00:00';
      }
      if (no_of_repeats === 0) {
        no_of_repeats = 1;
      }
    } else {
      no_of_repeats = 1;
    }
  
    newTaskParams['customerid'] = this.currentUser.id;
    newTaskParams['area'] = this.target.area;
    newTaskParams['project'] = this.target.project;
    newTaskParams['fileName'] = this.target?.fileName;
    if (this.target.geotargets != null) {
      newTaskParams['target'] = this.target.geotargets;
    } else {
      newTaskParams['target'] = JSON.stringify(geoParse(this.target.geoJSON));
    }
    newTaskParams['aoiCountry'] = this.target.country;
    newTaskParams['aoiPlace'] = this.target.place;
    newTaskParams['countryCode'] = this.target.countryCode;
    newTaskParams['frequency'] = this.target.selectedOption;    
    if (this.target.selectedOption === 1) {
      newTaskParams['repeatFrequency'] = this.target.freqOption;
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = this.target.subDailyCount;
    } else {
      newTaskParams['repeatFrequency'] = '';
      newTaskParams['noOfRepeats'] = no_of_repeats;
      newTaskParams['subDailyCount'] = '';
    }
    newTaskParams['mode'] = this.target.mode;
    newTaskParams['expected_age'] = this.expectedAge;
    newTaskParams['circleCordinates'] = this.target.circleCordinates;
  
    newTaskParams['openWindow'] = moment(this.target.openWindow).utcOffset(0, true).format();
    newTaskParams['closeWindow'] = moment(this.target.closeWindow).utcOffset(0, true).format();
    newTaskParams['country_starttime'] = moment(newTaskParams['openWindow'])
    .tz(userTimezone)
    .format();
  
   newTaskParams['country_closetime'] = moment(newTaskParams['closeWindow'])
    .tz(userTimezone)
    .format();
    newTaskParams['resolution'] = this.budgetForm.value.resolution;
    newTaskParams['taskingTier'] = this.budgetForm.value.taskingTier;
    newTaskParams['cloudCover'] = this.budgetForm.value.cloudCover;
    newTaskParams['holdBack'] = this.budgetForm.value.holdBack;
    newTaskParams['sensorType'] = this.budgetForm.value.sensorType;
    newTaskParams['numOfWeeks'] = no_of_weeks;
    newTaskParams['noOfMonths'] = noOfMonths;
    newTaskParams['intent'] = this.budgetForm.value?.intent;
    newTaskParams['sensorCategory'] = this.budgetForm.value?.sensorCategory;
    newTaskParams['openWater'] = this.target?.openWater;
    if (this.budgetForm.value.sensorType.sensor === this.aisType) {
      newTaskParams['noOfRefreshes'] = this.outcomePopUpData?.noOfRefreshes;
      newTaskParams['isHistorical'] = this.outcomePopUpData?.isHistorical;
      newTaskParams['historicalCost'] = this.outcomePopUpData?.historicalCost;
      newTaskParams['noOfHistoricalData'] = this.outcomePopUpData?.noOfHistoricalData;
    }
    if (this.budgetForm.value.sensorType.sensor === this.rfType) {
      newTaskParams['rfSignals'] = this.budgetForm.value?.rfSignals;
      //if (this.isBroRFSelected === false) {
        newTaskParams['rawIQData'] = this.budgetForm.value?.rawIQData;
      //}
    }
    newTaskParams['updateFrequency'] = this.budgetForm.value.updateFrequency.value;
    this.apiService.createBudget(newTaskParams).subscribe((res: any) => {

      newTaskParams['budgetRange'] =  res?.response?.minMaxCost;
      newTaskParams['sensors'] =  res?.response?.sensors;
      newTaskParams['budget'] =  res?.response?.budget;
      newTaskParams['budgetPoints'] =  res?.response?.budgetPoints;

      if (res?.msg === 'Success') { 
        let targetInMap: any[] = [];
       
        if (this.target?.multiTarget.length > 0) {
          targetInMap = this.target?.multiTarget;
        } else {
          targetInMap.push(this.target.geoJSON);
        }
         newTaskParams['targetInMap'] =  targetInMap;
        const dialogRef = this.dialog.open(BudgetpopupComponent, {
          backdropClass: 'blurr', disableClose: true, width: '40%',
          data: { data: res.response,strategy:this.strategyOptions[0], intent:this.budgetForm.value?.intent,purpose:this.purposeOption[0],
            pointUser: this.currentUser.pointsEligible, currentUser: this.currentUser, isBroRF: this.isBroRF(), rfSignals: this.budgetForm.value.sensorType.sensor === this.rfType ? this.budgetForm.value?.rfSignals : null,
            targetInMap: targetInMap,frequency: this.target.selectedOption,repeatFrequency: this.target?.freqOption,
            differenceInDays: days_difference,numberOfRepeats: no_of_repeats, audioSelections: this.audioSelections
          },
        });

        dialogRef.afterClosed().subscribe((result: { action: string, data?: any }) => {
        let pointCount = this.countPoints(this.target.geoJSON);
        this.selectedTasks
        if(pointCount === 1 && this.budgetForm.value.sensorType.sensor === this.rfType){
        const coords = this.utilsService.extractCoordinates(this.pointArray[0]);
        const radius = RF_RADIUS * 1000;
        let coordinates = this.utilsService.getCirclePolygon(coords,radius);
        newTaskParams['target'] = JSON.stringify(geoParse(coordinates));
       }
           if (result.action === 'save') {
            newTaskParams['budgetName'] = result?.data?.budgetName;
            if (this.budgetForm.value.sensorType.sensor === this.rfType && this.isBroRFSelected === false) {
              const sensorsArray = newTaskParams['sensors'];
              const siteDataArray = result?.data?.rfSiteAndCollection?.siteData;
              if (Array.isArray(siteDataArray)) {
              sensorsArray.forEach((sensor: any) => {
              if (sensor.sensor === 'RF' || sensor.sensortype === 'RF') {
              sensor.siteData = siteDataArray;
             }
           });
          }
          newTaskParams['sensors'] = sensorsArray;
            }
            //console.log('newTaskParams',newTaskParams);
            this.apiService.saveBudget(newTaskParams).subscribe((res: any) => {
              if (res?.msg === 'Success') { 
                this.router.navigate(['/budget']);
              } else {
                const dialogRef = this.dialog.open(CountrycheckComponent, {
                  width: '40%', backdropClass: 'blurred', disableClose: true,
                  data: { message: "budgetFail",url:"/budget",response: res?.response}
                });
              }
            }); 
          } else if (result.action === 'save_task') {
            
           newTaskParams['project'] = result?.data?.project;
            newTaskParams['taskname'] = result?.data?.taskname;
            newTaskParams['taskStrategy'] = result?.data?.taskStrategy?.value;
            newTaskParams['sensors'] = this.budgetForm.value.sensorType.sensor === 'RF'  ? this.updateCostsByCount(result?.data?.sensors, pointCount) : result?.data?.sensors;
            newTaskParams['intent'] = result?.data?.intent;
            newTaskParams['purpose'] = result?.data?.purpose;
            newTaskParams['projectid'] = null;
            newTaskParams['feasibilityTask'] =false;
            newTaskParams['observation'] = null;
            newTaskParams['tipAndCueBasedOn'] = "";
            newTaskParams['openWater'] = this.target?.openWater;
            if (this.budgetForm.value.sensorType.sensor === this.rfType && this.isBroRFSelected === false) {
              const sensorsArray = JSON.parse(newTaskParams['sensors'] || '[]');
              const siteDataArray = result?.data?.rfSiteAndCollection?.siteData;
              if (Array.isArray(siteDataArray)) {
              sensorsArray.forEach((sensor: any) => {
              if (sensor.sensor === 'RF' || sensor.sensortype === 'RF') {
              sensor.siteData = siteDataArray;
             }
           });
          }
          newTaskParams['sensors'] = JSON.stringify(sensorsArray);
            }
            //console.log('newTaskParams',newTaskParams);
           delete newTaskParams['cloudCover'];
           //return;
            const submitApi = this.target.multiTarget && this.target?.multiTarget.length > 0 ? this.apiService.multiPoiTaskSubmit(newTaskParams) : this.apiService.newTaskSubmit(newTaskParams);
            submitApi.subscribe((res: any) => {
             if (res?.msg === 'Success') { 
              let data = JSON.parse(res?.response);
              let taskid;
              let sensorList = this.matchUUIDs(newTaskParams['sensors'], data);
              newTaskParams['sensors'] = JSON.stringify(sensorList);
              if (data && data.length > 0) {
                taskid = res?.taskid;
                newTaskParams['taskId'] = taskid;
                this.apiService
                  .genCollection(
                    this.currentUser.id,
                    this.currentUser.email,
                    newTaskParams
                  )
                  .subscribe((res: any) => {
                    const taskid = res?.id;
                  });
              }
              const dialogRef = this.dialog.open(ConfirmDialog, {
                backdropClass: 'blurr', disableClose: true,
                data: { taskid: taskid, taskname:  newTaskParams['taskname'], response: res, type: 'normal',from:'budget' },
              });
               
              } else {
                this.outComeSubmit = false;
                const dialogRef = this.dialog.open(CountrycheckComponent, {
                  width: '40%', backdropClass: 'blurred', disableClose: true,
                  data: { message: "budgetFail",url:"/budget",response: res?.response}
                });
              }
            });
          } else{
            this.outComeSubmit = false;
          }
        });

      } else {
        this.outComeSubmit = false;
        const dialogRef = this.dialog.open(CountrycheckComponent, {
          width: '40%', backdropClass: 'blurred', disableClose: true,
          data: { message: "budgetFail",url:"/budget",response: res?.response}
        });
      }
    }, (error: any) => {
      this.outComeSubmit = false;
      const dialogRef = this.dialog.open(CountrycheckComponent, {
        width: '40%', backdropClass: 'blurred', disableClose: true,
        data: { message: "budgetFail",url:"/budget",response: error}
      });
    }); 
  }

countPoints(wkt: string): number {
  if (!wkt) return 0;
  return (wkt.match(/POINT\s*\(/g) || []).length;
}

updateCostsByCount(jsonString: string, count: number): string {
  if (!jsonString || count <= 0) {
    return jsonString;
  }

  const data = JSON.parse(jsonString);

  const updatedData = data.map((item: any) => {
    const hasSOI = Array.isArray(item?.signalOfInterest);

    return {
      ...item,
      cost: item.cost / count,
      unitCost: item.unitCost / count,
      multiplierCost: item.multiplierCost / count,
      minimumArea: typeof item.minimumArea === 'string'
      ? item.minimumArea.replace(/,/g, '')
      : item.minimumArea,
      isPoint: count >= 1,
      noOfCollections: 1,
      targetPoints: count === 1 ? item.targetPoints : null,
      ...(hasSOI && {
        signalOfInterest: item.signalOfInterest.map((soi: any) => {
          const audioMatch = this.audioSelections?.find(
            (a: any) => a.value === soi.value
          );

          return {
            ...soi,
            collectionDuration: audioMatch?.audioChecked
              ? 60
              : soi.collection_duration?.[0]?.value ?? null,
            isAudio: audioMatch?.audioChecked ?? false
          };
        })
      })
    };
  });

  return JSON.stringify(updatedData);
}

  sortArray(array: string[]): string[] {
    return array.sort((a, b) => {
      return this.getPriority(a) - this.getPriority(b);
    });
  }
  sortResolution(a: { key: string, name: string }, b: { key: string, name: string }): number {
    const isNumeric = (value: string): boolean => !isNaN(parseFloat(value.charAt(0)));
    
    const parseResolution = (res: string): { value: number, text: string } => {
      const match = res.match(/(\d+(\.\d+)?)(.*)/);
      const value = match ? parseFloat(match[1]) : NaN;
      const text = match ? match[3].trim() : res;
      return { value, text };
    };

    const resA = parseResolution(a.name);
    const resB = parseResolution(b.name);

    if (isNumeric(a.name) && isNumeric(b.name)) {
      if (resA.value !== resB.value) {
        return resA.value - resB.value;
      }
      return resA.text.localeCompare(resB.text);
    } else if (isNumeric(a.name)) {
      return -1;
    } else if (isNumeric(b.name)) {
      return 1;
    }
    return a.name.localeCompare(b.name);
}
  
  getPriority(value: string): number {
    if (value.includes('days')) {
      return 1;
    } else if (value.includes('months')) {
      return 2;
    } else {
      return 3;
    }
  }
  setUTCTodayDate() {
    const now = new Date();
    const utcYear = now.getUTCFullYear();
    const utcMonth = now.getUTCMonth();
    const utcDate = now.getUTCDate();
    this.todayDate = new Date(Date.UTC(utcYear, utcMonth, utcDate));    
  }

  convertToPoints(cost:number) : number
  {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
    return  Math.round(cost * conversionFactor);      
  }
  convertToCost(point:number) : number
  {
    const parts = this.currentUser.sensorConversionFactor.split(':');
    const conversionFactor =  parseFloat(parts[1]) / parseFloat(parts[0]);
    return  Math.round(point / conversionFactor);      
  }
  capitalizeFirstLetter(value: string): string {
    if (!value) {
      return '';
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
  }
  updateOptions() {
    this.cloudCoverOptions = this.budgetInputs.cloudCoverKeys || [];
    this.resolutionOptions = this.budgetInputs.resolutionArr || [];
    this.taskingTierOptions = this.budgetInputs.tierArr || [];
    this.holdBackOptions = this.budgetInputs.holdbackArr || [];
    this.rfSignalOptions = this.budgetInputs.rfSignals || [];
    
    this.updateFormControlValidators('cloudCover', this.cloudCoverOptions);

    this.updateFormControlValidators('resolution', this.resolutionOptions);
    this.updateFormControlValidators('taskingTier', this.taskingTierOptions);
    this.updateFormControlValidators('rfSignals', this.rfSignalOptions);
  }
  updateFormControlValidators(controlName: string, options: any[]) {
    const control = this.budgetForm.get(controlName);
    if (!control) return;
    if (options.length > 0) {
      control.setValidators([Validators.required]);
    } else {
      control.clearValidators();
    }

    control.updateValueAndValidity();
  }

  resetDateDefault()
  {
    const today = new Date();
    const day = today.getDate();
    const month = today.getMonth() + 1;
    const year = today.getFullYear();

    this.date = new FormControl(new Date(year, month - 1, day + 1));

    this.range = new FormGroup({
      start: new FormControl(new Date(year, month - 1, day + 1)),
      end: new FormControl(new Date(year, month - 1, day + this.defaultWindow)),
    });
  }

  onStartTimeChange(event:any, date:any)
  {
    let utcEndDate;
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(localTime, 'YYYY-MM-DD HH:mm A', this.userTimezone); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcStartDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('hh:mm A');
    if(this.selectedFrequencyID !== 0) {
      utcEndDate = moment(utcStartDate).add(30, 'days').toDate();
    } else {
      utcEndDate = utcStartDate;
    }
    return { utcTime, utcStartDate, utcEndDate };
  }

  onEndTimeChange(event:any, date:any)
  {
    const localStartDate = moment(date);
    const localTime = `${localStartDate.format('YYYY-MM-DD')} ${event}`;
    const localMoment = moment.tz(localTime, 'YYYY-MM-DD HH:mm A', this.userTimezone); // Convert to the user’s timezone
    const utcMoment = localMoment.utc();
    const utcEndDate = new Date(utcMoment.format('YYYY-MM-DD'));
    const utcTime = utcMoment.format('hh:mm A');
    return { utcTime, utcEndDate };
  }
  updateCurrentLocalTime() {
    this.currentLocalTime = this.utilsService.getCurrentLocalTime(this.currentUser);    
  }

  resetOutcome() {
    this.outComeForm.patchValue({
      sensorType: '',
      resolution: '',
      cloudCover: '',
      latency: '',
      budget: '',
      updateFrequency: '',
      intent: ''
    });
    this.outComesensor = [];
    this.outComeSubmit = false;
  }
  subStrategyChange(event) {
    this.subStrategy = event.value;
    this.formGroup.get('subStrategyRadio').setValue(event.value);
    this.target.taskSubStrategy = event.value;
    let openWater = this.target.openWater ? this.target.openWater : false;
    if (event.value === 'Tip-and-Cue') this.getObservationList(openWater);
  }

  tipAndCueTypeSelectChange(data: any) {
    this.tipAndCueBasedOn = data.value;
    this.target.tipAndCueBasedOn = data.value;
    this.observation = null;
    this.target.observation = null;
    this.rule = null;
    this.target.rule = null;
    this.updateTarget(this.target, '0');
  }
  tippingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      tippingSensorResolution: '',
      tippingCloudCover: ''
    });

    this.tippingSensorResolution = [];
    this.tippingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key ? this.target?.intent.key : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'tipping'
    }
    this.apiService.getTippingCueingSensorDetails(sensorObj).subscribe((res: any) => {
      this.tippingSensorCloudCover.length = 0;
      this.outComesensor = res;
      this.tippingSensorResolution = res.tippingSensorResolution;
      const cloudC: any = [];
      if (res.tippingSensorCloudCover) {
        for (var key in res.tippingSensorCloudCover) {
          cloudC.push({ key, value: res.tippingSensorCloudCover[key] });
        }
        this.tippingSensorCloudCover = cloudC;

        if (this.tippingSensorCloudCover?.length === 0) {
          this.outComeForm.get('tippingCloudCover').disable();
        } else {
          this.outComeForm.get('tippingCloudCover').enable();
        }

        if (!this.tippingSensorResolution) {
          this.outComeForm.get('tippingSensorResolution').disable();
        } else {
          this.outComeForm.get('tippingSensorResolution').enable();
        }
      }
    });
  }
  cueingSensorChange(event: any) {
    let target: any;
    this.outComeForm.patchValue({
      cueingSensorResolution: '',
      cueingCloudCover: ''
    });

    this.cueingSensorResolution = [];
    this.cueingSensorCloudCover = [];

    if (this.target.area > 0) {
      target = 'AOI';
    } else target = 'POI';

    let intent = this.target?.intent?.key ? this.target?.intent.key : this.target?.intent;
    let sensorObj = {
      sensorType: event.value,
      target: target,
      intent: intent,
      type: 'cueing'
    }
    this.apiService.getTippingCueingSensorDetails(sensorObj).subscribe((res: any) => {
      this.cueingSensorCloudCover.length =0;
      this.outComesensor = res;
      this.cueingSensorResolution = res.cueingSensorResolution;
      const cloudC: any = [];
      if (res.cueingSensorCloudCover) {
        for (var key in res.cueingSensorCloudCover) {
          cloudC.push({ key, value: res.cueingSensorCloudCover[key] });
        }
        this.cueingSensorCloudCover = cloudC;

        if (this.cueingSensorCloudCover?.length === 0) {
          this.outComeForm.get('cueingCloudCover').disable();
        } else {
          this.outComeForm.get('cueingCloudCover').enable();
        }

        if (!this.cueingSensorResolution) {
          this.outComeForm.get('cueingSensorResolution').disable();
        } else {
          this.outComeForm.get('cueingSensorResolution').enable();
        }
      }
    });
  }

   resetOutcomeDefined() {
    this.outComeForm.patchValue({
      resolution: '',
      budget: '',
      intent: ''
    });
    this.outComeSubmit = false;
  }

  drawCircles(radiusKm: number) {
    const radius = radiusKm * 1000;
    this.removeCircles();
    for (let i = 0; i < this.pointArray.length; i++) {
      const coords = this.utilsService.extractCoordinates(this.pointArray[i]);

      // Create a circle entity for each point
      this.viewer.entities.add({
        name:'circles',
        position: Cartesian3.fromDegrees(coords.lng, coords.lat),
        ellipse: {
          semiMajorAxis: radius,
          semiMinorAxis: radius,
          material: Color.BLUE.withAlpha(0.5),  // Semi-transparent blue color
          outline: true,
          outlineColor: Color.BLACK,
          outlineWidth: 2,
        },
      });
    }

    if (this.pointArray.length === 1) {
      const coords = this.utilsService.extractCoordinates(this.pointArray[0]);
      let coordinates = this.utilsService.getCirclePolygon(coords,radius);
      this.target.geoJSON = coordinates;
      let area = Math.PI * Math.pow(radiusKm, 2);      
      this.target.area = area.toFixed(2);
      this.target.targetPoints = this.pointArray;
      this.dataService.updateTarget(this.target);
    } else this.target.targetPoints = null;

    this.viewer.flyTo(this.viewer.entities);
    this.checkOverlap(radiusKm);
  }


  checkOverlap(radiusKm: number) {
    const radius = radiusKm * 1000;
    let coords: any = [];  
    this.dataService.clearOverlapData();
    // Extract coordinates
    for (let i = 0; i < this.pointArray.length; i++) {
      const coord = this.utilsService.extractCoordinates(this.pointArray[i]);
      coords.push(coord);
    }
  
    if (coords.length === 2) {
      // Two points, check for overlap and calculate percentage
      const distance = this.computeDistance(coords[0], coords[1]);
      const overlap = distance < (2 * radius);
  
      if (overlap) {
        const overlapPercentage = this.utilsService.calculateOverlapPercentage(distance, radius);
        this.dataService.setOverlapValue(overlapPercentage.toFixed(2), 1)
      }
    } else if (coords.length === 3) {
      // Three points, check for overlaps and handle multiple overlaps
      const distance12 = this.computeDistance(coords[0], coords[1]);
      const distance23 = this.computeDistance(coords[1], coords[2]);
      const distance13 = this.computeDistance(coords[0], coords[2]);
  
      const overlap12 = distance12 < (2 * radius);
      const overlap23 = distance23 < (2 * radius);
      const overlap13 = distance13 < (2 * radius);
  
      const overlapCount = [overlap12, overlap23, overlap13].filter(Boolean).length;
      let overlapPercentage = 0;

      if (overlapCount === 1) {
        // Calculate overlap percentage if only one overlap exists
        if (overlap12) {
          overlapPercentage = this.utilsService.calculateOverlapPercentage(distance12, radius);
        } else if (overlap23) {
          overlapPercentage = this.utilsService.calculateOverlapPercentage(distance23, radius);
        } else if (overlap13) {
          overlapPercentage = this.utilsService.calculateOverlapPercentage(distance13, radius);
        }
      }
      this.dataService.setOverlapValue(overlapPercentage.toFixed(2),overlapCount)
    }
    return false;
  }


  // Calculate the distance between two geographic coordinates
  computeDistance(coords1: { lng: number, lat: number }, coords2: { lng: number, lat: number }): number {    
    const position1 = this.toCartesian3(coords1.lng, coords1.lat);
    const position2 = this.toCartesian3(coords2.lng, coords2.lat);
    return Cartesian3.distance(position1, position2);
  }
  
  // Convert geographic coordinates to Cartesian3
  toCartesian3(lng: number, lat: number): Cartesian3 {
    const cartographic = Cesium.Cartographic.fromDegrees(lng, lat);
    return this.viewer.scene.globe.ellipsoid.cartographicToCartesian(cartographic);
  }

  drawPoi(coordinates) {
    const lng = coordinates[0],
      lat = coordinates[1];

      this.viewer.entities.add({
        name:'circles',
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        billboard: {
          image: 'assets/images/marker-icon.png',
          show: true, // default
          eyeOffset: new Cesium.Cartesian3(0.0, 0.0, 0.0), // default
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, // default
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, // default: CENTER
          alignedAxis: Cesium.Cartesian3.ZERO, // default
          width: 20, // default: undefined
          height: 30, // default: undefined
        },
      });
  }

  drawCircle(coordinates) {
    const radius = RF_RADIUS * 1000;
    const lng = coordinates[0],
      lat = coordinates[1];

      // Create a circle entity for each point
      this.viewer.entities.add({
        name:'circles',
        position: Cesium.Cartesian3.fromDegrees(lng, lat),
        ellipse: {
          semiMajorAxis: radius,
          semiMinorAxis: radius,
          material: Color.BLUE.withAlpha(0.4)
        }});
      }

  updateFrequencyChange(value:any): void {
    const startTime = moment(this.target.openWindow).utcOffset(0, true);
    const endTime = moment(this.target.closeWindow).utcOffset(0, true);
    const clydePeriodDuration = endTime.diff(startTime, 'days', true); 

    if (value.operatorKey === "ClydeSpace") {
        if (clydePeriodDuration < 90) {
            const message = `We are unable to accept this task as this sensor requires TOI should be minimum 3 months. Please change your time of interest or choose an alternative provider.`;
            this.showWarningPopup(message);
            this.outComeForm.patchValue({ updateFrequency: '' });
            this.budgetForm.patchValue({ updateFrequency: '' })
            return; 
        }
    }
    this.outcomePopUpData = {};
    if (["ClydeSpace", "Spire"].includes(value.operatorKey)) {
        this.openOperatorDialog(value.operatorKey);
    }
  }

  private showWarningPopup(message:string): void {
      
      this.popupService.openPopup(WarningPopup, message, '', '50%');
  }

  private openOperatorDialog(operatorKey: string): void {
      const dialog = this.dialog.open(OperatorPopupComponent, {
          minWidth: '50%',
          backdropClass: 'blurred',
          disableClose: true,
          data: { selectedRow: {}, operatorKey, daysCount: '', subscriptionAmount: null, hideTooltip: true },
      });

      dialog.afterClosed().subscribe((result) => {
        if (result != 'close') {
          const historicalCost = result.isHistorical? 25 : 0;
          if(operatorKey === "Spire") {
           this.outcomePopUpData.noOfRefreshes = result?.refreshCount;
           this.outcomePopUpData.isHistorical = result?.isHistorical;
           this.outcomePopUpData.historicalCost = historicalCost;
           this.outcomePopUpData.noOfHistoricalData = result?.fetchCount;
          } else if (operatorKey === "ClydeSpace") {
           this.outcomePopUpData.isHistorical = result?.isHistorical;
           this.outcomePopUpData.noOfHistoricalData = result?.daysCount;
          }
        }
        else {
          this.outComeForm.patchValue({ updateFrequency: '' });
          this.budgetForm.patchValue({ updateFrequency: '' });
        }
      });
  }

  isAnyFieldNull(): boolean {
    const requiredFields = ['tipAndCueBasedOn', 'latency', 'budget', 'tippingSensorType',
      'cueingSensorType', 'tippingSensorResolution', 'cueingSensorResolution', 'tippingCloudCover',
      'cueingCloudCover'
    ];
  
    for (const key of requiredFields) {
        const controlValue = this.outComeForm.get(key).value;
        if (key === 'cueingCloudCover') {
         if (this.cueingSensorCloudCover?.length > 0 && 
          (controlValue === null || controlValue === undefined || controlValue === '')
         ) return true
        } else if (key === 'tippingCloudCover') {
         if (this.tippingSensorCloudCover?.length > 0 && 
          (controlValue === null || controlValue === undefined || controlValue === '')
         ) return true
        } else if (key === 'cueingSensorResolution') {
          if (this.cueingSensorResolution?.length > 0 && 
           (controlValue === null || controlValue === undefined || controlValue === '')
          ) return true
         } else if (key === 'tippingSensorResolution') {
          if (this.tippingSensorResolution?.length > 0 && 
           (controlValue === null || controlValue === undefined || controlValue === '')
          ) return true
         }
        else if (controlValue === null || controlValue === undefined || controlValue === '') {
          return true;
        }
    }
    return false;
  }

 openSensorPreview() {
  this.sharedDataService.setData({ fromNewTask: true });
  this.router.navigate(['/preview']);
 }

  getObservationList(openWater) {
    this.rule = null;
    this.target.rule = null;
    this.observation = null;
    this.target.observation = null;
    this.feeds = null;
    this.target.feeds = null;
    this.apiService.getObservations(openWater).subscribe((res: any) => {
      this.observationOptions = res?.observations;
      this.rulesOptions = res?.ruleBased;
      this.feedList = res?.feeds;
    });
  }

  // Function to close panels
  closePanels() {
    if (this.sensorPanel) this.sensorPanel.close();
    if (this.cloudPanel) this.cloudPanel.close();
  }

  onSensorPanelOpen() {
    this.openPanel();
    if (this.sensorList && this.loadTaskCostDetails() && this.taskStrategy !='Tip-and-Cue') {
      this.sensorList.loadTaskingSensors(this.target);
    }

    if (this.sensorList && this.loadTaskCostDetails() && this.taskStrategy ==='Tip-and-Cue' && this.subStrategy == 'Tip-and-Cue') {      
      this.sensorList.loadTipAndCueingSensors(this.target);
    }
  }

  openPanel() {
    this.formGroup.get('target')?.enable(); // Enable control
    this.formGroup.markAllAsTouched();  // This will make all controls show validation errors if any
  }

  openCloudCover() {
    this.openPanel();
    if (this.budget) {
      this.budgetForm.markAllAsTouched();
    }
    this.cloudclicked = false;
    if (this.loadTaskCostDetails() || !this.budgetForm?.invalid) {
      this.getCloudData(true,0);
    }
  } 

  confirmLocation() {
    setTimeout(() => {
      const dialogRef = this.dialog.open(ConfirmPopupComponent, {
        width: '50%',
        backdropClass: 'blurred',
        disableClose: true,
        data: { message: 'location' }
      });
      dialogRef.afterClosed().subscribe((result) => {        
        if (result === 'no') {
          this.resetMap();
        }
      });
    }, 2000); //2second
  }

  loadUserDetails(userId): void {
    if (userId) {
      this.userService.personalInfo(userId).subscribe({
        next: (res: any) => {
          this.currentUser = res;
          this.currentLocalTime = this.utilsService.getCurrentLocalTime(this.currentUser);
          this.userTimezone = this.utilsService.getTimezoneFromCountry(this.currentUser.country);

          // Plan-4 users: AIS update-frequency options must be filtered by allocations.
          // Clear the list until allocations are fetched to avoid briefly showing unallocated options.
          if (this.currentUser?.user_plan === 4) {
            this.aisAllocationFetched = false;
            this.allocatedAisOperators = new Set();
            this.updateFrequencies = [];
          }
          
          // Check all sensor eligibility in a single call
          this.checkSensorEligibility();
        },
        error: (error) => {
          console.error('Error loading user details:', error);
        }
      });
    }
  } 

  /**
   * Check sensor eligibility for Tip-and-Cue workflow and sensor categories
   * Uses backend-calculated flags from single API call
   */
  async checkSensorEligibility(): Promise<void> {
    try {
      // Show loading indicator if in budget mode
      if (this.budget) {
        this.sensorCategoryCheckLoading = true;
      }

      const userSubs = this.currentUser?.subscriptionType || 'standard';
      
      // Get intent options and find the internalUse intent ID
      const intentOptions = await firstValueFrom(this.apiService.intentOption());
      const internalUseIntent = intentOptions.find((item: any) => item.intent_key === 'internalUse');
      const intent = internalUseIntent?._id || intentOptions[0]?._id;

      // Get all allocated sensors with eligibility flags - single API call
      const sensorResult: any = await firstValueFrom(
        this.userService.getSensors(userSubs, this.currentUser?.id, intent, {})
      );

      // Extract backend-calculated flags from response (maintains backward compatibility)
      // Only check Tip-and-Cue eligibility for user_plan === 4
      if (this.currentUser?.user_plan === 4) {
        this.tipAndCueEligible = sensorResult?.[0]?.isTipAndCueEnabled || false;
        this.tipAndCueEligibilityChecked = true;
      } else {
        // For other plans, default to eligible and mark as checked
        this.tipAndCueEligible = true;
        this.tipAndCueEligibilityChecked = true;
      }

      // Extract sensor category counts for budget mode
      if (this.budget) {
        const imagingCount = sensorResult?.[0]?.imagingSensorCount || 0;
        const nonImagingCount = sensorResult?.[0]?.nonImagingSensorCount || 0;
        
        this.hasImagingSensors = imagingCount > 0;
        this.hasNonImagingSensors = nonImagingCount > 0;

        this.ensureBudgetSensorCategorySelection();
      }

      // Extract operators array from response
      const allOperators = sensorResult?.[0]?.operators || [];

      await this.hydratePlan4AisOperators(allOperators);

      this.refreshAisUpdateFrequencies();
      
      // Store allocated sensor types for filtering outcome sensor types dropdown
      // This ensures Plan 4 users only see their allocated sensor types
      this.allocatedSensorTypes = new Set(
        allOperators
          .map((op: any) => op?.sensortype || op?.sensorType || op?.sensor)
          .filter(Boolean),
      );
    } catch (error) {
      console.error('Error checking sensor eligibility:', error);
      
      // Set defaults on error
      this.hasTippingSensors = false;
      this.hasCueingSensors = false;
      
      // Only set tipAndCueEligible based on user plan
      if (this.currentUser?.user_plan === 4) {
        this.tipAndCueEligible = false;
      } else {
        this.tipAndCueEligible = true;
      }
      this.tipAndCueEligibilityChecked = true;

      if (this.budget) {
        // On error in budget mode, default to enabled to avoid blocking users
        this.hasImagingSensors = true;
        this.hasNonImagingSensors = true;

        this.ensureBudgetSensorCategorySelection();
      }
    } finally {
      if (this.budget) {
        this.sensorCategoryCheckLoading = false;
      }
    }
  }

  private refreshAisUpdateFrequencies(): void {
    const normalizeOperatorKey = (value: any): string =>
      String(value ?? '').replace(/\s+/g, '').toLowerCase();

    const all = this.apiService.updateFrequencies || [];
    const shouldFilterByPlan4 = this.currentUser?.user_plan === 4;
    if (shouldFilterByPlan4) {
      if (!this.aisAllocationFetched) {
        // Allocation not loaded/failed: keep list empty for Plan-4 users.
        // (Filtering requires allocations; without it we can't safely decide which options to show.)
        this.updateFrequencies = [];
        return;
      }

      const allocatedNormalized = new Set(
        Array.from(this.allocatedAisOperators).map(normalizeOperatorKey).filter(Boolean)
      );

      // Plan-4 users should only see frequencies for their allocated AIS operator(s)
      this.updateFrequencies = allocatedNormalized.size
        ? all.filter((f: any) => allocatedNormalized.has(normalizeOperatorKey(f?.operatorKey)) || allocatedNormalized.has(normalizeOperatorKey(f?.operator)))
        : [];
      return;
    }
    // Non-allocated users keep the legacy full list
    this.updateFrequencies = [...all];
  }

  private async hydratePlan4AisOperators(allOperators: any[]): Promise<void> {
    // Plan-4 users: filter AIS update-frequency options based on allocated AIS sensors.
    // Seed AIS operators from the sensors response as a fallback.
    // This helps when allocation API uses display names (e.g., 'Clyde Space')
    // while UI frequency options use compact keys (e.g., 'ClydeSpace').
    if (this.currentUser?.user_plan !== 4) return;

    const normalizeSensorType = (value: any): string => String(value ?? '').trim().toLowerCase();
    const isAisSensorType = (value: any): boolean =>
      normalizeSensorType(value) === normalizeSensorType(this.aisType);

    const aisOperatorsFromSensors = new Set<string>(
      (allOperators || [])
        .filter(
          (op: any) =>
            isAisSensorType(op?.sensortype) ||
            isAisSensorType(op?.sensorType) ||
            isAisSensorType(op?.sensor),
        )
        .map((op: any) => op?.key || op?.operatorKey || op?.operator || op?.name)
        .filter(Boolean)
        .map((v: any) => String(v)),
    );

    this.allocatedAisOperators = aisOperatorsFromSensors;
    // Mark as fetched even if empty (means no AIS allocations)
    this.aisAllocationFetched = true;

    try {
      const allocationRes: any = await firstValueFrom(this.apiService.getAllocation());
      const allocatedSensors = allocationRes?.allocations?.[0]?.sensor || [];
      const aisOperatorsFromAllocation = new Set<string>(
        allocatedSensors
          .filter(
            (s: any) =>
              isAisSensorType(s?.sensor) ||
              isAisSensorType(s?.sensorType) ||
              isAisSensorType(s?.sensortype),
          )
          .map((s: any) => s?.operator)
          .filter(Boolean)
          .map((v: any) => String(v)),
      );

      // Only override if allocation API returns AIS operators.
      // If it returns nothing (schema mismatch / no AIS rows), keep the sensors-based fallback.
      if (aisOperatorsFromAllocation.size > 0) {
        this.allocatedAisOperators = aisOperatorsFromAllocation;
      }
    } catch (allocationError) {
      console.error('Error fetching allocated sensors for AIS frequencies:', allocationError);
      // Keep the sensors-based fallback; do not blank the list.
    }
  }

  private ensureBudgetSensorCategorySelection(): void {
    if (!this.budget) return;

    const sensorCategoryControl = this.budgetForm?.get('sensorCategory');
    if (!sensorCategoryControl) return;

    const currentValue = sensorCategoryControl.value;
    const imagingEnabled = this.hasImagingSensors;
    const nonImagingEnabled = this.hasNonImagingSensors;

    let nextValue: string = currentValue;

    if (currentValue === this.imagingSensor && !imagingEnabled) {
      nextValue = nonImagingEnabled ? this.nonImagingSensor : currentValue;
    } else if (currentValue === this.nonImagingSensor && !nonImagingEnabled) {
      nextValue = imagingEnabled ? this.imagingSensor : currentValue;
    } else if (!currentValue) {
      nextValue = imagingEnabled ? this.imagingSensor : (nonImagingEnabled ? this.nonImagingSensor : this.imagingSensor);
    }

    if (nextValue !== currentValue) {
      sensorCategoryControl.setValue(nextValue, { emitEvent: false });
    }

    this.selectedCategory = sensorCategoryControl.value;
    this.showResolution = (this.selectedCategory !== this.nonImagingSensor);
  }

  categoryChange(event) {
    const nextCategory = event?.value;
    this.selectedCategory = nextCategory;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];

    this.resetForm(nextCategory);
    this.showResolution = (this.selectedCategory !== this.nonImagingSensor);
  }

  outcomeSensorTypes(userId: string) {
    this.apiService.getOutcomeSensorTypes(userId).subscribe((res: any) => {
      if (res) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor =>
          res?.sensorTypes.includes(sensor.value)
        );        
      }
      // Filter by feasibility
       this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true);
      
      // Additionally filter by allocated sensor types (for Plan 4 users)
      // If allocatedSensorTypes is not empty, only show sensor types that are allocated
      if (this.allocatedSensorTypes.size > 0) {
        this.filteredSensorTypes = this.filteredSensorTypes.filter(item => 
          this.allocatedSensorTypes.has(item.value)
        );
      }
    });
  }

  displayUpdateFrequency() {
    return this.updateFrequencyOption && this.budgetForm?.get('sensorType')?.value?.sensor == 'AIS';
  }
  tleSensorTypes(userId: string, intentId?:string) {
    this.apiService.getOutcomeSensorTypes(userId, intentId).subscribe((res: any) => {
       if (res?.sensorTypes?.length > 0) {
        this.SensorsTypes = this.apiService.SENSORSTYPE.filter(sensor =>
          res?.sensorTypes.includes(sensor.value)
        );    
        this.filteredSensorTypes = this.SensorsTypes.filter(item => item.feasibility === true);  
        
        // Additionally filter by allocated sensor types (for Plan 4 users)
        // If allocatedSensorTypes is not empty, only show sensor types that are allocated
        if (this.allocatedSensorTypes.size > 0) {
          this.filteredSensorTypes = this.filteredSensorTypes.filter(item => 
            this.allocatedSensorTypes.has(item.value)
          );
        }
      }else{
         const message = 'No sensors are meeting the selected intent. Please change the intent and try again.';
       const dialogRef = this.popupService.openPopup(CollectionPopupComponent, message, '', '40%');
        dialogRef.afterClosed().subscribe((result) => {
       this.formGroup.get('intent')?.setValue(null);
this.formGroup.get('intent')?.markAsPristine();
this.formGroup.get('intent')?.markAsUntouched();

this.target.intent = null;
    });
    this.filteredSensorTypes = [];  
        
      }
       
    });
  }
 shouldEnableCancelButton(data: any, formData: FormGroup): boolean {
    const isValid = (value: any): boolean => {
        return value !== null && value !== undefined && value !== "";
    };
    
    const requiredDataFields = [
        data.geoJSON,
        data.project,
        data.taskname,
        data.taskStrategy,
        data.purposeOption,
        data.intent,
        data.openWindow,
        data.closeWindow,
    ];
    
    const dataFieldsValid = requiredDataFields.every(field => isValid(field));
    
    // Check if tleSensorForm is valid and has values
    const formValid = formData && formData.valid;
    
    // Check if form controls have non-empty values
    const sensorTypeValid = isValid(formData?.get('sensorType')?.value);
    const resolutionValid = isValid(formData?.get('resolution')?.value);
    const sensorValid = isValid(formData?.get('sensor')?.value);
    
    const formFieldsValid = sensorTypeValid && resolutionValid && sensorValid;
     const additionalConditions = this.mapLoading === false && this.showtleClick === true;
    // All conditions must be true for cancel button to be enabled
    return dataFieldsValid && formValid && formFieldsValid && additionalConditions;
}
 get isTleTrackingEnabled(): boolean {
  const geoValid = !!this.target?.geoJSON;
  const sensorValid = !!this.tleSensorForm?.value?.sensor;
  const isValid = (value: any): boolean => {
    return value !== null && value !== undefined && value !== "";
  };
  
  const startTimeValid = isValid(this.formGroup?.get('startTime')?.value);
  const endTimeValid = isValid(this.formGroup?.get('endTime')?.value);

  return geoValid && sensorValid && startTimeValid && endTimeValid && !this.showtleDisabled;
}

  calculateObservation(data){
    this.target.geoJSONCue = this.utilsService.getGeoJsonData(data);
    if (!this.checkObservationInsideMap()) {
      return false;
    }
    this.setObservationValues(data);
    return true;
  }

  setObservationValues(data) {
    let geoJsonType = this.target.geoJSONCue.includes('POINT') ? 'Point' : 'Polygon';
      this.target.observationTypeCue = geoJsonType;
      if (geoJsonType === 'Point') {
        this.target.areaCue = 0;
      } else {
        const points: [number, number][] = data.split(';').map(item => item.split(',').map(Number) as [number, number]);
        let areaCue = this.utilsService.calculateAreaUsingTurf(points);
        this.target.areaCue = (areaCue/ 1e6).toFixed(2);
      }
  }

  checkObservationInsideMap(): boolean {
    let observationCoordinate = '';
    let mapCoordinate = '';
    if (this.target.geoJSON.includes('POINT'))
      mapCoordinate = geoParse(this.target.geoJSON).coordinates;
    else
      mapCoordinate = geoParse(this.target.geoJSON).coordinates[0];

    if (this.target.geoJSONCue.includes('POINT')) 
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates;
    else
      observationCoordinate = geoParse(this.target.geoJSONCue).coordinates[0];

    if (this.target.geoJSONCue.includes('POINT')) { // observation in POI
      if (this.target.geoJSON.includes('POINT') && this.utilsService.arePointsSame(observationCoordinate, mapCoordinate))    //map is POI
        return true;
      else if (this.utilsService.pointAllInPolygon(observationCoordinate, mapCoordinate))// map is AOI
        return true;
    } else { //observation is AOI
      if (this.target.geoJSON.includes('POINT') && this.utilsService.pointAllInPolygon(mapCoordinate, observationCoordinate)) { //map is POI
        return true;
      } else if (this.utilsService.comparePolygons(observationCoordinate, mapCoordinate)) { //map is AOI
        return true;
      }
    }
    return false;
  }

  resetBelow(controlName: string) {
    if (this.selectedCategory === this.nonImagingSensor) {

      if (this.target.geoJSON?.includes('POINT') && this.target.geoJSON?.match(/POINT/g).length > 0)
        return;
      const startIndex = this.controlOrder.indexOf(controlName);
      if (startIndex === -1) return;

      for (let i = startIndex + 1; i < this.controlOrder.length; i++) {
        const ctrl = this.budgetForm.get(this.controlOrder[i]);
        if (ctrl) {
          ctrl.setValue(null, { emitEvent: false }); // cleaner, safer
        }
      }
    }
  }

keepOpen(event: Event) {
  event.stopPropagation(); // Prevent select from closing
}

onSignalToggle(option: any, event: MatCheckboxChange) {
  if (event.checked) {
    // Add
    if (!this.selectedSignals.includes(option)) {
      this.selectedSignals.push(option);
    }

    if (!this.checkSelection()) {
      // Selection rule failed → revert
      this.selectedSignals = this.selectedSignals.filter(o => o !== option);
      event.source.checked = false;
      return;
    }
  } 
  else {
    // Remove
    this.selectedSignals = this.selectedSignals.filter(o => o !== option);
    this.audioSelections = this.audioSelections.filter(a => a !== option);
  }

  this.updateDisplay(event.checked);
}

  uncheckSignal(option: any, event: MatCheckboxChange) {
    event.source.checked = !event.source.checked;
    this.selectedSignals = this.selectedSignals.filter(o => o !== option);
    this.audioSelections = this.audioSelections.filter(a => a !== option);
  }
 
  onAudioToggle(option: any, event: any) {
    option.audioChecked = event.checked;
    if (event.checked) {
      this.audioSelections.push(option);
    } else {
      this.audioSelections = this.audioSelections.filter(a => a !== option);
    }
    this.updateDisplay(event.checked); // refresh trigger text
  }

  getSelectedDisplay(): string {
    const result = this.selectedSignals
      .map(opt => {
        const hasAudio = this.audioSelections.includes(opt);
        return hasAudio ? `${opt.value} (Audio)` : opt.value;
      })
      .join(', ');
    this.selectedDisplay = result;
    this.cdr.detectChanges();
    return result;
  }
  updateDisplay(isOpen: boolean) {
    this.selectedDisplay = this.getSelectedDisplay();const control = this.budgetForm.get('rfSignals');
    if (control) {
      control.setValue(this.selectedSignals, { emitEvent: false });
      control.markAsTouched();
    }
    this.budgetForm.get('rfSignals')?.setValue(this.selectedSignals);
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }

  showRfSignals(): boolean {
    let showRF = this.selectedCategory === this.nonImagingSensor && this.budgetForm.get('sensorType')?.value?.sensor === this.rfType;
    if (showRF){
      this.generateRFCollections();
    }
    return showRF;
  }

  resetRfSignals() {
    this.selectedDisplay = '';
    this.selectedSignals = [];
    this.budgetForm.patchValue({
      rfSignals: [],
      rawIQData: false
    });
  }

  checkSelection(): boolean {
    let selectedSignals = this.selectedSignals.filter(sensor => {
      return Array.isArray(sensor.collection_duration) && sensor.collection_duration.length > 0;
    });

    // Define categories
    const gps = ['GPS L1', 'GPS L2', 'GPS L5'];
    const vhf = ['VHF'];
    const uhf = ['UHF'];
    const lBand = ['L-band (ADS-B)', 'L-band (GNSS)', 'L-band (SATCOM)'];
    const sBand = ['S-band'];
    // Separate signals into categories
    const selectedGPS = selectedSignals.filter(s => gps.includes(s.value));
    const selectedVHF = selectedSignals.filter(s => vhf.includes(s.value));
    const selectedUHF = selectedSignals.filter(s => uhf.includes(s.value));
    const selectedLBand = selectedSignals.filter(s => lBand.includes(s.value));
    const selectedsBand = selectedSignals.filter(s => sBand.includes(s.value));
    // Rule: Only one GPS signal can be selected at a time
    if (selectedGPS.length > 1) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
      //this.selectedSignals = this.selectedSignals.filter(o => o !== option);
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    if (selectedSignals.length > 1 &&  selectedsBand.length >0) {
      const message = `You can request a maximum of three signals when combining UHF, VHF, and
                  L-Band, charged individually, for the same price in a single task. You can
                  request all the other signals individually.`;
      this.popupService.openPopup(WarningPopup, message, '', '50%');
      return false;
    }
    // Check for invalid combinations
    if (selectedGPS.length > 0) {
        if (selectedSignals.length > selectedGPS.length) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
         // this.selectedSignals = this.selectedSignals.filter(o => o !== option);
          return false;
        }
    } else {
        // Validate non-GPS selections
        if (selectedVHF.length + selectedUHF.length + selectedLBand.length > 3) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
        if (selectedVHF.length > 1 || selectedUHF.length > 1 || selectedLBand.length > 1) {
          const message = `You can request a maximum of three signals when combining UHF, VHF, and
                      L-Band, charged individually, for the same price in a single task. You can
                      request all the other signals individually.`;
          this.popupService.openPopup(WarningPopup, message, '', '50%');
          return false;
        }
    }
    return true;
  }

  generateRFCollections() {
    this.RFCollections = Array.from(
    { length: this.maxRFCollection - this.minRFCollection + 1 },
    (_, i) => this.minRFCollection + i
    );
  }

  isBroRF() {
    this.isBroRFSelected =this.budgetInputs?.rfSignals && this.budgetInputs?.rfSignals?.some(item => item.value.includes('S-band, X-band'));
    return this.isBroRFSelected;
  }

  onOpenedChange(isOpen: boolean) {
    if (isOpen) {
      this.preventMatSelectClose();
    }
  }
  private preventMatSelectClose() {
    if (this.signalSelect && !this.originalClose) {
      // Save the original close method
      this.originalClose = this.signalSelect.close;

      // Override the close method
      this.signalSelect.close = () => {};
    }
  }
  close(mySelect: MatSelect, event: Event): void {
    this.restoreMatSelectClose();
    event.stopPropagation(); // Prevent propagation
    mySelect.close(); // Close the dropdown
  }
  private restoreMatSelectClose() {
    if (this.signalSelect && this.originalClose) {
      this.signalSelect.close = this.originalClose;
      this.originalClose = null;
    }
  }

  resetCategory() {
    this.selectedCategory = this.imagingSensor;
    this.updateFrequencyOption = false;
    this.budgetSensorType = [];
    this.resetForm(this.selectedCategory);
  }

  displayBudgetPopup(event: any) {
    if (this.budgetForm?.value?.sensorType.sensor === 'HSI'){
      if (event.value.key === '5.3m') {
        const message =`
        <ol>
          <li>The task needs to be an area of interest (AOI). Please draw a polygon.</li>
          <li>Each side of the polygon must be at least 5 km.</li>
          <li>The total area of the polygon cannot exceed 400 sqkm. You can find the size of your area at the top of the map after you draw or upload the polygon.</li>
          <li>The start of the time of interest (TOI) must be at least three days after the submission date.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      } else if (event.value.key === '10m'  && this.budgetForm?.value?.sensorType.sensor === 'HSI'){
        const message = `
        <ol>
          <li> The sensor does not have holdback selection options.</li>
          <li> Only period-based collection orders are supported at this time. Recurrent and specific date orders are not available.</li>
        </ol>`;
        this.popupService.openPopup(WarningPopup, message, 'orderedWarning', '50%');
      }
    }
  }

  hasFeature(key: string): boolean {
  return this.currentUser?.planDetails?.features?.some(feature => feature.key === key);
}
}
